var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 32,
    viewBox: "0 0 158 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1061 11.5488C44.4219 10.0364 42.0846 9.28027 39.0599 9.28027C37.2039 9.28027 35.4853 9.55524 33.8698 10.1052C32.9418 10.4145 32.0137 10.8614 31.1201 11.4113C30.0202 12.0987 29.7452 13.5767 30.5014 14.6079L30.6389 14.7797C31.3263 15.7078 32.5981 15.9484 33.5605 15.3641C34.0417 15.0891 34.5572 14.8485 35.1072 14.6423C36.3102 14.1954 37.4788 13.9548 38.6131 13.9548C39.988 13.9548 41.0879 14.2642 41.9128 14.9172C42.7377 15.5359 43.1158 16.5327 43.1158 17.8044C43.1158 18.1138 42.8752 18.32 42.6002 18.32H36.8601C35.829 18.32 34.8666 18.4231 33.9729 18.595C33.0793 18.7668 32.2543 19.0762 31.5325 19.523C30.6732 20.0042 29.9858 20.6917 29.4702 21.5853C28.9547 22.479 28.6797 23.5789 28.6797 24.8506C28.6797 26.2599 29.0234 27.5316 29.7796 28.5971C30.5014 29.697 31.4982 30.522 32.7355 31.1063C33.9729 31.6906 35.4165 31.9999 36.9976 31.9999C38.1319 31.9999 39.163 31.7937 40.1942 31.3469C41.191 30.9 42.0846 30.2126 42.8752 29.2502C43.0127 29.1127 43.1158 28.9409 43.2189 28.769L43.4595 30.6594C43.5282 31.175 43.9751 31.5531 44.4906 31.5531H47.5841C48.1684 31.5531 48.6152 31.0719 48.6152 30.522V17.8044C48.6496 15.1235 47.7903 13.0268 46.1061 11.5488ZM42.4283 25.1256C41.9471 25.8818 41.2941 26.4661 40.4692 26.8786C39.6442 27.291 38.7506 27.5316 37.7882 27.5316C36.6883 27.5316 35.829 27.291 35.1759 26.7754C34.5229 26.2599 34.2135 25.6068 34.2135 24.7819C34.2135 24.4038 34.2823 24.0601 34.4198 23.7507C34.5572 23.4414 34.7978 23.2008 35.0728 22.9602C35.3822 22.6852 35.7946 22.5134 36.2414 22.4446C36.6883 22.3759 37.1695 22.3415 37.6507 22.3415H43.1501V22.5134C43.1501 23.5101 42.9095 24.3694 42.4283 25.1256Z",
    fill: "#66BDE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.08 31.9661C104.949 31.9661 103.059 31.4849 101.409 30.4882C99.759 29.5257 98.4529 28.1509 97.4905 26.4323C96.5281 24.7137 96.0469 22.7545 96.0469 20.5547C96.0469 18.3206 96.5281 16.3614 97.4561 14.6772C98.4185 12.993 99.7246 11.6525 101.374 10.6557C103.059 9.69331 104.949 9.17773 107.08 9.17773C109.177 9.17773 111.067 9.65894 112.717 10.6557C114.367 11.6181 115.673 12.9586 116.635 14.6772C117.598 16.3614 118.045 18.3206 118.045 20.5547C118.045 22.7545 117.564 24.6793 116.635 26.3979C115.673 28.1165 114.401 29.457 112.717 30.4538C111.067 31.4849 109.177 31.9661 107.08 31.9661ZM107.08 27.1197C108.214 27.1197 109.177 26.8448 110.002 26.3292C110.827 25.8136 111.445 25.0574 111.858 24.0607C112.27 23.0983 112.511 21.9296 112.511 20.5547C112.511 19.1799 112.305 17.9769 111.858 17.0145C111.445 16.0521 110.792 15.3303 110.002 14.7803C109.177 14.2647 108.214 13.9898 107.08 13.9898C105.912 13.9898 104.949 14.2647 104.124 14.7803C103.299 15.2959 102.646 16.0521 102.234 17.0145C101.787 17.9769 101.581 19.1455 101.581 20.5547C101.581 21.9296 101.787 23.0983 102.234 24.0607C102.681 25.0231 103.299 25.7792 104.124 26.3292C104.949 26.8791 105.946 27.1197 107.08 27.1197Z",
    fill: "#66BDE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.773 9.65894H56.6913C57.1038 9.65894 57.4475 10.0027 57.4475 10.4151C57.4475 10.8276 57.7912 11.1713 58.2037 11.1713C58.3755 11.1713 58.5474 11.1025 58.6849 10.9994C60.1972 9.79643 62.0533 9.17773 63.9781 9.17773C69.8213 9.17773 72.1242 13.8866 72.1242 18.5268V29.2851C72.1242 30.7288 70.9556 31.9318 69.4776 31.9318H69.3057C67.8621 31.9318 66.6591 30.7631 66.6591 29.3195V19.283C66.6591 16.3614 65.1811 14.2304 62.397 14.2304C59.338 14.2304 57.4131 15.8802 57.4131 19.7642V29.3195C57.4131 30.7631 56.2445 31.9318 54.8009 31.9318H54.629C53.1854 31.9318 51.9824 30.7631 51.9824 29.2851V10.4151C52.0168 10.0027 52.3605 9.65894 52.773 9.65894Z",
    fill: "#66BDE4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5173 0.412109C79.9953 0.412109 81.2327 1.64949 81.2327 3.12747V16.9105C81.2327 17.323 81.5764 17.6667 81.9888 17.6667C82.1951 17.6667 82.4013 17.5636 82.5388 17.4261L88.8976 10.4486C89.3788 9.93305 90.0662 9.62371 90.7536 9.62371C92.9878 9.62371 94.122 12.3047 92.5753 13.9202L88.7944 17.8385C88.5538 18.0791 88.5195 18.4916 88.7257 18.8009L94.8438 27.8407C95.6688 29.0437 95.325 30.6935 94.1564 31.5184C93.7096 31.7934 93.194 31.9653 92.6784 31.9653C91.7848 31.9653 90.9255 31.4841 90.4443 30.7279L85.2198 22.4787C84.9792 22.1006 84.5324 22.0319 84.1543 22.2381C84.0855 22.2725 84.0511 22.3068 84.0168 22.3756L81.4389 25.1941C81.3014 25.3316 81.2327 25.5034 81.2327 25.7096V29.3187C81.2327 30.7623 80.064 31.9653 78.5861 31.9653H78.4142C76.9706 31.9653 75.7676 30.7966 75.7676 29.3187V3.12747C75.8019 1.61512 77.0393 0.412109 78.5173 0.412109Z",
    fill: "#66BDE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.379 27.0849V2.71536C121.379 1.23738 122.616 0 124.094 0C125.572 0 126.81 1.23738 126.81 2.71536V25.5725C126.81 26.6037 127.497 27.0505 128.597 27.0505C128.7 27.0505 128.941 27.0505 129.216 27.0505C130.522 27.0161 131.587 28.0473 131.622 29.3534C131.622 29.3534 131.622 29.3878 131.622 29.4221C131.622 30.6595 130.694 31.6563 129.456 31.7938C128.184 31.8969 126.775 31.9656 125.985 31.9656C123.476 31.9656 121.379 31.0032 121.379 27.0849Z",
    fill: "#66BDE4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.751 7.83633H134.717C134.751 7.80195 134.751 7.80195 134.751 7.83633Z",
    fill: "url(#paint0_linear_7270_1548)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.63 4.74316H140.664C140.63 4.74316 140.561 4.77754 140.492 4.81191L140.63 4.74316Z",
    fill: "url(#paint1_linear_7270_1548)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.332 7.183C136.366 7.183 136.401 7.183 136.435 7.14863H136.401L136.504 7.11426L136.332 7.183Z",
    fill: "url(#paint2_linear_7270_1548)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.574 7.0459C136.505 7.08027 136.539 7.08027 136.471 7.08027L136.574 7.0459H136.608C136.539 7.11464 136.539 7.08027 136.574 7.0459Z",
    fill: "url(#paint3_linear_7270_1548)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M137.157 6.7707H137.123L137.192 6.73633L137.157 6.7707Z",
    fill: "url(#paint4_linear_7270_1548)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M139.082 5.39551L139.014 5.42988L139.082 5.39551Z",
    fill: "url(#paint5_linear_7270_1548)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.327 5.7744C138.258 5.7744 138.292 5.74003 138.258 5.70566C138.258 5.70566 138.292 5.70565 138.292 5.67128C138.292 5.67128 138.395 5.63691 138.361 5.63691C138.395 5.63691 138.395 5.63691 138.43 5.63691C138.361 5.67128 138.533 5.60254 138.43 5.67128C138.43 5.67128 138.498 5.67128 138.533 5.63691C138.533 5.63691 138.464 5.67128 138.498 5.63691C138.533 5.60254 138.567 5.60254 138.567 5.63691C138.602 5.63691 138.67 5.60254 138.705 5.60254C138.567 5.67128 138.464 5.74003 138.327 5.7744Z",
    fill: "url(#paint6_linear_7270_1548)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.6 5.5332C138.6 5.5332 138.566 5.5332 138.531 5.56757C138.531 5.5332 138.566 5.5332 138.6 5.5332Z",
    fill: "url(#paint7_linear_7270_1548)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.844 6.15254L137.947 6.11816C137.947 6.11816 137.912 6.11816 137.912 6.15254C137.878 6.11816 137.844 6.15254 137.844 6.15254Z",
    fill: "url(#paint8_linear_7270_1548)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M136.676 7.04609C136.676 7.04609 136.71 7.04609 136.745 7.01172C136.745 7.01172 136.71 7.01172 136.676 7.04609Z",
    fill: "url(#paint9_linear_7270_1548)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134.511 7.93905H134.477C134.545 7.90468 134.58 7.87031 134.648 7.83594C134.614 7.87031 134.545 7.93905 134.511 7.93905Z",
    fill: "url(#paint10_linear_7270_1548)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M143.036 3.3334C143.001 3.3334 143.001 3.3334 143.036 3.3334C143.036 3.29902 143.036 3.29902 143.036 3.3334Z",
    fill: "url(#paint11_linear_7270_1548)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M139.116 4.39961H139.082C139.116 4.39961 139.151 4.36523 139.185 4.36523C139.185 4.36523 139.151 4.39961 139.116 4.39961Z",
    fill: "url(#paint12_linear_7270_1548)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138.704 4.70801C138.635 4.74238 138.635 4.74238 138.635 4.74238C138.566 4.74238 138.601 4.77675 138.566 4.74238C138.566 4.70801 138.498 4.77675 138.532 4.77675L138.429 4.81112L138.498 4.77675C138.463 4.77675 138.395 4.81112 138.395 4.81112L138.498 4.77675C138.532 4.77675 138.566 4.77675 138.601 4.74238C138.601 4.74238 138.601 4.74238 138.566 4.74238C138.67 4.67364 138.601 4.74238 138.704 4.70801Z",
    fill: "url(#paint13_linear_7270_1548)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M138.739 4.63949H138.773L138.842 4.60512C138.842 4.60512 138.911 4.60512 138.876 4.60512C138.876 4.60512 138.876 4.60512 138.842 4.60512C138.842 4.60512 138.945 4.57075 138.945 4.60512C138.911 4.60512 138.876 4.63949 138.842 4.63949C138.807 4.63949 138.773 4.67386 138.739 4.70823H138.704V4.67386C138.739 4.67386 138.739 4.63949 138.739 4.63949L138.67 4.67386C138.67 4.63949 138.773 4.60512 138.807 4.60512C138.739 4.60512 138.807 4.57075 138.739 4.63949Z",
    fill: "url(#paint14_linear_7270_1548)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M144.306 2.40527H144.341C144.375 2.40527 144.375 2.43965 144.444 2.40527C144.409 2.40527 144.375 2.43965 144.341 2.40527H144.306Z",
    fill: "url(#paint15_linear_7270_1548)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M140.87 3.71191C140.835 3.74629 140.835 3.74629 140.87 3.71191V3.71191Z",
    fill: "url(#paint16_linear_7270_1548)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M138.945 4.53652C139.014 4.50215 139.048 4.50215 139.117 4.46777L139.014 4.53652C138.979 4.57089 139.014 4.57089 139.048 4.53652C139.014 4.57089 138.876 4.60526 138.945 4.53652C138.945 4.53652 138.911 4.57089 138.876 4.57089C138.876 4.57089 138.911 4.53652 138.945 4.53652C138.911 4.53652 138.876 4.53652 138.842 4.57089C138.876 4.53652 138.808 4.57089 138.842 4.53652C138.911 4.50215 139.014 4.46777 139.083 4.46777C139.048 4.46777 139.014 4.50215 138.945 4.53652Z",
    fill: "url(#paint17_linear_7270_1548)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M139.116 4.53711H139.047C139.047 4.57148 139.116 4.53711 139.116 4.53711Z",
    fill: "url(#paint18_linear_7270_1548)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M139.048 4.70859C139.013 4.70859 138.979 4.70859 138.945 4.70859C138.979 4.74296 139.048 4.70859 139.048 4.70859C138.979 4.74296 138.945 4.74296 138.91 4.77733C138.91 4.74296 139.048 4.67421 139.048 4.70859Z",
    fill: "url(#paint19_linear_7270_1548)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.116 4.70801L139.047 4.74238L139.116 4.70801Z",
    fill: "url(#paint20_linear_7270_1548)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M140.869 3.64258C140.869 3.67695 140.938 3.64258 140.938 3.64258C140.869 3.67695 140.904 3.67695 140.869 3.64258Z",
    fill: "url(#paint21_linear_7270_1548)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.756 2.57715L143.688 2.61152L143.756 2.57715Z",
    fill: "url(#paint22_linear_7270_1548)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M144.032 2.47382H143.963H143.997L144.032 2.43945V2.47382Z",
    fill: "url(#paint23_linear_7270_1548)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M145.442 2.02733C145.476 2.02733 145.511 1.99295 145.545 1.99295C145.511 2.02733 145.648 1.99295 145.682 1.99295H145.717C145.717 1.99295 145.717 1.99295 145.682 1.99295H145.786L145.957 1.95858H146.06L146.301 1.92421L146.645 1.85547C146.61 1.85547 146.576 1.88984 146.542 1.88984C146.576 1.88984 146.473 1.88984 146.507 1.92421C146.542 1.92421 146.576 1.92421 146.576 1.92421L146.542 1.95858C146.439 1.99296 146.439 1.95858 146.335 1.95858C146.335 1.95858 146.37 1.95858 146.301 1.99295C146.198 1.99295 146.232 2.02733 146.164 1.99295C146.095 1.99295 146.06 1.99295 145.992 1.99295C145.923 1.99295 145.854 1.99296 145.786 2.02733H145.854C145.82 2.02733 145.786 2.02733 145.751 2.02733C145.751 2.02733 145.751 2.02733 145.786 2.02733H145.614C145.579 2.02733 145.614 2.02733 145.614 1.99295C145.579 1.99295 145.545 1.99296 145.511 2.02733H145.545H145.476C145.407 2.0617 145.545 2.02733 145.579 2.02733C145.511 2.02733 145.476 2.02733 145.373 2.0617C145.373 2.0617 145.407 2.0617 145.442 2.02733C145.579 2.02733 145.511 2.02733 145.442 2.02733C145.476 2.0617 145.476 2.0617 145.442 2.02733Z",
    fill: "url(#paint24_linear_7270_1548)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M147.159 1.75234C147.056 1.75234 146.987 1.75234 146.918 1.75234C147.021 1.75234 146.953 1.78671 147.09 1.75234C146.953 1.75234 146.815 1.78671 146.678 1.78671C146.781 1.75234 146.609 1.78671 146.643 1.75234H146.712H146.746H146.781C146.781 1.75234 146.746 1.75234 146.746 1.78671C146.85 1.78671 146.781 1.78671 146.85 1.75234H146.953L147.331 1.68359C147.399 1.68359 147.296 1.71796 147.331 1.71796C147.296 1.71796 147.159 1.78671 147.159 1.75234Z",
    fill: "url(#paint25_linear_7270_1548)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M147.95 1.68379H147.881V1.64941C147.915 1.64941 147.915 1.64941 147.881 1.68379C147.95 1.68379 147.95 1.64941 147.95 1.68379Z",
    fill: "url(#paint26_linear_7270_1548)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M147.469 1.68359L147.503 1.71796H147.469V1.68359Z",
    fill: "url(#paint27_linear_7270_1548)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M147.606 1.64941L147.537 1.68379C147.537 1.68379 147.571 1.64941 147.606 1.64941Z",
    fill: "url(#paint28_linear_7270_1548)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M138.188 6.633L138.256 6.59863L138.222 6.633H138.188Z",
    fill: "url(#paint29_linear_7270_1548)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M140.457 5.36148C140.422 5.39586 140.525 5.32711 140.457 5.36148V5.36148Z",
    fill: "url(#paint30_linear_7270_1548)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M134.958 8.86719C134.889 8.90156 134.889 8.93593 134.889 8.93593C134.821 8.9703 134.821 8.9703 134.786 8.9703C134.752 8.9703 134.718 9.03905 134.752 9.00467L134.649 9.07342L134.718 9.03905C134.683 9.03905 134.614 9.10779 134.58 9.10779L134.683 9.03905C134.718 9.03905 134.752 9.00468 134.786 8.9703C134.786 8.9703 134.786 8.9703 134.752 8.9703C134.924 8.86719 134.855 8.9703 134.958 8.86719Z",
    fill: "url(#paint31_linear_7270_1548)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M135.027 8.79886H135.096L135.164 8.73012C135.164 8.73012 135.233 8.69575 135.199 8.73012C135.199 8.73012 135.164 8.73012 135.164 8.76449C135.199 8.76449 135.268 8.69575 135.268 8.73012C135.233 8.76449 135.164 8.79886 135.13 8.79886C135.096 8.83324 135.027 8.86761 135.027 8.90198C135.027 8.90198 134.993 8.90198 134.958 8.90198C134.958 8.86761 134.993 8.83324 135.027 8.79886L134.924 8.86761C134.924 8.83324 135.027 8.76449 135.061 8.73012C135.027 8.76449 135.096 8.73012 135.027 8.79886Z",
    fill: "url(#paint32_linear_7270_1548)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M143.035 4.9834L142.76 5.05214C142.76 5.05214 142.863 5.01777 142.794 5.01777C142.829 5.01777 142.863 4.9834 142.897 5.01777C142.966 5.01777 143 4.9834 142.966 4.9834H143.138C143.069 4.9834 143.103 4.9834 143 4.9834C143.035 4.9834 143.035 4.9834 143.035 4.9834Z",
    fill: "url(#paint33_linear_7270_1548)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M142.004 4.94941L142.141 4.91504C142.141 4.91504 142.21 4.91504 142.176 4.91504H142.141C142.21 4.91504 142.176 4.91504 142.279 4.91504C142.245 4.94941 142.176 4.94941 142.141 4.94941H142.107H142.004Z",
    fill: "url(#paint34_linear_7270_1548)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M143.034 4.94922L142.931 4.98359H142.896C142.931 4.94922 143 4.94922 143.034 4.94922Z",
    fill: "url(#paint35_linear_7270_1548)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M143.963 4.87987C143.929 4.87987 143.86 4.91424 143.894 4.91424C143.826 4.91424 143.688 4.98298 143.585 4.98298H143.379H143.207H143.241C143.276 4.94861 143.276 4.94861 143.241 4.94861C143.31 4.94861 143.276 4.94861 143.379 4.94861C143.345 4.94861 143.345 4.94861 143.413 4.91424C143.654 4.87987 143.757 4.87987 143.963 4.87987C144.066 4.84549 144.135 4.81112 144.204 4.77675C144.169 4.77675 144.101 4.77675 144.066 4.77675L144.204 4.74238V4.77675C144.41 4.74238 144.169 4.77675 144.238 4.74238C144.273 4.74238 144.307 4.74238 144.341 4.74238C144.169 4.77675 144.341 4.77675 144.204 4.81112C144.238 4.81112 144.307 4.81112 144.376 4.81112C144.444 4.81112 144.307 4.81112 144.307 4.77675C144.376 4.77675 144.376 4.77675 144.41 4.77675C144.513 4.77675 144.616 4.74238 144.685 4.70801C144.719 4.70801 144.754 4.70801 144.788 4.70801C144.788 4.70801 144.685 4.74238 144.651 4.77675H144.582C144.651 4.77675 144.582 4.77675 144.548 4.77675C144.513 4.77675 144.479 4.77675 144.479 4.77675H144.513C144.479 4.77675 144.41 4.77675 144.341 4.81112C144.273 4.81112 144.204 4.81112 144.135 4.81112H144.169C144.169 4.84549 144.066 4.84549 143.963 4.87987Z",
    fill: "url(#paint36_linear_7270_1548)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M143.757 4.84588C143.757 4.84588 143.688 4.84588 143.791 4.81151C143.791 4.81151 143.791 4.81151 143.757 4.84588C143.86 4.81151 143.894 4.77714 143.963 4.77714C143.997 4.77714 143.894 4.77714 143.929 4.77714C143.997 4.77714 144.169 4.70839 144.169 4.74276C144.204 4.74276 144.238 4.74276 144.272 4.70839C144.376 4.70839 144.616 4.60528 144.616 4.67402C144.582 4.67402 144.513 4.67402 144.479 4.67402V4.70839C144.41 4.70839 144.479 4.70839 144.376 4.70839H144.41C144.307 4.70839 144.204 4.74276 144.101 4.77714C144.101 4.77714 144.032 4.81151 144.066 4.81151C144.032 4.81151 143.963 4.81151 143.929 4.81151C143.86 4.81151 143.791 4.81151 143.757 4.84588Z",
    fill: "url(#paint37_linear_7270_1548)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M138.188 6.73633C138.154 6.73633 138.154 6.7707 138.188 6.73633V6.73633Z",
    fill: "url(#paint38_linear_7270_1548)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M137.604 7.11426C137.604 7.14863 137.604 7.14863 137.604 7.11426C137.57 7.14863 137.57 7.14863 137.604 7.11426Z",
    fill: "url(#paint39_linear_7270_1548)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M135.438 8.48926C135.369 8.52363 135.3 8.59237 135.232 8.62674H135.266C135.335 8.59237 135.369 8.558 135.438 8.48926L135.3 8.59237C135.232 8.66112 135.3 8.62675 135.335 8.59237H135.3C135.3 8.59237 135.129 8.69549 135.266 8.59237C135.266 8.59237 135.163 8.62674 135.163 8.66112C135.197 8.66112 135.197 8.62674 135.232 8.62674C135.232 8.62674 135.197 8.62674 135.163 8.66112C135.094 8.69549 135.197 8.62674 135.163 8.66112C135.232 8.59237 135.335 8.558 135.438 8.48926Z",
    fill: "url(#paint40_linear_7270_1548)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M139.15 6.42733C139.116 6.46171 139.013 6.53045 138.979 6.49608L139.082 6.42733C139.116 6.42733 139.185 6.35859 139.185 6.35859C139.116 6.39296 139.185 6.35859 139.219 6.35859C139.253 6.35859 139.219 6.35859 139.219 6.32422H139.253H139.288L139.219 6.35859H139.253C139.15 6.39296 139.288 6.35859 139.15 6.42733Z",
    fill: "url(#paint41_linear_7270_1548)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M142.725 5.01777L142.793 4.9834C142.828 4.9834 142.725 5.01777 142.725 5.01777Z",
    fill: "url(#paint42_linear_7270_1548)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M142.864 4.9495H142.932H142.967C143.001 4.9495 143.139 4.9495 143.173 4.91513C143.207 4.91513 143.276 4.91513 143.311 4.88076C143.276 4.88076 143.242 4.88076 143.242 4.88076C143.311 4.84639 143.379 4.81202 143.448 4.81202H143.379H143.517C143.551 4.77764 143.448 4.81202 143.414 4.81202C143.517 4.81202 143.62 4.74327 143.689 4.74327C143.689 4.74327 143.689 4.7089 143.792 4.67453C143.723 4.7089 143.826 4.67453 143.792 4.7089C143.826 4.7089 143.895 4.67453 143.895 4.7089C143.964 4.67453 144.032 4.67453 144.101 4.67453C144.239 4.64016 144.307 4.60579 144.445 4.60579C144.445 4.57141 144.514 4.57141 144.548 4.53704C144.582 4.53704 144.685 4.53704 144.685 4.53704C144.582 4.57141 144.617 4.53704 144.582 4.53704C144.548 4.53704 144.582 4.53704 144.514 4.57141C144.617 4.57141 144.685 4.53704 144.789 4.50267C144.892 4.4683 144.892 4.43393 145.029 4.39956H145.098C145.167 4.36518 145.235 4.36518 145.304 4.36518C145.373 4.36518 145.442 4.36518 145.51 4.36518C145.545 4.36518 145.51 4.36518 145.476 4.36518C145.579 4.33081 145.682 4.33081 145.785 4.36518L145.854 4.33081C145.82 4.33081 145.751 4.33081 145.751 4.33081C145.785 4.33081 145.82 4.33081 145.854 4.33081C145.854 4.33081 145.82 4.33081 145.785 4.33081C145.923 4.29644 145.82 4.36518 145.888 4.33081C145.923 4.33081 145.957 4.33081 145.957 4.33081L146.026 4.29644C146.026 4.29644 146.129 4.29644 146.163 4.29644C146.163 4.29644 146.129 4.33081 146.095 4.29644C146.095 4.29644 146.163 4.29644 146.198 4.29644C146.198 4.26207 146.473 4.26207 146.404 4.2277C146.576 4.2277 146.816 4.15895 146.954 4.15895C146.988 4.15895 147.057 4.12458 147.023 4.12458C147.16 4.12458 147.229 4.12458 147.366 4.09021H147.298C147.401 4.09021 147.469 4.05584 147.607 4.02147C147.573 4.02147 147.573 4.02147 147.573 4.02147C147.607 4.02147 147.641 4.02147 147.676 4.02147C147.641 4.02147 147.71 4.02147 147.676 4.02147C147.951 3.95272 148.157 3.9871 148.432 3.91835C148.363 3.91835 148.329 3.91835 148.329 3.91835H148.398C148.432 3.91835 148.501 3.91835 148.535 3.91835C148.707 3.88398 148.776 3.91835 148.947 3.88398H148.741L148.81 3.84961H148.707C148.776 3.84961 148.81 3.84961 148.81 3.84961H148.776C148.81 3.84961 148.844 3.84961 148.879 3.84961C148.741 3.84961 148.569 3.84961 148.432 3.88398C148.398 3.88398 148.329 3.88398 148.294 3.91835C148.26 3.91835 148.329 3.91835 148.363 3.91835C148.363 3.91835 148.363 3.91835 148.329 3.91835C148.329 3.91835 148.123 3.95272 148.088 3.9871C147.916 3.9871 148.123 3.95272 147.951 3.9871L147.882 4.02147C147.779 4.02147 147.641 4.02147 147.538 4.05584H147.573C147.573 4.05584 147.573 4.05584 147.538 4.05584C147.47 4.05584 147.401 4.05584 147.332 4.09021H147.229C147.263 4.05584 147.298 4.02147 147.263 3.9871H147.229C147.126 3.9871 147.057 3.9871 146.988 4.02147H146.954C146.92 4.05584 146.885 4.09021 146.885 4.12458C146.816 4.12458 146.782 4.12458 146.713 4.12458C146.645 4.12458 146.541 4.12458 146.507 4.15895C146.404 4.15895 146.335 4.19333 146.232 4.2277C146.163 4.2277 146.06 4.2277 145.992 4.2277C145.957 4.2277 145.751 4.29644 145.648 4.29644C145.682 4.29644 145.717 4.29644 145.751 4.29644C145.682 4.29644 145.648 4.29644 145.613 4.33081C145.751 4.29644 145.613 4.33081 145.682 4.33081C145.613 4.33081 145.579 4.33081 145.51 4.33081C145.613 4.33081 145.476 4.33081 145.579 4.29644C145.476 4.29644 145.373 4.29644 145.27 4.33081C145.27 4.33081 145.27 4.33081 145.235 4.36518H145.201C145.167 4.36518 145.304 4.36518 145.201 4.36518C145.098 4.36518 144.892 4.43393 144.892 4.39956C144.823 4.43393 145.029 4.39956 144.926 4.43393C144.995 4.43393 145.063 4.39956 145.098 4.43393C145.029 4.43393 145.063 4.43393 145.029 4.4683H144.96C144.823 4.4683 144.651 4.50267 144.514 4.57141C144.41 4.57141 144.273 4.57141 144.135 4.60579C144.17 4.60579 143.998 4.64016 144.101 4.64016C144.067 4.67453 143.998 4.67453 143.964 4.67453C144.032 4.67453 143.998 4.67453 144.032 4.64016C143.998 4.64016 143.929 4.64016 143.895 4.67453C143.826 4.7089 143.86 4.67453 143.792 4.67453C143.723 4.67453 143.689 4.7089 143.62 4.74327H143.551C143.586 4.74327 143.482 4.74327 143.482 4.77764C143.414 4.77764 143.379 4.77764 143.311 4.77764C143.345 4.77764 143.242 4.81202 143.242 4.81202C143.104 4.88076 143.036 4.84639 142.898 4.88076C142.864 4.88076 142.829 4.88076 142.795 4.91513H142.761C142.692 4.91513 142.623 4.91513 142.554 4.91513C142.554 4.91513 142.657 4.88076 142.692 4.88076H142.726C142.761 4.84639 142.829 4.84639 142.829 4.84639C142.726 4.84639 142.589 4.88076 142.486 4.91513C142.589 4.84639 142.692 4.81202 142.829 4.81202L142.761 4.84639H142.829L142.761 4.88076C142.829 4.88076 142.864 4.84639 142.932 4.84639C142.864 4.84639 142.829 4.88076 142.864 4.88076C142.932 4.84639 142.932 4.88076 143.001 4.84639C142.967 4.84639 142.932 4.84639 142.967 4.88076C143.07 4.84639 143.104 4.84639 143.207 4.77764C143.207 4.81202 143.345 4.74327 143.345 4.77764H143.379C143.482 4.74327 143.276 4.77764 143.448 4.7089C143.517 4.7089 143.585 4.67453 143.654 4.67453C143.585 4.67453 143.517 4.67453 143.448 4.67453H143.482C143.414 4.67453 143.345 4.7089 143.276 4.7089C143.379 4.7089 143.242 4.7089 143.173 4.74327C143.242 4.74327 143.242 4.74327 143.345 4.7089C143.173 4.77764 143.173 4.7089 143.036 4.77764C143.104 4.77764 143.001 4.81202 143.001 4.81202C142.967 4.81202 142.898 4.84639 142.864 4.84639L142.898 4.81202C142.795 4.81202 142.795 4.88076 142.657 4.88076C142.657 4.88076 142.761 4.84639 142.726 4.84639C142.623 4.88076 142.52 4.91513 142.417 4.98387C142.417 4.98387 142.417 4.98387 142.348 4.98387C142.348 4.98387 142.348 5.01824 142.382 4.98387C142.348 4.98387 142.279 5.01825 142.245 5.01825C142.348 4.98387 142.211 5.01825 142.176 5.01825C142.142 5.01825 142.176 5.01825 142.211 5.01825C142.176 5.01825 142.142 5.05262 142.108 5.05262C142.108 5.05262 142.211 5.05262 142.279 5.05262H142.245C142.279 5.05262 142.314 5.05262 142.348 5.01825C142.314 5.05262 142.314 5.05262 142.314 5.05262C142.348 5.05262 142.382 5.05262 142.382 5.05262C142.417 5.05262 142.348 5.08699 142.314 5.08699H142.245H142.039C141.97 5.08699 141.936 5.12136 141.867 5.15573C141.798 5.1901 141.729 5.22448 141.764 5.22448L141.661 5.25885C141.798 5.25885 141.661 5.29322 141.695 5.29322H141.626H141.558C141.626 5.25885 141.558 5.29322 141.523 5.29322C141.523 5.29322 141.42 5.32759 141.386 5.36196C141.317 5.39633 141.283 5.39633 141.214 5.4307C141.179 5.4307 141.145 5.4307 141.111 5.4307C141.214 5.39633 141.145 5.39633 141.145 5.39633C141.145 5.39633 141.145 5.39633 141.111 5.39633C141.179 5.36196 141.283 5.36196 141.351 5.32759C141.317 5.32759 141.283 5.32759 141.248 5.36196C141.317 5.36196 141.386 5.32759 141.454 5.29322H141.489L141.592 5.25885C141.558 5.25885 141.592 5.25885 141.489 5.25885C141.489 5.25885 141.592 5.22448 141.626 5.1901H141.661C141.661 5.1901 141.764 5.15573 141.661 5.15573H141.592H141.523L141.558 5.12136L141.454 5.15573H141.489C141.317 5.22447 141.454 5.22447 141.283 5.25885C141.214 5.25885 141.111 5.29322 141.076 5.32759C141.145 5.29322 141.076 5.32759 141.111 5.32759C141.076 5.36196 141.008 5.36196 140.973 5.36196C140.973 5.36196 140.939 5.39633 141.008 5.36196C141.008 5.36196 140.905 5.39633 140.905 5.4307C140.836 5.46508 140.767 5.46508 140.698 5.49945C140.595 5.49945 140.526 5.53382 140.458 5.60256C140.286 5.67131 140.183 5.70568 140.011 5.77442L139.942 5.80879L139.873 5.84316C139.908 5.84316 139.976 5.80879 139.942 5.84316C140.011 5.80879 140.045 5.77442 140.114 5.74005C140.114 5.74005 140.114 5.74005 140.08 5.77442C140.114 5.77442 140.148 5.74005 140.183 5.70568L140.251 5.67131C140.355 5.63693 140.32 5.67131 140.423 5.63694C140.389 5.63694 140.355 5.63694 140.32 5.63694C140.355 5.60256 140.251 5.63694 140.286 5.63694C140.355 5.63694 140.423 5.60256 140.492 5.56819H140.458L140.595 5.49945C140.561 5.53382 140.698 5.46508 140.698 5.49945C140.561 5.56819 140.595 5.53382 140.423 5.63694C140.458 5.63694 140.526 5.60256 140.561 5.60256C140.595 5.60256 140.561 5.60256 140.561 5.63694C140.492 5.63694 140.389 5.67131 140.32 5.70568C140.286 5.70568 140.355 5.67131 140.423 5.63694L140.32 5.67131L140.114 5.77442C140.148 5.77442 140.183 5.77442 140.183 5.77442C140.148 5.77442 140.114 5.80879 140.114 5.80879C140.114 5.80879 140.114 5.77442 140.08 5.80879C139.976 5.84317 139.908 5.91191 139.839 5.94628C139.839 5.91191 139.736 5.94628 139.702 5.94628C139.702 5.94628 139.633 5.98065 139.598 6.01502C139.564 6.01502 139.598 5.98065 139.633 5.94628C139.736 5.91191 139.702 5.94628 139.736 5.94628L139.873 5.87754H139.839C139.908 5.84317 139.976 5.84317 139.976 5.80879C139.942 5.80879 139.873 5.84316 139.839 5.84316L139.873 5.80879C139.77 5.80879 139.839 5.84317 139.736 5.87754C139.77 5.84317 139.736 5.87754 139.667 5.87754C139.702 5.84317 139.839 5.80879 139.805 5.77442C139.736 5.77442 139.633 5.87754 139.564 5.87754C139.495 5.91191 139.461 5.94628 139.358 5.94628C139.323 5.98065 139.255 5.98065 139.22 6.01502L139.152 6.0494C139.186 6.0494 139.22 6.01502 139.289 5.98065C139.323 5.94628 139.392 5.91191 139.461 5.91191C139.392 5.94628 139.255 6.01502 139.22 6.01502L139.186 6.0494H139.152C139.117 6.08377 139.152 6.08377 139.255 6.0494C139.289 6.0494 139.358 6.01502 139.392 6.01502H139.358C139.427 5.98065 139.495 5.94628 139.564 5.94628C139.427 6.01502 139.289 6.08377 139.186 6.15251C139.152 6.15251 139.083 6.15251 139.048 6.11814C138.945 6.15251 138.877 6.22125 138.773 6.25562C138.739 6.25562 138.705 6.29 138.67 6.29C138.636 6.32437 138.705 6.29 138.67 6.29L138.567 6.35874C138.636 6.35874 138.67 6.32437 138.739 6.29H138.705C138.739 6.25562 138.877 6.22125 138.877 6.18688C138.877 6.15251 138.808 6.18688 138.911 6.15251C138.98 6.11814 139.014 6.11814 139.014 6.11814C139.014 6.11814 138.911 6.18688 138.98 6.15251C138.945 6.15251 138.877 6.18688 138.842 6.22125C138.877 6.18688 138.945 6.18688 138.98 6.15251C139.083 6.11814 139.083 6.15251 139.048 6.18688C139.048 6.18688 138.877 6.25562 138.98 6.18688C138.911 6.18688 138.808 6.25562 138.739 6.29L138.636 6.32437H138.67L138.533 6.35874C138.602 6.32437 138.499 6.39311 138.464 6.42748C138.464 6.42748 138.395 6.42748 138.43 6.42748C138.464 6.39311 138.464 6.42748 138.498 6.39311H138.43H138.395C138.292 6.42748 138.464 6.39311 138.327 6.46185V6.59934C138.258 6.63371 138.189 6.70246 138.12 6.73683C138.052 6.7712 138.017 6.80557 137.949 6.83994C137.983 6.83994 138.017 6.83994 137.983 6.87431C138.052 6.83994 138.086 6.80557 138.155 6.7712C138.086 6.7712 138.052 6.80557 138.017 6.83994C138.017 6.80557 138.189 6.7712 138.189 6.73683C138.361 6.63371 138.327 6.70246 138.464 6.59934C138.464 6.59934 138.498 6.59934 138.533 6.59934C138.498 6.63371 138.327 6.70246 138.258 6.73683H138.292C138.258 6.7712 138.189 6.7712 138.155 6.80557C138.052 6.83994 138.12 6.83994 138.086 6.87431L138.017 6.90869L137.949 6.97743C137.914 7.0118 137.914 7.0118 137.845 7.04617L137.949 6.97743C137.88 7.0118 137.914 6.97743 137.845 7.0118C137.914 6.97743 137.811 7.04617 137.811 7.08054H137.777C137.742 7.11492 137.742 7.08054 137.674 7.11492C137.708 7.08054 137.777 7.04617 137.811 7.0118C137.777 7.0118 137.674 7.08054 137.639 7.08054C137.605 7.11492 137.536 7.11492 137.536 7.14929C137.639 7.11492 137.536 7.21803 137.708 7.08054C137.708 7.08054 137.708 7.08054 137.674 7.08054C137.674 7.04617 137.777 7.0118 137.811 7.0118C137.811 7.0118 137.845 7.0118 137.777 7.04617C137.777 7.04617 137.708 7.04617 137.639 7.11492H137.674L137.57 7.18366C137.536 7.21803 137.467 7.2524 137.399 7.28677C137.364 7.28677 137.295 7.32115 137.295 7.35552C137.261 7.35552 137.227 7.38989 137.261 7.35552C137.192 7.38989 137.158 7.42426 137.089 7.45863L137.158 7.38989C137.124 7.42426 137.055 7.42426 136.986 7.45863C136.883 7.56175 136.746 7.63049 136.608 7.66486C136.505 7.7336 136.539 7.76798 136.402 7.80235C136.367 7.80235 136.402 7.76798 136.333 7.83672C136.264 7.87109 136.196 7.93984 136.092 7.97421C136.058 8.00858 135.989 8.04295 135.989 8.04295C136.058 8.00858 136.092 7.97421 136.161 7.93984C136.264 7.87109 136.23 7.90546 136.333 7.83672C136.333 7.83672 136.299 7.87109 136.264 7.90546C136.264 7.90546 136.471 7.80235 136.367 7.87109C136.264 7.93983 136.196 7.90546 136.161 7.97421C136.196 7.93984 136.264 7.93984 136.299 7.90546L136.23 7.97421H136.161C136.058 8.07732 136.024 8.04295 135.921 8.07732C135.989 8.00858 135.886 8.07732 135.921 8.00858C135.852 8.04295 135.783 8.11169 135.818 8.11169C135.955 8.04295 135.852 8.11169 135.989 8.04295C135.989 8.04295 136.058 8.04295 135.989 8.11169C135.886 8.14607 135.989 8.07732 135.921 8.11169C135.886 8.11169 135.886 8.14606 135.818 8.18044C135.783 8.21481 135.749 8.21481 135.714 8.24918C135.714 8.21481 135.68 8.24918 135.646 8.28355C135.68 8.21481 135.749 8.18044 135.818 8.14606C135.818 8.14606 135.818 8.14606 135.886 8.14606L135.818 8.18044H135.852L135.921 8.14606C135.818 8.18044 135.852 8.14606 135.818 8.18044C135.749 8.24918 135.749 8.21481 135.714 8.24918C135.714 8.24918 135.611 8.3523 135.508 8.42104L135.543 8.38667C135.611 8.35229 135.508 8.42104 135.508 8.42104H135.474C135.405 8.45541 135.405 8.42104 135.336 8.48978C135.336 8.48978 135.405 8.48978 135.371 8.48978C135.336 8.52415 135.302 8.5929 135.268 8.5929C135.268 8.5929 135.233 8.5929 135.199 8.62727L135.164 8.66164C135.233 8.66164 135.268 8.5929 135.302 8.55852C135.336 8.52415 135.371 8.52415 135.405 8.48978C135.371 8.52415 135.336 8.55852 135.302 8.55852C135.302 8.55852 135.336 8.55852 135.371 8.55852C135.439 8.48978 135.474 8.48978 135.577 8.45541C135.68 8.42104 135.714 8.35229 135.783 8.31792H135.749L136.024 8.18044C136.024 8.18044 136.058 8.18044 136.058 8.14606L136.196 8.07732L136.161 8.11169C136.161 8.11169 136.058 8.18044 136.058 8.14606C136.024 8.18044 135.955 8.21481 135.921 8.24918C135.955 8.21481 135.886 8.24918 135.852 8.24918C135.852 8.24918 135.783 8.28355 135.783 8.31792L135.818 8.28355C135.886 8.24918 135.714 8.35229 135.818 8.31792C135.714 8.35229 135.611 8.45541 135.508 8.48978L135.543 8.45541C135.508 8.48978 135.439 8.52415 135.405 8.55852C135.439 8.55852 135.474 8.52415 135.508 8.48978L135.405 8.55852L135.268 8.62727L135.302 8.5929C135.233 8.62727 135.164 8.69601 135.096 8.73038C135.164 8.73038 135.199 8.66164 135.302 8.62727C135.371 8.5929 135.302 8.66164 135.336 8.62727C135.336 8.62727 135.302 8.66164 135.268 8.66164C135.336 8.66164 135.439 8.55852 135.508 8.52415C135.543 8.48978 135.611 8.45541 135.68 8.42104C135.68 8.42104 135.646 8.45541 135.611 8.45541C135.646 8.45541 135.68 8.45541 135.68 8.42104C135.646 8.45541 135.68 8.42104 135.646 8.45541C135.68 8.45541 135.714 8.42104 135.749 8.38667H135.714C135.749 8.38667 135.749 8.31792 135.818 8.28355C135.749 8.3523 135.852 8.28355 135.886 8.28355C135.921 8.28355 135.921 8.28355 135.955 8.24918C135.921 8.24918 135.886 8.28355 135.886 8.28355C135.921 8.28355 135.921 8.24918 135.955 8.24918H135.921L136.333 8.31792C136.367 8.31792 136.402 8.31792 136.436 8.31792C136.471 8.28355 136.505 8.28355 136.539 8.24918C136.574 8.21481 136.642 8.18044 136.711 8.14606C136.746 8.11169 136.436 8.24918 136.677 8.11169C136.78 8.04295 136.746 8.11169 136.814 8.07732C136.849 8.04295 136.849 8.07732 136.917 8.04295C136.917 8.04295 136.883 8.07732 136.849 8.07732L136.952 8.00858C136.883 8.00858 137.021 7.93984 136.986 7.97421C137.055 7.90546 137.124 7.87109 137.192 7.87109C137.227 7.80235 137.295 7.80235 137.364 7.76798C137.364 7.76798 137.33 7.76798 137.295 7.80235C137.227 7.80235 137.399 7.73361 137.295 7.76798C137.295 7.76798 137.227 7.80235 137.227 7.76798L137.295 7.69923H137.261L137.364 7.59612C137.467 7.493 137.639 7.42426 137.742 7.35552C137.777 7.35552 138.052 7.21803 138.155 7.18366C138.12 7.18366 138.086 7.18366 138.12 7.18366C138.086 7.18366 138.017 7.21803 138.017 7.21803C138.017 7.21803 137.949 7.2524 138.017 7.2524C137.88 7.32115 138.017 7.21803 137.983 7.2524C138.086 7.18366 138.189 7.14929 138.327 7.11492L138.395 7.08054C138.327 7.11492 138.361 7.14929 138.43 7.08054C138.499 7.04617 138.533 7.0118 138.636 6.97743H138.67C138.739 6.94306 138.705 6.90869 138.739 6.87431C138.808 6.83994 138.911 6.80557 138.98 6.7712C139.014 6.73683 139.152 6.66808 139.083 6.70246C139.186 6.66808 139.186 6.73683 139.323 6.59934H139.289C139.358 6.56497 139.461 6.49623 139.53 6.49623C139.598 6.46185 139.667 6.42748 139.736 6.39311C139.667 6.39311 139.908 6.25563 139.942 6.22125H140.011C140.011 6.22125 140.045 6.18688 140.08 6.18688C140.011 6.22125 140.148 6.18688 140.011 6.25562C140.114 6.25562 140.217 6.22125 140.286 6.18688L140.183 6.25562C140.183 6.25562 140.148 6.25562 140.114 6.25562C140.32 6.15251 140.08 6.25562 140.251 6.15251C140.286 6.15251 140.251 6.15251 140.32 6.15251C140.286 6.15251 140.286 6.15251 140.32 6.15251H140.355C140.423 6.08377 140.251 6.18688 140.286 6.15251C140.217 6.18688 140.08 6.22125 140.08 6.18688C140.183 6.11814 140.183 6.18688 140.32 6.08377C140.355 6.08377 140.389 6.08377 140.423 6.08377C140.423 6.08377 140.423 6.08377 140.458 6.0494C140.561 6.0494 140.595 6.01502 140.664 6.01502C140.458 6.08377 140.526 6.11814 140.32 6.15251C140.355 6.15251 140.492 6.08377 140.526 6.11814C140.595 6.11814 140.664 6.08377 140.733 6.0494H140.698C140.801 6.01502 140.87 5.94628 140.973 5.94628H140.939C140.973 5.94628 141.042 5.91191 141.076 5.87754H141.145H141.214C141.214 5.87754 141.283 5.84316 141.248 5.84316C141.317 5.80879 141.351 5.80879 141.454 5.77442C141.558 5.74005 141.386 5.77442 141.351 5.77442C141.454 5.74005 141.558 5.67131 141.695 5.67131C141.661 5.67131 141.661 5.67131 141.661 5.70568C141.695 5.70568 141.729 5.67131 141.729 5.67131H141.764C141.798 5.63693 141.798 5.63693 141.764 5.67131C141.798 5.67131 141.867 5.63693 141.901 5.60256C141.833 5.60256 141.729 5.67131 141.695 5.67131C141.867 5.63693 141.833 5.56819 142.039 5.53382C142.142 5.49945 142.073 5.53382 142.108 5.53382C142.039 5.53382 142.004 5.56819 141.97 5.60256C141.97 5.60256 142.004 5.60256 142.039 5.56819C142.039 5.56819 142.108 5.49945 142.142 5.49945C142.073 5.53382 142.108 5.53382 142.108 5.56819C142.211 5.56819 142.211 5.53382 142.279 5.49945C142.348 5.46508 142.314 5.49945 142.382 5.49945C142.348 5.49945 142.348 5.49945 142.279 5.49945C142.245 5.49945 142.176 5.53382 142.142 5.53382L142.211 5.49945C142.108 5.53382 142.142 5.49945 142.142 5.49945C142.279 5.4307 142.245 5.49945 142.348 5.46508C142.245 5.49945 142.382 5.46508 142.348 5.46508C142.417 5.46508 142.348 5.46508 142.451 5.46508C142.486 5.46508 142.52 5.4307 142.554 5.4307C142.589 5.4307 142.52 5.49945 142.657 5.4307H142.692C142.864 5.36196 142.932 5.36196 143.07 5.32759C143.173 5.29322 143.345 5.25885 143.414 5.22448C143.448 5.22448 143.517 5.1901 143.517 5.1901C143.517 5.1901 143.551 5.1901 143.586 5.1901H143.551C143.551 5.1901 143.551 5.1901 143.586 5.1901C143.551 5.1901 143.62 5.15573 143.482 5.1901C143.448 5.22448 143.586 5.1901 143.551 5.1901C143.517 5.1901 143.517 5.1901 143.517 5.1901C143.482 5.1901 143.482 5.1901 143.482 5.22448C143.482 5.22448 143.414 5.25885 143.379 5.22448C143.276 5.25885 143.379 5.22447 143.311 5.25885H143.276L142.864 5.22448C142.726 5.25885 142.864 5.15573 142.692 5.22448C142.726 5.22448 142.657 5.25885 142.589 5.29322C142.657 5.29322 142.726 5.25885 142.795 5.25885C142.692 5.29322 142.898 5.22447 142.864 5.25885C142.795 5.25885 142.761 5.25885 142.692 5.29322C142.623 5.29322 142.554 5.32759 142.486 5.32759C142.451 5.32759 142.451 5.32759 142.451 5.32759C142.417 5.32759 142.382 5.32759 142.382 5.32759L142.211 5.22448C142.348 5.1901 142.554 5.12136 142.726 5.05262C142.761 5.01825 142.589 5.05262 142.623 5.05262H142.589H142.554C142.554 5.05262 142.726 5.01825 142.657 5.05262C142.52 5.08699 142.451 5.12136 142.314 5.15573C142.348 5.12136 142.486 5.08699 142.589 5.05262C142.554 5.05262 142.52 5.05262 142.486 5.08699C142.589 5.05262 142.657 5.01824 142.761 4.98387H142.795L142.692 5.01825C142.795 4.98387 142.864 4.98387 142.864 5.01825H142.898L142.864 4.9495ZM142.486 5.22448H142.554C142.52 5.22448 142.52 5.22448 142.486 5.22448ZM141.867 5.08699H141.833C141.833 5.08699 141.833 5.08699 141.867 5.08699ZM137.88 7.11492C137.845 7.14929 137.777 7.18366 137.742 7.21803H137.777V7.18366L137.845 7.14929C137.811 7.18366 137.777 7.21803 137.742 7.21803C137.742 7.21803 137.605 7.2524 137.57 7.28677L137.674 7.21803C137.639 7.21803 137.536 7.32114 137.467 7.32114C137.467 7.32114 137.536 7.2524 137.57 7.2524C137.57 7.2524 137.467 7.28677 137.536 7.2524C137.433 7.28677 137.364 7.35552 137.295 7.38989C137.261 7.42426 137.227 7.38989 137.192 7.45863C137.295 7.42426 137.192 7.493 137.261 7.45863C137.261 7.45863 137.261 7.45863 137.192 7.52738C137.124 7.52738 137.124 7.59612 137.089 7.59612C137.055 7.63049 137.124 7.59612 137.089 7.63049C136.986 7.66486 136.986 7.66486 136.986 7.63049C137.055 7.59612 137.089 7.59612 137.158 7.56175L137.021 7.59612L137.055 7.56175C137.021 7.56175 137.021 7.56175 136.986 7.59612H136.952C136.986 7.56175 137.055 7.52737 137.089 7.493C137.124 7.493 137.158 7.45863 137.192 7.45863C137.261 7.42426 137.33 7.38989 137.33 7.38989H137.295C137.364 7.35552 137.399 7.35552 137.467 7.28677C137.57 7.2524 137.674 7.18366 137.742 7.18366C137.811 7.18366 137.811 7.14929 137.88 7.11492ZM139.667 6.18688C139.564 6.25562 139.461 6.25562 139.323 6.35874C139.358 6.35874 139.427 6.32437 139.495 6.32437L139.427 6.35874C139.461 6.35874 139.392 6.39311 139.323 6.42748H139.392C139.427 6.39311 139.461 6.39311 139.495 6.35874C139.53 6.32437 139.598 6.29 139.667 6.25562C139.667 6.25562 139.53 6.32437 139.598 6.32437C139.564 6.32437 139.495 6.35874 139.495 6.39311C139.564 6.39311 139.53 6.39311 139.564 6.39311L139.461 6.42748C139.461 6.42748 139.598 6.35874 139.53 6.42748C139.495 6.42748 139.392 6.49623 139.392 6.49623C139.323 6.5306 139.358 6.49623 139.289 6.5306C139.289 6.5306 139.289 6.5306 139.323 6.49623C139.358 6.49623 139.392 6.49623 139.427 6.46185C139.427 6.42748 139.358 6.49623 139.392 6.46185C139.392 6.42748 139.53 6.39311 139.495 6.39311L139.427 6.42748H139.358C139.323 6.42748 139.289 6.49623 139.22 6.49623C139.186 6.49623 139.22 6.46185 139.152 6.49623C139.048 6.56497 138.98 6.59934 138.877 6.66808H138.808C138.808 6.66808 138.911 6.59934 138.877 6.63371L138.773 6.66808C138.739 6.66808 138.705 6.70246 138.67 6.70246C138.705 6.70246 138.773 6.66808 138.773 6.70246C138.739 6.70246 138.705 6.73683 138.705 6.73683C138.67 6.7712 138.636 6.7712 138.602 6.7712C138.499 6.80557 138.67 6.70246 138.636 6.70246L138.533 6.7712L138.43 6.80557H138.395C138.43 6.80557 138.43 6.80557 138.43 6.80557C138.361 6.83994 138.43 6.80557 138.361 6.87431C138.361 6.87431 138.258 6.90869 138.189 6.94306C138.189 6.97743 138.155 6.97743 138.224 6.94306C138.224 6.94306 138.155 7.0118 138.12 7.0118L138.052 7.04617C138.052 7.04617 138.052 7.04617 138.017 7.04617C138.12 6.97743 138.189 6.94306 138.292 6.87431C138.395 6.80557 138.498 6.7712 138.533 6.73683C138.533 6.73683 138.533 6.73683 138.533 6.70246L138.602 6.66808L138.739 6.59934L138.911 6.56497C138.911 6.56497 138.911 6.56497 138.945 6.56497H138.98C139.014 6.56497 139.014 6.5306 139.048 6.49623L138.945 6.56497C138.945 6.56497 138.945 6.56497 138.98 6.49623C138.945 6.49623 138.945 6.49623 138.98 6.49623C138.98 6.49623 139.048 6.46185 139.048 6.49623C139.117 6.46185 139.152 6.42748 139.255 6.39311C139.323 6.35874 139.427 6.29 139.495 6.29C139.358 6.32437 139.598 6.22125 139.461 6.29C139.564 6.22125 139.564 6.29 139.667 6.22125L139.598 6.25562C139.77 6.15251 139.908 6.15251 140.045 6.08377L140.148 6.0494C139.908 6.01502 139.873 6.08377 139.667 6.18688ZM141.386 5.46508C141.317 5.46508 141.145 5.49945 141.145 5.46508C141.145 5.43071 141.179 5.46508 141.248 5.4307L141.592 5.29322C141.386 5.39633 141.283 5.49945 141.592 5.36196H141.626C141.523 5.43071 141.42 5.43071 141.386 5.46508ZM141.145 5.53382C141.111 5.53382 141.111 5.53382 141.145 5.53382C141.076 5.56819 141.111 5.56819 141.076 5.53382H141.145ZM141.076 5.60256C140.973 5.63693 140.939 5.67131 140.836 5.70568L140.87 5.67131C140.767 5.70568 140.801 5.74005 140.664 5.77442C140.595 5.77442 140.458 5.84316 140.458 5.84316C140.458 5.84316 140.389 5.91191 140.355 5.91191C140.32 5.91191 140.148 5.98065 140.183 5.94628C140.217 5.94628 140.286 5.91191 140.286 5.87754L140.217 5.91191L140.251 5.87754C140.217 5.87754 140.217 5.87754 140.251 5.87754L140.355 5.84316L140.458 5.80879C140.389 5.84317 140.355 5.87754 140.458 5.84316C140.492 5.80879 140.63 5.74005 140.595 5.77442C140.492 5.80879 140.595 5.80879 140.492 5.84316C140.526 5.84316 140.595 5.80879 140.63 5.80879C140.595 5.80879 140.63 5.77442 140.698 5.74005C140.733 5.74005 140.801 5.70568 140.836 5.67131C140.836 5.67131 140.87 5.67131 140.801 5.70568C140.836 5.70568 140.87 5.67131 140.905 5.67131C140.905 5.67131 140.836 5.67131 140.87 5.67131C140.905 5.67131 140.939 5.63693 140.939 5.60256H140.973H141.042C140.973 5.60256 141.008 5.60256 141.008 5.63694C140.973 5.63694 141.008 5.63693 141.076 5.60256L141.008 5.63694C141.042 5.63694 141.111 5.56819 141.076 5.60256ZM141.901 5.32759C141.936 5.32759 141.833 5.36196 141.798 5.36196C141.764 5.36196 141.695 5.39633 141.661 5.36196C141.661 5.32759 141.661 5.36196 141.695 5.36196L141.764 5.32759C141.729 5.32759 141.729 5.32759 141.729 5.36196C141.833 5.29322 141.833 5.32759 141.901 5.32759ZM147.091 3.91835C147.091 3.95272 147.091 3.95272 147.091 3.91835V3.91835ZM146.851 3.9871C146.851 3.9871 146.851 3.9871 146.92 3.9871H146.782C146.782 3.9871 146.782 3.9871 146.851 3.9871Z",
    fill: "url(#paint43_linear_7270_1548)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M135.473 8.55859C135.439 8.55859 135.404 8.59297 135.404 8.59297C135.404 8.62734 135.473 8.55859 135.473 8.55859Z",
    fill: "url(#paint44_linear_7270_1548)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M135.473 8.59277C135.439 8.62715 135.439 8.62714 135.404 8.62714L135.473 8.59277Z",
    fill: "url(#paint45_linear_7270_1548)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M135.439 8.73013C135.405 8.73013 135.371 8.7645 135.336 8.79887C135.336 8.83324 135.439 8.7645 135.439 8.73013C135.405 8.79887 135.336 8.83324 135.268 8.83324C135.268 8.83324 135.439 8.69575 135.439 8.73013Z",
    fill: "url(#paint46_linear_7270_1548)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M135.473 8.76484L135.507 8.73047L135.473 8.76484Z",
    fill: "url(#paint47_linear_7270_1548)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M136.401 7.80176C136.401 7.80176 136.366 7.83613 136.332 7.83613C136.366 7.80176 136.366 7.80176 136.401 7.80176Z",
    fill: "url(#paint48_linear_7270_1548)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M137.673 7.08008C137.57 7.14882 137.502 7.14882 137.398 7.21756C137.536 7.11445 137.605 7.14882 137.673 7.08008Z",
    fill: "url(#paint49_linear_7270_1548)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M137.604 7.04606C137.604 7.08043 137.707 7.01168 137.707 7.04606C137.604 7.08043 137.638 7.04606 137.604 7.04606Z",
    fill: "url(#paint50_linear_7270_1548)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M138.086 6.7707L138.12 6.73633L138.086 6.7707Z",
    fill: "url(#paint51_linear_7270_1548)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M137.362 7.5959L137.328 7.63027L137.397 7.56152L137.362 7.5959Z",
    fill: "url(#paint52_linear_7270_1548)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M137.741 7.2516H137.707C137.707 7.2516 137.741 7.21723 137.741 7.2516Z",
    fill: "url(#paint53_linear_7270_1548)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M138.463 6.56445L138.395 6.59882L138.463 6.56445Z",
    fill: "url(#paint54_linear_7270_1548)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M138.12 7.11502C138.085 7.11502 138.085 7.1494 138.12 7.11502C138.085 7.1494 138.188 7.04628 138.12 7.11502Z",
    fill: "url(#paint55_linear_7270_1548)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M138.602 6.70234C138.602 6.70234 138.636 6.66797 138.67 6.66797C138.636 6.70234 138.602 6.70234 138.602 6.70234Z",
    fill: "url(#paint56_linear_7270_1548)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M138.909 6.5641C138.875 6.5641 138.875 6.5641 138.875 6.5641C138.909 6.5641 138.944 6.52973 138.909 6.5641Z",
    fill: "url(#paint57_linear_7270_1548)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M139.804 5.84277C139.735 5.87715 139.701 5.91152 139.701 5.91152C139.632 5.94589 139.632 5.91152 139.598 5.94589C139.701 5.91152 139.701 5.87715 139.804 5.84277Z",
    fill: "url(#paint58_linear_7270_1548)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M139.873 5.80879C139.873 5.80879 139.942 5.77441 139.907 5.77441C139.907 5.77441 139.907 5.77441 139.873 5.80879Z",
    fill: "url(#paint59_linear_7270_1548)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M139.702 6.11816C139.667 6.11816 139.667 6.15254 139.633 6.15254C139.667 6.15254 139.702 6.11816 139.702 6.11816Z",
    fill: "url(#paint60_linear_7270_1548)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M140.182 5.70508C140.114 5.73945 140.148 5.73945 140.182 5.70508V5.70508Z",
    fill: "url(#paint61_linear_7270_1548)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M139.873 6.04883H139.839L139.805 6.0832L139.873 6.04883Z",
    fill: "url(#paint62_linear_7270_1548)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M139.735 6.28945C139.666 6.28945 139.803 6.2207 139.735 6.28945C139.838 6.18633 139.7 6.28945 139.803 6.2207C139.769 6.25507 139.735 6.28945 139.735 6.28945Z",
    fill: "url(#paint63_linear_7270_1548)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M140.113 6.0832L140.01 6.11757C140.044 6.11757 140.113 6.0832 140.113 6.0832C140.182 6.04883 140.216 6.04883 140.216 6.04883C140.216 6.0832 140.147 6.11757 140.113 6.0832Z",
    fill: "url(#paint64_linear_7270_1548)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M140.457 5.84277C140.422 5.84277 140.388 5.87715 140.354 5.87715C140.388 5.84277 140.457 5.84277 140.457 5.84277Z",
    fill: "url(#paint65_linear_7270_1548)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M141.316 5.60175L141.419 5.56738C141.351 5.60175 141.351 5.60175 141.316 5.60175H141.385C141.316 5.63613 141.282 5.63613 141.316 5.60175Z",
    fill: "url(#paint66_linear_7270_1548)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M143.446 4.53632C143.481 4.53632 143.412 4.53632 143.412 4.53632L143.55 4.50195L143.446 4.53632Z",
    fill: "url(#paint67_linear_7270_1548)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M143.62 4.46777C143.551 4.50215 143.585 4.50215 143.62 4.46777V4.46777Z",
    fill: "url(#paint68_linear_7270_1548)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M143.654 4.81152L143.619 4.8459L143.654 4.81152Z",
    fill: "url(#paint69_linear_7270_1548)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M143.998 4.70801C143.963 4.70801 143.929 4.74238 143.895 4.74238C143.929 4.70801 143.929 4.70801 143.998 4.70801Z",
    fill: "url(#paint70_linear_7270_1548)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M143.963 4.8459H143.895L143.963 4.81152V4.8459Z",
    fill: "url(#paint71_linear_7270_1548)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M146.266 3.98696C146.163 3.98696 145.991 4.0557 145.991 4.02133C145.888 4.02133 145.785 4.02133 145.682 4.09007C145.785 4.09007 145.75 4.09007 145.888 4.09007C145.682 4.12444 145.544 4.15881 145.338 4.19319C145.476 4.15881 145.235 4.19319 145.304 4.15881H145.372H145.476C145.441 4.15881 145.441 4.15881 145.441 4.19319C145.579 4.15881 145.476 4.19319 145.579 4.12444L145.716 4.09007C145.682 4.09007 145.716 4.09007 145.75 4.09007L145.991 4.0557C146.129 3.98695 146.266 3.95258 146.266 3.98696C146.335 3.95258 146.163 3.98696 146.266 3.98696Z",
    fill: "url(#paint72_linear_7270_1548)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M146.576 3.91797L146.473 3.95234C146.473 3.91797 146.473 3.91797 146.576 3.91797Z",
    fill: "url(#paint73_linear_7270_1548)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M144.959 4.64003C144.959 4.64003 144.925 4.64003 144.856 4.64003C144.822 4.64003 144.822 4.64003 144.822 4.64003C144.787 4.64003 144.753 4.64003 144.719 4.64003C144.822 4.60566 144.925 4.60566 145.062 4.57129C145.131 4.57129 145.062 4.60566 145.062 4.64003L144.925 4.67441C144.959 4.64003 144.822 4.6744 144.959 4.64003Z",
    fill: "url(#paint74_linear_7270_1548)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M132.655 9.7959L132.62 9.83027C132.586 9.86464 132.552 9.89901 132.586 9.86464C132.483 9.89901 132.517 9.93338 132.483 9.89901C132.414 9.93338 132.38 9.96775 132.448 9.93338L132.311 10.0365L132.414 9.96776C132.38 9.96776 132.277 10.0709 132.242 10.0709L132.414 9.96776C132.448 9.93339 132.517 9.89901 132.552 9.86464C132.552 9.86464 132.552 9.86464 132.517 9.86464C132.62 9.76153 132.517 9.86464 132.655 9.7959Z",
    fill: "url(#paint75_linear_7270_1548)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M132.759 9.65817L132.862 9.6238L132.965 9.55506C132.965 9.55506 133.068 9.52069 132.999 9.55506C132.999 9.55506 132.965 9.55506 132.965 9.58943C132.999 9.58943 133.102 9.48631 133.102 9.52069C133.068 9.55506 132.999 9.58943 132.93 9.6238C132.862 9.65817 132.827 9.72692 132.759 9.76129C132.724 9.76129 132.724 9.76129 132.69 9.79566C132.724 9.72692 132.759 9.72692 132.759 9.65817L132.621 9.76129C132.655 9.72692 132.793 9.65817 132.827 9.58943C132.759 9.65817 132.862 9.58943 132.759 9.65817Z",
    fill: "url(#paint76_linear_7270_1548)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M136.161 7.45801C136.127 7.49238 136.161 7.49238 136.161 7.45801C136.092 7.49238 136.092 7.52675 136.161 7.45801Z",
    fill: "url(#paint77_linear_7270_1548)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M136.643 7.45864C136.677 7.42426 136.677 7.45864 136.643 7.45864V7.45864Z",
    fill: "url(#paint78_linear_7270_1548)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M133.101 9.45194C133.101 9.45194 132.998 9.52068 132.964 9.55505C132.929 9.55505 132.998 9.52068 132.964 9.55505C132.998 9.55505 133.032 9.52068 133.067 9.48631C133.067 9.48631 133.032 9.48631 132.964 9.52068C132.895 9.55505 132.998 9.48631 132.964 9.52068C133.067 9.41757 133.204 9.34882 133.342 9.31445C133.239 9.3832 133.17 9.41757 133.067 9.48631H133.101C133.17 9.41757 133.204 9.3832 133.307 9.34882L133.101 9.45194C133.032 9.52068 133.101 9.45194 133.17 9.41757C133.17 9.41757 133.136 9.41757 133.136 9.45194C133.136 9.45194 132.964 9.55506 133.101 9.45194Z",
    fill: "url(#paint79_linear_7270_1548)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M135.473 8.0082C135.473 7.97383 135.507 7.97383 135.473 8.0082V8.0082Z",
    fill: "url(#paint80_linear_7270_1548)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M135.472 8.07715C135.438 8.07715 135.404 8.11152 135.369 8.11152C135.404 8.07715 135.438 8.07715 135.472 8.07715Z",
    fill: "url(#paint81_linear_7270_1548)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M133.341 9.38301C133.307 9.38301 133.238 9.45175 133.238 9.41738C133.238 9.41738 133.341 9.31426 133.341 9.38301Z",
    fill: "url(#paint82_linear_7270_1548)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M133.307 9.38281L133.273 9.41718C133.273 9.41718 133.273 9.41718 133.238 9.41718L133.307 9.38281Z",
    fill: "url(#paint83_linear_7270_1548)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M133.239 9.55523C133.204 9.55523 133.136 9.5896 133.101 9.62398C133.136 9.65835 133.239 9.55523 133.239 9.55523C133.136 9.65835 133.101 9.65835 132.998 9.72709C133.067 9.65835 133.239 9.52086 133.239 9.55523Z",
    fill: "url(#paint84_linear_7270_1548)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M133.273 9.58925L133.342 9.52051V9.55488L133.273 9.58925Z",
    fill: "url(#paint85_linear_7270_1548)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M136.228 7.42402C136.091 7.49276 136.022 7.52714 135.885 7.59588C136.057 7.45839 136.16 7.49276 136.297 7.38965L136.228 7.42402Z",
    fill: "url(#paint86_linear_7270_1548)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M136.161 7.38981C136.161 7.42418 136.264 7.35543 136.264 7.38981C136.161 7.45855 136.196 7.38981 136.127 7.45855L136.161 7.38981Z",
    fill: "url(#paint87_linear_7270_1548)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M135.713 8.008L135.782 7.97363L135.747 8.008H135.713Z",
    fill: "url(#paint88_linear_7270_1548)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M136.779 7.04609L136.814 7.01172L136.779 7.04609Z",
    fill: "url(#paint89_linear_7270_1548)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M135.816 8.00781L135.747 8.04218L135.713 8.07656L135.816 8.00781Z",
    fill: "url(#paint90_linear_7270_1548)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M136.264 7.59556L136.195 7.62993C136.23 7.62993 136.298 7.56119 136.264 7.59556Z",
    fill: "url(#paint91_linear_7270_1548)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M137.191 6.80488L137.295 6.77051H137.26L137.191 6.80488Z",
    fill: "url(#paint92_linear_7270_1548)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M136.779 7.38981C136.711 7.42418 136.745 7.38981 136.745 7.38981C136.711 7.42418 136.848 7.35543 136.779 7.38981Z",
    fill: "url(#paint93_linear_7270_1548)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M139.151 5.70494C139.151 5.70494 139.116 5.73931 139.082 5.73931C139.082 5.73931 139.185 5.67056 139.151 5.70494Z",
    fill: "url(#paint94_linear_7270_1548)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M140.904 5.258L141.007 5.22363C141.007 5.258 141.007 5.22363 140.904 5.258H141.007C140.939 5.258 140.904 5.29238 140.904 5.258Z",
    fill: "url(#paint95_linear_7270_1548)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M149.325 3.43671C149.29 3.43671 149.256 3.43671 149.256 3.43671C149.29 3.43671 149.29 3.43671 149.325 3.43671C149.256 3.43671 149.29 3.40234 149.29 3.40234C149.393 3.40234 149.325 3.43671 149.325 3.43671Z",
    fill: "url(#paint96_linear_7270_1548)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M149.394 3.12734C149.36 3.12734 149.325 3.12734 149.325 3.12734C149.291 3.09297 149.394 3.09297 149.394 3.12734Z",
    fill: "url(#paint97_linear_7270_1548)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M149.36 3.12695C149.36 3.12695 149.325 3.12695 149.291 3.16132C149.291 3.12695 149.325 3.12695 149.36 3.12695Z",
    fill: "url(#paint98_linear_7270_1548)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M149.394 3.02441C149.394 3.02441 149.394 3.05879 149.36 3.05879C149.326 3.02441 149.36 3.02441 149.394 3.02441Z",
    fill: "url(#paint99_linear_7270_1548)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M149.016 3.43652C149.016 3.43652 149.05 3.43652 149.084 3.43652C149.084 3.43652 149.016 3.4709 149.016 3.43652Z",
    fill: "url(#paint100_linear_7270_1548)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M149.016 3.43652C148.982 3.4709 149.051 3.50527 149.016 3.53964C148.948 3.53964 148.948 3.57401 148.913 3.60838C148.879 3.53964 148.913 3.4709 149.016 3.43652Z",
    fill: "url(#paint101_linear_7270_1548)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M148.121 3.74648C148.121 3.71211 148.121 3.71211 148.121 3.74648C148.19 3.71211 148.155 3.71211 148.155 3.74648C148.155 3.71211 148.155 3.74648 148.121 3.74648Z",
    fill: "url(#paint102_linear_7270_1548)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M148.019 3.71191C148.087 3.71191 147.984 3.78066 147.984 3.74629C147.95 3.71191 148.019 3.71191 148.019 3.71191Z",
    fill: "url(#paint103_linear_7270_1548)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M147.366 3.71191C147.331 3.71191 147.331 3.74629 147.366 3.71191V3.71191Z",
    fill: "url(#paint104_linear_7270_1548)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M145.167 4.12421L145.339 4.08984C145.304 4.12422 145.27 4.12421 145.167 4.12421C145.27 4.12421 145.132 4.15859 145.132 4.15859C145.167 4.15859 145.201 4.15859 145.235 4.15859L145.201 4.19296C145.098 4.22733 145.064 4.19296 144.96 4.22733C144.96 4.22733 144.995 4.22733 144.926 4.2617C144.823 4.2617 144.823 4.29607 144.754 4.29607C144.685 4.29607 144.617 4.29607 144.548 4.33045C144.445 4.33045 144.342 4.36482 144.273 4.36482H144.376C144.307 4.36482 144.307 4.36482 144.239 4.36482C144.239 4.36482 144.239 4.36482 144.273 4.36482C144.273 4.36482 144.204 4.36482 144.17 4.36482H144.067C143.998 4.36482 144.067 4.36482 144.067 4.33045C144.032 4.33045 143.964 4.33044 143.964 4.36482C143.964 4.36482 144.032 4.36482 143.998 4.36482H143.895C143.792 4.39919 143.964 4.36482 144.032 4.36482C143.929 4.39919 143.895 4.36482 143.792 4.39919C143.826 4.39919 143.826 4.39919 143.861 4.36482C143.861 4.36482 143.757 4.36482 143.689 4.39919H143.654C143.689 4.39919 143.757 4.36482 143.792 4.36482C143.757 4.39919 143.929 4.33045 143.998 4.33045H144.067H144.101C144.101 4.33045 144.101 4.33045 144.067 4.33045C144.101 4.33045 144.17 4.29607 144.17 4.33045L144.273 4.29607L144.376 4.2617L144.582 4.22733C144.582 4.22733 144.582 4.22733 144.617 4.22733L144.857 4.19296C144.857 4.19296 144.892 4.19296 144.926 4.19296L145.132 4.15859C145.132 4.12422 145.167 4.12421 145.167 4.12421Z",
    fill: "url(#paint105_linear_7270_1548)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M143.928 3.12758H143.859C143.894 3.09321 143.928 3.05884 143.928 3.12758Z",
    fill: "url(#paint106_linear_7270_1548)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M143.516 3.19629C143.482 3.19629 143.447 3.23066 143.447 3.19629C143.482 3.19629 143.516 3.19629 143.516 3.19629Z",
    fill: "url(#paint107_linear_7270_1548)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M143.412 4.46812C143.412 4.43375 143.446 4.43375 143.481 4.43375C143.481 4.43375 143.481 4.43375 143.446 4.43375C143.446 4.43375 143.446 4.43375 143.481 4.43375C143.481 4.46812 143.515 4.39938 143.515 4.43375C143.515 4.46812 143.446 4.43375 143.481 4.46812C143.446 4.43375 143.446 4.43375 143.412 4.46812Z",
    fill: "url(#paint108_linear_7270_1548)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M143.448 4.39907C143.413 4.43344 143.379 4.43344 143.379 4.39907C143.413 4.39907 143.448 4.36469 143.448 4.39907Z",
    fill: "url(#paint109_linear_7270_1548)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M143.241 4.39941C143.207 4.39941 143.207 4.39941 143.172 4.43379C143.172 4.39941 143.138 4.43379 143.104 4.43379C143.138 4.43379 143.241 4.39941 143.241 4.39941Z",
    fill: "url(#paint110_linear_7270_1548)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M142.932 3.36836C142.932 3.33398 142.966 3.36836 143.035 3.33398C143.035 3.33398 142.932 3.33398 142.932 3.36836Z",
    fill: "url(#paint111_linear_7270_1548)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M142.932 3.40234C142.966 3.40234 142.966 3.40234 143 3.40234C142.966 3.40234 142.932 3.43672 142.932 3.40234Z",
    fill: "url(#paint112_linear_7270_1548)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M142.623 4.63984C142.623 4.60547 142.657 4.60547 142.726 4.60547C142.657 4.60547 142.623 4.63984 142.623 4.63984Z",
    fill: "url(#paint113_linear_7270_1548)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M140.836 4.19315C140.87 4.19315 140.87 4.15878 140.905 4.15878C140.939 4.15878 140.905 4.19315 140.939 4.15878C141.042 4.12441 141.111 4.09004 141.214 4.05566V4.09004C141.248 4.09004 141.283 4.05566 141.283 4.05566C141.248 4.05566 141.248 4.09004 141.214 4.09004C141.18 4.05566 141.111 4.05566 141.077 4.09004C141.042 4.12441 141.008 4.12441 140.973 4.15878C140.973 4.15878 140.973 4.15878 140.939 4.15878C140.905 4.15878 140.836 4.19315 140.836 4.19315Z",
    fill: "url(#paint114_linear_7270_1548)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M141.042 4.2621C140.973 4.29647 140.939 4.29647 140.836 4.29647C140.939 4.2621 141.008 4.29647 141.042 4.2621C141.042 4.22773 141.111 4.19336 141.145 4.19336C141.145 4.19336 141.145 4.22773 141.111 4.22773L141.042 4.2621Z",
    fill: "url(#paint115_linear_7270_1548)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M140.766 4.36445C140.8 4.36445 140.766 4.33008 140.8 4.33008C140.834 4.33008 140.8 4.33008 140.8 4.36445C140.8 4.36445 140.8 4.36445 140.766 4.36445Z",
    fill: "url(#paint116_linear_7270_1548)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M140.664 4.19257C140.698 4.19257 140.733 4.1582 140.767 4.1582C140.733 4.1582 140.664 4.19257 140.664 4.19257Z",
    fill: "url(#paint117_linear_7270_1548)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M140.32 4.33027C140.32 4.33027 140.389 4.2959 140.423 4.2959C140.389 4.2959 140.355 4.2959 140.32 4.33027Z",
    fill: "url(#paint118_linear_7270_1548)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M140.423 4.36465C140.389 4.36465 140.355 4.36465 140.32 4.36465C140.355 4.33027 140.423 4.33027 140.423 4.36465Z",
    fill: "url(#paint119_linear_7270_1548)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M140.217 4.39941C140.217 4.39941 140.217 4.39941 140.182 4.43379C140.148 4.43379 140.182 4.39941 140.217 4.39941Z",
    fill: "url(#paint120_linear_7270_1548)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M140.113 4.46834C140.079 4.46834 140.044 4.50271 140.01 4.50271C140.01 4.46834 140.079 4.43397 140.113 4.46834Z",
    fill: "url(#paint121_linear_7270_1548)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M140.044 4.43359C140.009 4.43359 139.975 4.46796 139.941 4.46796H139.906H139.975C139.975 4.50234 140.078 4.43359 140.044 4.43359Z",
    fill: "url(#paint122_linear_7270_1548)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M139.906 4.53632C139.941 4.53632 139.975 4.50195 140.009 4.50195C139.941 4.50195 139.906 4.53632 139.906 4.53632Z",
    fill: "url(#paint123_linear_7270_1548)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M139.872 4.5367C139.837 4.57107 139.769 4.60544 139.734 4.60544C139.734 4.60544 139.769 4.57107 139.803 4.57107C139.803 4.5367 139.872 4.50233 139.872 4.5367Z",
    fill: "url(#paint124_linear_7270_1548)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M139.495 4.81152C139.46 4.81152 139.46 4.8459 139.426 4.8459C139.426 4.8459 139.495 4.8459 139.495 4.81152Z",
    fill: "url(#paint125_linear_7270_1548)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M139.22 4.777C139.22 4.777 139.323 4.74262 139.289 4.777C139.255 4.81137 139.22 4.81137 139.22 4.777C139.22 4.81137 139.186 4.777 139.22 4.777Z",
    fill: "url(#paint126_linear_7270_1548)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M139.254 5.36152C139.288 5.36152 139.288 5.36152 139.323 5.32715V5.36152C139.288 5.36152 139.254 5.36152 139.254 5.36152Z",
    fill: "url(#paint127_linear_7270_1548)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M138.91 5.1205C138.91 5.08613 138.944 5.08613 138.979 5.05176C138.979 5.05176 138.944 5.08613 138.91 5.1205Z",
    fill: "url(#paint128_linear_7270_1548)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M138.875 4.7775C138.875 4.7775 138.841 4.7775 138.807 4.81187C138.807 4.7775 138.841 4.7775 138.875 4.7775C138.875 4.74313 138.841 4.81187 138.875 4.7775Z",
    fill: "url(#paint129_linear_7270_1548)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M138.945 5.12051C138.911 5.12051 138.911 5.15488 138.877 5.15488C138.842 5.15488 138.911 5.12051 138.945 5.12051C138.945 5.08613 138.911 5.12051 138.945 5.12051C138.945 5.08613 138.945 5.08613 138.945 5.12051Z",
    fill: "url(#paint130_linear_7270_1548)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M138.911 5.12075C138.876 5.12075 138.842 5.15512 138.842 5.12075C138.876 5.12075 138.807 5.12075 138.911 5.12075C138.876 5.12075 138.876 5.08637 138.911 5.12075Z",
    fill: "url(#paint131_linear_7270_1548)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M138.842 5.18965C138.842 5.15527 138.876 5.15527 138.842 5.18965C138.876 5.18965 138.911 5.15527 138.911 5.15527L138.842 5.18965Z",
    fill: "url(#paint132_linear_7270_1548)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M138.703 5.01777C138.737 5.01777 138.738 5.01777 138.772 4.9834C138.772 5.01777 138.703 5.01777 138.703 5.01777Z",
    fill: "url(#paint133_linear_7270_1548)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M138.807 5.12109C138.773 5.12109 138.807 5.15546 138.773 5.15546C138.773 5.15546 138.773 5.15547 138.807 5.12109C138.773 5.12109 138.773 5.15547 138.738 5.12109H138.807Z",
    fill: "url(#paint134_linear_7270_1548)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M138.601 4.87988C138.567 4.91425 138.498 4.94863 138.498 4.91425C138.532 4.91425 138.601 4.87988 138.601 4.87988Z",
    fill: "url(#paint135_linear_7270_1548)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M138.739 5.15527C138.739 5.15527 138.704 5.18965 138.67 5.18965C138.704 5.15527 138.704 5.15527 138.739 5.15527Z",
    fill: "url(#paint136_linear_7270_1548)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M138.67 5.08613C138.704 5.08613 138.704 5.05176 138.704 5.05176C138.704 5.08613 138.67 5.08613 138.67 5.08613Z",
    fill: "url(#paint137_linear_7270_1548)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M138.67 5.05239C138.636 5.05239 138.602 5.08676 138.602 5.05239C138.636 5.05239 138.67 5.01801 138.67 5.05239Z",
    fill: "url(#paint138_linear_7270_1548)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M138.704 5.12125C138.67 5.15562 138.601 5.18999 138.566 5.18999C138.566 5.18999 138.601 5.18999 138.601 5.15562C138.601 5.15562 138.601 5.12125 138.566 5.12125C138.601 5.08688 138.601 5.15562 138.704 5.12125Z",
    fill: "url(#paint139_linear_7270_1548)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M138.498 4.94922C138.429 4.98359 138.395 5.01796 138.326 5.05233C138.326 5.01796 138.429 4.98359 138.498 4.94922C138.464 4.94922 138.464 4.94922 138.498 4.94922Z",
    fill: "url(#paint140_linear_7270_1548)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M138.326 5.43007C138.361 5.43007 138.395 5.3957 138.429 5.36133C138.395 5.36133 138.395 5.36133 138.361 5.3957C138.395 5.43007 138.326 5.46444 138.326 5.43007Z",
    fill: "url(#paint141_linear_7270_1548)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M138.394 5.46484C138.36 5.49922 138.325 5.49922 138.291 5.53359C138.36 5.49922 138.394 5.46484 138.394 5.46484Z",
    fill: "url(#paint142_linear_7270_1548)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M138.188 5.5332C138.188 5.49883 138.222 5.49883 138.188 5.5332C138.256 5.46446 138.256 5.49883 138.291 5.49883C138.291 5.49883 138.222 5.5332 138.256 5.5332C138.222 5.5332 138.256 5.49883 138.188 5.5332Z",
    fill: "url(#paint143_linear_7270_1548)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M137.947 5.32753C138.016 5.29316 138.05 5.25879 138.119 5.25879C138.085 5.25879 138.016 5.32753 137.947 5.32753Z",
    fill: "url(#paint144_linear_7270_1548)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M138.291 6.11776C138.36 6.08339 138.394 6.04902 138.497 6.01465C138.428 6.04902 138.36 6.08339 138.291 6.11776Z",
    fill: "url(#paint145_linear_7270_1548)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M138.188 5.46443C138.154 5.46443 138.119 5.4988 138.119 5.4988C138.188 5.46443 138.188 5.43006 138.188 5.46443Z",
    fill: "url(#paint146_linear_7270_1548)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M137.948 5.32715C137.913 5.32715 137.913 5.36152 137.879 5.36152C137.879 5.32715 137.913 5.32715 137.948 5.32715Z",
    fill: "url(#paint147_linear_7270_1548)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M138.119 5.9455C138.154 5.9455 138.188 5.91113 138.222 5.91113C138.188 5.9455 138.154 5.9455 138.119 5.9455Z",
    fill: "url(#paint148_linear_7270_1548)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M137.947 5.46484C137.947 5.49922 137.912 5.49922 137.844 5.53359C137.844 5.49922 137.947 5.49922 137.947 5.46484Z",
    fill: "url(#paint149_linear_7270_1548)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M137.88 5.5332C137.811 5.5332 137.777 5.60195 137.742 5.60195C137.777 5.60195 137.88 5.5332 137.88 5.5332Z",
    fill: "url(#paint150_linear_7270_1548)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M138.154 6.32441C138.189 6.29004 138.223 6.29004 138.257 6.29004C138.257 6.29004 138.189 6.29004 138.154 6.32441Z",
    fill: "url(#paint151_linear_7270_1548)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M137.844 5.60254C137.844 5.60254 137.81 5.63691 137.775 5.63691C137.81 5.63691 137.81 5.60254 137.844 5.60254Z",
    fill: "url(#paint152_linear_7270_1548)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M137.811 5.5332C137.777 5.5332 137.777 5.56757 137.811 5.5332V5.5332Z",
    fill: "url(#paint153_linear_7270_1548)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 5.60195C137.534 5.60195 137.569 5.56757 137.603 5.5332C137.603 5.5332 137.603 5.5332 137.637 5.5332C137.603 5.56757 137.569 5.60195 137.5 5.60195C137.5 5.63632 137.5 5.63632 137.5 5.60195Z",
    fill: "url(#paint154_linear_7270_1548)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M137.398 5.60195L137.502 5.5332C137.467 5.56757 137.433 5.56757 137.398 5.60195Z",
    fill: "url(#paint155_linear_7270_1548)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M137.466 5.60219C137.432 5.60219 137.535 5.56782 137.5 5.60219C137.5 5.56782 137.5 5.60219 137.466 5.60219Z",
    fill: "url(#paint156_linear_7270_1548)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M137.637 5.91132C137.569 5.98007 137.569 5.87695 137.5 5.9457C137.5 5.91132 137.637 5.87695 137.637 5.87695C137.603 5.91132 137.637 5.91132 137.637 5.91132Z",
    fill: "url(#paint157_linear_7270_1548)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M137.57 6.25546C137.639 6.22109 137.639 6.18672 137.708 6.15234C137.708 6.15234 137.708 6.15234 137.673 6.15234C137.605 6.18672 137.605 6.25546 137.57 6.25546Z",
    fill: "url(#paint158_linear_7270_1548)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M137.502 5.84277C137.467 5.84277 137.398 5.91152 137.398 5.91152C137.433 5.87715 137.467 5.84277 137.502 5.84277Z",
    fill: "url(#paint159_linear_7270_1548)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M137.398 6.01493C137.363 6.01493 137.466 5.94618 137.432 6.01493C137.432 5.98056 137.432 6.01493 137.398 6.01493Z",
    fill: "url(#paint160_linear_7270_1548)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M137.569 6.18652C137.569 6.18652 137.534 6.2209 137.5 6.2209V6.18652C137.534 6.2209 137.569 6.18652 137.569 6.18652Z",
    fill: "url(#paint161_linear_7270_1548)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M137.398 6.18671C137.398 6.18671 137.433 6.15234 137.467 6.15234H137.502C137.467 6.18672 137.433 6.18671 137.398 6.18671Z",
    fill: "url(#paint162_linear_7270_1548)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M137.295 6.39237C137.398 6.358 137.467 6.28925 137.536 6.25488C137.536 6.25488 137.467 6.25488 137.502 6.25488C137.433 6.25488 137.364 6.32363 137.295 6.39237C137.33 6.358 137.364 6.32363 137.398 6.28925C137.398 6.32363 137.295 6.358 137.227 6.39237H137.295ZM137.398 6.28925L137.467 6.25488C137.467 6.25488 137.433 6.28925 137.398 6.28925Z",
    fill: "url(#paint163_linear_7270_1548)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M137.088 5.9455C137.122 5.9455 137.157 5.91113 137.191 5.91113C137.122 5.91113 137.088 5.9455 137.088 5.9455Z",
    fill: "url(#paint164_linear_7270_1548)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M137.054 5.77441C136.985 5.77441 136.951 5.84316 136.848 5.84316C136.916 5.80879 136.985 5.77441 137.054 5.77441Z",
    fill: "url(#paint165_linear_7270_1548)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M137.26 6.28925L137.294 6.25488C137.329 6.32363 137.294 6.28925 137.26 6.28925Z",
    fill: "url(#paint166_linear_7270_1548)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M137.295 6.39277C137.295 6.39277 137.329 6.3584 137.363 6.3584C137.295 6.39277 137.26 6.42714 137.295 6.39277Z",
    fill: "url(#paint167_linear_7270_1548)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M137.191 6.28925C137.191 6.28925 137.226 6.25488 137.26 6.25488C137.26 6.25488 137.191 6.32363 137.191 6.28925Z",
    fill: "url(#paint168_linear_7270_1548)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M137.123 6.2209C137.157 6.2209 137.157 6.2209 137.191 6.18652H137.226C137.191 6.2209 137.157 6.2209 137.123 6.2209C137.123 6.25527 137.088 6.25527 137.123 6.2209Z",
    fill: "url(#paint169_linear_7270_1548)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M137.26 6.32387C137.225 6.32387 137.191 6.32387 137.225 6.32387C137.26 6.2895 137.225 6.32387 137.26 6.32387Z",
    fill: "url(#paint170_linear_7270_1548)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M137.123 6.18638C137.123 6.18638 137.089 6.22075 137.055 6.22075C137.089 6.22075 137.089 6.15201 137.123 6.18638Z",
    fill: "url(#paint171_linear_7270_1548)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M137.364 6.59863C137.33 6.633 137.261 6.66738 137.227 6.66738C137.261 6.633 137.33 6.59863 137.364 6.59863Z",
    fill: "url(#paint172_linear_7270_1548)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M136.812 6.08339C136.847 6.04902 136.916 6.01465 136.984 6.01465C136.916 6.04902 136.881 6.04902 136.812 6.08339Z",
    fill: "url(#paint173_linear_7270_1548)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M136.95 6.11782C136.95 6.11782 136.95 6.11782 136.916 6.15219C136.916 6.08344 136.916 6.11782 136.95 6.11782Z",
    fill: "url(#paint174_linear_7270_1548)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M136.95 6.18671C136.95 6.18671 136.916 6.22109 136.916 6.18671C136.916 6.15234 136.916 6.15234 136.95 6.18671C136.916 6.15234 136.916 6.15234 136.95 6.18671C136.95 6.15234 136.95 6.15234 136.95 6.15234C136.916 6.15234 136.985 6.15234 136.95 6.18671Z",
    fill: "url(#paint175_linear_7270_1548)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M136.848 6.15234C136.813 6.18672 136.813 6.18671 136.779 6.18671C136.779 6.18671 136.779 6.15234 136.848 6.15234Z",
    fill: "url(#paint176_linear_7270_1548)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M137.26 6.80525C137.226 6.80525 137.191 6.83963 137.191 6.83963C137.191 6.80525 137.226 6.77088 137.26 6.80525Z",
    fill: "url(#paint177_linear_7270_1548)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M136.916 6.3584C136.916 6.3584 136.882 6.39277 136.848 6.39277C136.848 6.3584 136.882 6.3584 136.916 6.3584Z",
    fill: "url(#paint178_linear_7270_1548)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M136.883 6.83925C136.917 6.83925 136.952 6.80488 137.02 6.77051C136.986 6.80488 136.952 6.83925 136.883 6.83925Z",
    fill: "url(#paint179_linear_7270_1548)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M136.471 6.04902C136.436 6.04902 136.505 6.01465 136.505 6.01465C136.505 6.04902 136.505 6.04902 136.471 6.04902Z",
    fill: "url(#paint180_linear_7270_1548)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M136.779 6.9084C136.814 6.87402 136.848 6.87402 136.882 6.87402C136.848 6.87402 136.779 6.9084 136.779 6.9084Z",
    fill: "url(#paint181_linear_7270_1548)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M136.471 6.39258C136.436 6.42695 136.368 6.46132 136.402 6.42695C136.402 6.46132 136.436 6.39258 136.471 6.39258Z",
    fill: "url(#paint182_linear_7270_1548)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M136.23 6.25488C136.161 6.28925 136.127 6.32363 136.023 6.358C136.092 6.358 136.195 6.25488 136.23 6.25488Z",
    fill: "url(#paint183_linear_7270_1548)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M136.367 6.66738C136.402 6.66738 136.436 6.59863 136.47 6.59863C136.436 6.633 136.436 6.66738 136.367 6.66738Z",
    fill: "url(#paint184_linear_7270_1548)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M136.264 6.3584C136.298 6.3584 136.298 6.3584 136.298 6.3584C136.264 6.39277 136.264 6.3584 136.264 6.3584Z",
    fill: "url(#paint185_linear_7270_1548)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M136.229 6.73652C136.229 6.73652 136.263 6.70215 136.297 6.70215C136.263 6.73652 136.229 6.73652 136.229 6.73652Z",
    fill: "url(#paint186_linear_7270_1548)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M136.161 6.63379C136.127 6.63379 136.127 6.66816 136.127 6.63379H136.161Z",
    fill: "url(#paint187_linear_7270_1548)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M136.092 6.66738C136.092 6.66738 136.092 6.633 136.092 6.59863C136.092 6.633 136.126 6.633 136.092 6.66738Z",
    fill: "url(#paint188_linear_7270_1548)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M136.469 7.11482C136.435 7.11482 136.4 7.14919 136.4 7.14919C136.4 7.11482 136.469 7.08045 136.469 7.11482Z",
    fill: "url(#paint189_linear_7270_1548)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M136.161 6.70174C136.161 6.70174 136.126 6.73611 136.092 6.73611C136.092 6.70174 136.126 6.66737 136.161 6.70174Z",
    fill: "url(#paint190_linear_7270_1548)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M136.092 6.77089C136.126 6.77089 136.161 6.70215 136.195 6.70215C136.126 6.77089 136.092 6.77089 136.092 6.77089Z",
    fill: "url(#paint191_linear_7270_1548)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M135.816 6.63339C135.885 6.59902 135.92 6.56465 135.954 6.53027C135.92 6.56465 135.851 6.63339 135.816 6.63339Z",
    fill: "url(#paint192_linear_7270_1548)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M136.092 7.01113C136.126 7.01113 136.195 6.94238 136.195 6.94238C136.161 6.97675 136.161 6.97675 136.092 7.01113Z",
    fill: "url(#paint193_linear_7270_1548)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M135.92 6.80507C135.954 6.80507 136.023 6.7707 136.057 6.73633C136.023 6.7707 135.954 6.83944 135.92 6.80507Z",
    fill: "url(#paint194_linear_7270_1548)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M136.298 7.18359C136.264 7.18359 136.23 7.21796 136.195 7.21796C136.264 7.21796 136.264 7.18359 136.298 7.18359Z",
    fill: "url(#paint195_linear_7270_1548)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M135.852 6.7018C135.818 6.7018 135.783 6.73617 135.783 6.7018C135.818 6.7018 135.818 6.66743 135.852 6.7018Z",
    fill: "url(#paint196_linear_7270_1548)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M135.955 6.90785C135.989 6.87348 135.989 6.90785 135.955 6.90785V6.90785Z",
    fill: "url(#paint197_linear_7270_1548)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M135.61 6.56484C135.576 6.56484 135.679 6.49609 135.714 6.49609C135.679 6.53047 135.645 6.56484 135.61 6.56484Z",
    fill: "url(#paint198_linear_7270_1548)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M135.748 6.90878C135.782 6.87441 135.851 6.84004 135.92 6.80566C135.886 6.84004 135.817 6.87441 135.748 6.90878Z",
    fill: "url(#paint199_linear_7270_1548)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M135.713 6.66797C135.713 6.66797 135.748 6.66797 135.782 6.66797C135.748 6.66797 135.713 6.70234 135.713 6.66797C135.679 6.70234 135.679 6.70234 135.713 6.66797Z",
    fill: "url(#paint200_linear_7270_1548)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M135.885 6.94301C135.885 6.94301 135.919 6.90864 135.919 6.94301C135.85 6.94301 135.782 7.01175 135.885 6.94301Z",
    fill: "url(#paint201_linear_7270_1548)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M135.954 7.0459C135.988 7.0459 135.988 7.08027 135.954 7.0459V7.0459Z",
    fill: "url(#paint202_linear_7270_1548)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M135.748 6.77051C135.713 6.77051 135.713 6.80488 135.679 6.80488H135.645C135.679 6.80488 135.713 6.77051 135.748 6.77051Z",
    fill: "url(#paint203_linear_7270_1548)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M135.645 6.87407C135.645 6.87407 135.748 6.80533 135.713 6.8397C135.679 6.8397 135.679 6.87407 135.645 6.87407Z",
    fill: "url(#paint204_linear_7270_1548)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M135.782 7.01131C135.747 7.04568 135.747 7.04568 135.713 7.04568C135.782 7.01131 135.782 6.97694 135.782 7.01131Z",
    fill: "url(#paint205_linear_7270_1548)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M136.093 7.38965C136.024 7.45839 135.989 7.45839 135.955 7.49276C135.955 7.45839 136.093 7.42402 136.093 7.38965Z",
    fill: "url(#paint206_linear_7270_1548)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M135.989 7.2867L135.92 7.32107C135.954 7.2867 135.989 7.25233 135.989 7.2867Z",
    fill: "url(#paint207_linear_7270_1548)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M135.816 7.45839C135.816 7.42402 135.92 7.38965 135.954 7.38965C135.885 7.42402 135.851 7.45839 135.816 7.45839Z",
    fill: "url(#paint208_linear_7270_1548)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M135.68 7.11426C135.714 7.11426 135.714 7.11426 135.714 7.11426C135.68 7.11426 135.68 7.14863 135.68 7.11426Z",
    fill: "url(#paint209_linear_7270_1548)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M135.679 7.25156C135.645 7.25156 135.576 7.3203 135.576 7.3203C135.611 7.28593 135.679 7.21718 135.679 7.25156Z",
    fill: "url(#paint210_linear_7270_1548)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M135.336 6.80552C135.301 6.80552 135.232 6.87427 135.232 6.83989C135.267 6.83989 135.301 6.77115 135.336 6.80552Z",
    fill: "url(#paint211_linear_7270_1548)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M135.885 7.5959C135.919 7.5959 135.954 7.56152 135.954 7.56152C135.885 7.5959 135.885 7.5959 135.885 7.5959Z",
    fill: "url(#paint212_linear_7270_1548)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M135.473 7.11445L135.542 7.08008C135.508 7.08008 135.508 7.11445 135.439 7.14882C135.404 7.14882 135.508 7.11445 135.473 7.11445Z",
    fill: "url(#paint213_linear_7270_1548)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M135.611 7.25154C135.577 7.25154 135.542 7.28591 135.508 7.28591C135.542 7.25154 135.577 7.21717 135.611 7.25154Z",
    fill: "url(#paint214_linear_7270_1548)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M135.199 6.77051C135.199 6.77051 135.164 6.80488 135.13 6.80488C135.096 6.80488 135.199 6.77051 135.199 6.77051Z",
    fill: "url(#paint215_linear_7270_1548)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M135.233 7.01172C135.233 7.01172 135.164 7.08046 135.164 7.04609C135.164 7.04609 135.198 7.01172 135.233 7.01172Z",
    fill: "url(#paint216_linear_7270_1548)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M135.371 7.18359C135.336 7.21797 135.302 7.21797 135.268 7.25234C135.268 7.25234 135.336 7.18359 135.371 7.18359Z",
    fill: "url(#paint217_linear_7270_1548)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M135.095 6.90859C135.061 6.90859 135.027 6.90859 135.061 6.90859C135.061 6.87422 135.095 6.87422 135.095 6.90859Z",
    fill: "url(#paint218_linear_7270_1548)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M135.576 7.52734C135.541 7.52734 135.507 7.59609 135.473 7.56171C135.507 7.56171 135.541 7.52734 135.576 7.52734Z",
    fill: "url(#paint219_linear_7270_1548)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M135.508 7.5957C135.508 7.5957 135.474 7.63007 135.439 7.63007C135.474 7.5957 135.508 7.5957 135.508 7.5957Z",
    fill: "url(#paint220_linear_7270_1548)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M135.576 7.7334C135.541 7.7334 135.507 7.80214 135.473 7.76777C135.473 7.76777 135.541 7.7334 135.576 7.7334Z",
    fill: "url(#paint221_linear_7270_1548)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M135.472 7.56152C135.438 7.63027 135.369 7.63027 135.369 7.63027C135.369 7.63027 135.404 7.5959 135.472 7.56152Z",
    fill: "url(#paint222_linear_7270_1548)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M134.854 7.0459C134.888 7.0459 134.922 7.0459 134.957 7.0459L134.922 7.08027C134.888 7.0459 134.854 7.0459 134.854 7.0459Z",
    fill: "url(#paint223_linear_7270_1548)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M135.577 7.76758C135.542 7.76758 135.542 7.80195 135.508 7.80195C135.508 7.80195 135.542 7.76758 135.577 7.76758Z",
    fill: "url(#paint224_linear_7270_1548)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M135.096 7.38984L135.164 7.35547C135.164 7.35547 135.13 7.38984 135.096 7.38984Z",
    fill: "url(#paint225_linear_7270_1548)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M134.993 7.18359C134.855 7.25234 134.855 7.28671 134.752 7.32108C134.821 7.25234 134.889 7.21797 134.993 7.18359Z",
    fill: "url(#paint226_linear_7270_1548)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M135.335 7.66406C135.335 7.69843 135.301 7.69843 135.301 7.69843C135.301 7.66406 135.301 7.66406 135.335 7.66406Z",
    fill: "url(#paint227_linear_7270_1548)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M134.682 7.56091C134.785 7.49217 134.888 7.42343 134.991 7.35468C134.991 7.35468 134.957 7.35468 134.991 7.32031C134.991 7.32031 135.025 7.32031 135.06 7.32031C134.957 7.42343 134.819 7.4578 134.682 7.56091Z",
    fill: "url(#paint228_linear_7270_1548)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M135.197 7.73359C135.197 7.69922 135.232 7.73359 135.197 7.73359C135.232 7.69922 135.266 7.69922 135.266 7.69922C135.266 7.69922 135.266 7.73359 135.197 7.73359Z",
    fill: "url(#paint229_linear_7270_1548)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M134.476 7.28652C134.511 7.28652 134.511 7.32089 134.476 7.28652C134.442 7.32089 134.476 7.32089 134.476 7.28652C134.545 7.25215 134.545 7.25215 134.614 7.21777C134.579 7.25215 134.545 7.28652 134.476 7.28652Z",
    fill: "url(#paint230_linear_7270_1548)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M135.061 7.80195L135.095 7.76758C135.095 7.80195 135.061 7.83632 135.061 7.80195Z",
    fill: "url(#paint231_linear_7270_1548)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M134.51 7.25215C134.441 7.25215 134.476 7.25215 134.51 7.25215C134.476 7.21777 134.476 7.25215 134.441 7.25215C134.441 7.25215 134.476 7.21777 134.51 7.21777C134.51 7.21777 134.51 7.21777 134.51 7.25215Z",
    fill: "url(#paint232_linear_7270_1548)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M134.613 7.42402C134.579 7.42402 134.544 7.49276 134.51 7.45839C134.579 7.42402 134.579 7.38965 134.613 7.38965C134.647 7.38965 134.613 7.38965 134.613 7.42402Z",
    fill: "url(#paint233_linear_7270_1548)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M134.889 7.90468C134.923 7.87031 134.992 7.87031 135.026 7.83594C135.026 7.83594 135.061 7.83594 135.026 7.87031C134.957 7.87031 134.923 7.90468 134.889 7.90468Z",
    fill: "url(#paint234_linear_7270_1548)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M134.511 7.3893C134.477 7.3893 134.477 7.3893 134.477 7.3893C134.477 7.3893 134.511 7.35493 134.511 7.3893Z",
    fill: "url(#paint235_linear_7270_1548)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M134.58 7.5959L134.614 7.56152C134.511 7.66464 134.477 7.66464 134.58 7.5959Z",
    fill: "url(#paint236_linear_7270_1548)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M134.408 7.35547C134.339 7.38984 134.339 7.42421 134.305 7.42421C134.373 7.38984 134.339 7.38984 134.339 7.35547C134.339 7.42421 134.373 7.35547 134.408 7.35547Z",
    fill: "url(#paint237_linear_7270_1548)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M134.477 7.56152C134.545 7.56152 134.545 7.56152 134.477 7.56152C134.477 7.5959 134.511 7.5959 134.477 7.56152Z",
    fill: "url(#paint238_linear_7270_1548)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M134.201 7.35468C134.236 7.35468 134.27 7.32031 134.304 7.32031C134.27 7.35468 134.236 7.35468 134.201 7.35468Z",
    fill: "url(#paint239_linear_7270_1548)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M134.476 7.62974L134.441 7.66411C134.407 7.66411 134.476 7.59537 134.476 7.62974Z",
    fill: "url(#paint240_linear_7270_1548)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M134.889 8.17969C134.786 8.17969 134.82 8.24843 134.717 8.2828C134.717 8.31718 134.751 8.2828 134.786 8.2828C134.786 8.2828 134.751 8.2828 134.751 8.31717C134.82 8.24843 134.82 8.21406 134.889 8.17969Z",
    fill: "url(#paint241_linear_7270_1548)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M134.168 7.42383C134.099 7.4582 134.064 7.49257 134.064 7.4582C134.099 7.4582 134.168 7.42383 134.168 7.42383Z",
    fill: "url(#paint242_linear_7270_1548)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M134.682 8.17988C134.682 8.17988 134.682 8.17988 134.716 8.14551C134.75 8.14551 134.682 8.14551 134.682 8.17988Z",
    fill: "url(#paint243_linear_7270_1548)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M134.613 8.1457C134.613 8.1457 134.648 8.11133 134.682 8.11133C134.682 8.1457 134.613 8.18007 134.613 8.1457Z",
    fill: "url(#paint244_linear_7270_1548)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M134.373 8.14608C134.407 8.11171 134.476 8.07734 134.545 8.04297C134.476 8.07734 134.442 8.11171 134.373 8.14608Z",
    fill: "url(#paint245_linear_7270_1548)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M134.58 8.28339C134.614 8.28339 134.614 8.24902 134.649 8.24902C134.614 8.24902 134.58 8.28339 134.58 8.28339Z",
    fill: "url(#paint246_linear_7270_1548)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M134.2 7.87068L134.166 7.90506C134.132 7.87068 134.2 7.83631 134.2 7.87068Z",
    fill: "url(#paint247_linear_7270_1548)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M134.063 7.80176C134.063 7.80176 134.029 7.83613 133.994 7.83613C134.063 7.80176 134.063 7.80176 134.063 7.80176Z",
    fill: "url(#paint248_linear_7270_1548)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M134.099 7.83594C134.03 7.87031 134.099 7.87031 134.099 7.83594V7.83594Z",
    fill: "url(#paint249_linear_7270_1548)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M134.477 8.38593L134.545 8.35156H134.58C134.58 8.35156 134.545 8.38593 134.477 8.38593C134.511 8.42031 134.477 8.42031 134.477 8.38593C134.477 8.42031 134.477 8.42031 134.477 8.38593Z",
    fill: "url(#paint250_linear_7270_1548)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M133.893 7.97368V7.93931C133.893 7.90494 133.927 7.97368 133.893 7.97368Z",
    fill: "url(#paint251_linear_7270_1548)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M133.857 8.17974C133.857 8.17974 133.926 8.11099 133.926 8.14537C133.926 8.17974 133.892 8.17974 133.857 8.17974Z",
    fill: "url(#paint252_linear_7270_1548)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M134.098 8.55859C134.064 8.55859 134.064 8.59297 134.029 8.59297C134.029 8.5586 134.098 8.55859 134.098 8.55859Z",
    fill: "url(#paint253_linear_7270_1548)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M133.514 8.17988C133.514 8.14551 133.514 8.14551 133.582 8.14551C133.548 8.14551 133.548 8.17988 133.514 8.17988Z",
    fill: "url(#paint254_linear_7270_1548)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M133.926 8.66152C133.926 8.66152 133.96 8.62715 133.995 8.59277C133.96 8.62715 133.96 8.66152 133.926 8.66152Z",
    fill: "url(#paint255_linear_7270_1548)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M133.994 8.69539C133.925 8.72977 133.891 8.76414 133.822 8.79851C133.857 8.76414 133.96 8.66102 133.994 8.69539Z",
    fill: "url(#paint256_linear_7270_1548)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M133.994 8.8332C133.994 8.8332 134.029 8.79883 134.063 8.79883C134.029 8.79883 134.029 8.8332 133.994 8.8332Z",
    fill: "url(#paint257_linear_7270_1548)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M133.788 8.90234C133.72 8.93672 133.651 9.00546 133.582 9.00546C133.685 8.97109 133.72 8.90234 133.788 8.90234Z",
    fill: "url(#paint258_linear_7270_1548)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M133.136 8.35175C133.136 8.35175 133.102 8.35175 133.136 8.31738V8.35175Z",
    fill: "url(#paint259_linear_7270_1548)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M133.032 8.28285C133.032 8.24848 132.998 8.28285 132.998 8.28285C132.998 8.28285 132.998 8.24848 133.032 8.28285C133.032 8.24848 133.032 8.21411 133.032 8.28285Z",
    fill: "url(#paint260_linear_7270_1548)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M133.686 8.90234L133.617 8.93672C133.652 8.97109 133.686 8.90234 133.686 8.90234Z",
    fill: "url(#paint261_linear_7270_1548)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M133.101 8.45547C133.067 8.45547 133.101 8.42109 133.101 8.45547C133.101 8.42109 133.136 8.42109 133.101 8.45547Z",
    fill: "url(#paint262_linear_7270_1548)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M132.862 8.4209C132.827 8.45527 132.827 8.4209 132.793 8.4209C132.862 8.4209 132.862 8.4209 132.862 8.4209Z",
    fill: "url(#paint263_linear_7270_1548)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M132.758 8.38672C132.724 8.38672 132.689 8.42109 132.689 8.45546C132.689 8.42109 132.724 8.42109 132.758 8.38672Z",
    fill: "url(#paint264_linear_7270_1548)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M144.341 4.26137C144.341 4.26137 144.238 4.29574 144.238 4.26137C144.238 4.26137 144.273 4.227 144.273 4.26137H144.238C144.273 4.26137 144.376 4.26137 144.341 4.26137Z",
    fill: "url(#paint265_linear_7270_1548)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M143.653 4.43379C143.653 4.43379 143.721 4.43379 143.687 4.43379C143.687 4.39941 143.653 4.43379 143.653 4.43379C143.653 4.43379 143.618 4.43379 143.584 4.43379C143.618 4.43379 143.653 4.39941 143.687 4.39941C143.653 4.39941 143.653 4.39941 143.653 4.43379Z",
    fill: "url(#paint266_linear_7270_1548)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M143.345 3.23012C143.345 3.23012 143.448 3.19575 143.414 3.23012C143.414 3.23012 143.311 3.26449 143.345 3.23012Z",
    fill: "url(#paint267_linear_7270_1548)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M143.104 3.29902C143.138 3.29902 143.207 3.26465 143.172 3.29902C143.207 3.29902 143.207 3.26465 143.241 3.26465C143.276 3.26465 143.276 3.26465 143.31 3.26465C143.207 3.26465 143.138 3.29902 143.104 3.29902C143.138 3.29902 143.069 3.33339 143.104 3.29902Z",
    fill: "url(#paint268_linear_7270_1548)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M143.035 4.50252C143 4.50252 142.932 4.53689 142.932 4.53689C142.966 4.50252 143.035 4.46815 143.035 4.50252Z",
    fill: "url(#paint269_linear_7270_1548)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M142.862 4.53676C142.828 4.57113 142.794 4.57113 142.759 4.57113C142.725 4.57113 142.691 4.63987 142.656 4.6055C142.691 4.57113 142.725 4.57113 142.759 4.57113C142.759 4.57113 142.759 4.57113 142.794 4.57113H142.759C142.828 4.57113 142.897 4.53676 142.897 4.53676C142.897 4.46802 142.897 4.50239 142.862 4.53676C142.897 4.50239 142.862 4.50239 142.862 4.53676Z",
    fill: "url(#paint270_linear_7270_1548)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M141.214 4.1584C141.214 4.12402 141.214 4.12402 141.214 4.1584C141.18 4.12402 141.18 4.1584 141.18 4.1584L141.248 4.12402C141.248 4.12402 141.248 4.12402 141.214 4.1584C141.248 4.12402 141.214 4.12402 141.214 4.1584Z",
    fill: "url(#paint271_linear_7270_1548)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M141.076 4.1584C141.076 4.12402 141.179 4.12402 141.248 4.12402C141.214 4.12402 141.179 4.1584 141.145 4.19277C141.111 4.1584 141.145 4.12402 141.076 4.1584Z",
    fill: "url(#paint272_linear_7270_1548)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M140.869 4.22695L140.938 4.19257C140.938 4.22695 141.007 4.1582 141.041 4.1582C141.007 4.19257 141.007 4.19257 141.007 4.22695C140.972 4.22695 140.972 4.22695 141.007 4.19257C140.972 4.19257 140.938 4.19257 140.904 4.22695H140.938C140.904 4.22695 140.835 4.26132 140.869 4.22695C140.904 4.22695 140.835 4.22695 140.869 4.22695Z",
    fill: "url(#paint273_linear_7270_1548)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M140.904 3.98633C140.835 4.0207 140.801 4.05507 140.732 4.08944C140.732 4.05507 140.663 4.08944 140.629 4.12381C140.698 4.08944 140.732 4.05507 140.835 4.0207L140.766 4.05507C140.801 4.0207 140.835 3.98633 140.904 3.98633Z",
    fill: "url(#paint274_linear_7270_1548)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M140.905 4.60586C140.905 4.60586 140.87 4.60586 140.836 4.60586C140.87 4.60586 140.87 4.57149 140.905 4.60586C140.905 4.57149 140.905 4.57149 140.905 4.60586Z",
    fill: "url(#paint275_linear_7270_1548)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M140.492 4.46816C140.492 4.46816 140.492 4.43379 140.527 4.43379C140.527 4.43379 140.527 4.43379 140.492 4.46816C140.561 4.43379 140.595 4.43379 140.595 4.43379C140.63 4.43379 140.63 4.43379 140.698 4.39941C140.698 4.39941 140.733 4.43379 140.698 4.43379C140.63 4.43379 140.595 4.46816 140.492 4.46816C140.561 4.43379 140.527 4.46816 140.492 4.46816Z",
    fill: "url(#paint276_linear_7270_1548)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M140.525 4.2621C140.525 4.22773 140.491 4.2621 140.525 4.22773C140.525 4.22773 140.559 4.22773 140.594 4.22773C140.559 4.22773 140.525 4.22773 140.525 4.2621C140.559 4.22773 140.559 4.22773 140.594 4.22773C140.594 4.22773 140.628 4.22773 140.628 4.19336C140.663 4.22773 140.594 4.2621 140.525 4.2621Z",
    fill: "url(#paint277_linear_7270_1548)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M140.388 4.50258C140.354 4.50258 140.388 4.46821 140.388 4.50258V4.50258Z",
    fill: "url(#paint278_linear_7270_1548)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M140.285 4.36523C140.216 4.36523 140.319 4.36523 140.25 4.39961C140.216 4.39961 140.216 4.39961 140.182 4.39961C140.182 4.39961 140.182 4.39961 140.182 4.36523C140.216 4.36523 140.319 4.36523 140.285 4.36523Z",
    fill: "url(#paint279_linear_7270_1548)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M140.113 4.60585C140.216 4.57148 140.216 4.53711 140.32 4.53711C140.285 4.53711 140.32 4.57148 140.285 4.57148C140.216 4.57148 140.148 4.60585 140.113 4.60585Z",
    fill: "url(#paint280_linear_7270_1548)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M140.113 4.43359C140.182 4.43359 140.216 4.43359 140.216 4.43359L140.148 4.46796C140.148 4.46796 140.113 4.46797 140.113 4.43359C140.113 4.46797 140.113 4.46797 140.113 4.43359Z",
    fill: "url(#paint281_linear_7270_1548)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M139.391 4.74301C139.357 4.74301 139.357 4.77738 139.391 4.74301C139.357 4.70864 139.322 4.74301 139.322 4.74301L139.357 4.70864H139.322C139.357 4.67426 139.357 4.70864 139.391 4.70864C139.391 4.74301 139.357 4.74301 139.391 4.74301Z",
    fill: "url(#paint282_linear_7270_1548)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M139.289 4.94922C139.254 4.94922 139.254 4.94922 139.22 4.98359H139.186C139.22 4.94922 139.254 4.94922 139.289 4.94922Z",
    fill: "url(#paint283_linear_7270_1548)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M139.082 4.94922C139.082 4.98359 138.945 5.01796 138.91 5.01796C138.945 5.01796 138.945 4.98359 138.979 4.98359C138.979 4.98359 138.979 4.94922 139.013 4.94922C139.013 4.98359 139.116 4.94922 139.082 4.94922Z",
    fill: "url(#paint284_linear_7270_1548)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M138.945 4.91425C138.979 4.91425 138.979 4.91425 138.945 4.91425C138.91 4.91425 138.91 4.91425 138.945 4.91425C138.945 4.91425 138.979 4.87988 139.013 4.87988C139.013 4.87988 138.979 4.91425 138.945 4.91425Z",
    fill: "url(#paint285_linear_7270_1548)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M138.773 5.22402C138.808 5.22402 138.773 5.18965 138.808 5.15527C138.842 5.15527 138.808 5.22402 138.773 5.22402Z",
    fill: "url(#paint286_linear_7270_1548)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M138.773 5.08691C138.773 5.08691 138.773 5.12129 138.738 5.12129C138.807 5.12129 138.704 5.12129 138.773 5.08691C138.738 5.12129 138.738 5.12129 138.773 5.08691Z",
    fill: "url(#paint287_linear_7270_1548)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M138.601 5.05176C138.601 5.08613 138.635 5.1205 138.601 5.1205C138.601 5.08613 138.429 5.15487 138.395 5.15487C138.395 5.1205 138.498 5.05176 138.601 5.05176Z",
    fill: "url(#paint288_linear_7270_1548)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M138.463 5.1895C138.463 5.1895 138.532 5.12076 138.497 5.15513C138.497 5.1895 138.497 5.15513 138.463 5.1895Z",
    fill: "url(#paint289_linear_7270_1548)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M138.429 5.12109C138.429 5.12109 138.395 5.12109 138.395 5.15546C138.395 5.18984 138.464 5.12109 138.498 5.12109C138.395 5.18984 138.292 5.18984 138.292 5.22421C138.292 5.22421 138.257 5.22421 138.223 5.22421C138.086 5.32732 137.948 5.36169 137.811 5.43044C137.914 5.39607 137.982 5.32732 138.086 5.32732C138.086 5.32732 138.086 5.32732 138.12 5.29295C138.189 5.25858 138.292 5.15547 138.429 5.12109Z",
    fill: "url(#paint290_linear_7270_1548)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M138.189 5.32713C138.223 5.29276 138.258 5.25839 138.292 5.25839C138.258 5.25839 138.327 5.22402 138.327 5.22402C138.361 5.18965 138.395 5.15527 138.43 5.15527C138.43 5.18965 138.43 5.15527 138.464 5.15527C138.43 5.18965 138.43 5.15527 138.361 5.18965C138.395 5.18965 138.258 5.25839 138.258 5.25839C138.258 5.25839 138.258 5.25839 138.223 5.25839C138.223 5.32713 138.258 5.29276 138.189 5.32713Z",
    fill: "url(#paint291_linear_7270_1548)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M138.016 5.60195C137.981 5.63632 137.912 5.63632 137.912 5.67069C137.912 5.67069 137.912 5.67069 137.878 5.67069C137.741 5.67069 137.637 5.7738 137.5 5.84255C137.5 5.80818 137.534 5.80818 137.569 5.80818L137.741 5.70506C137.809 5.67069 137.844 5.63632 137.912 5.63632C137.878 5.63632 137.878 5.63632 137.878 5.60195C137.947 5.60195 137.981 5.56757 138.05 5.5332C138.05 5.5332 138.084 5.5332 138.05 5.56757C138.05 5.56757 137.912 5.60195 137.947 5.63632C137.981 5.63632 138.05 5.60195 138.119 5.56757C138.119 5.60195 138.119 5.60195 138.119 5.63632C138.084 5.56757 138.016 5.60195 138.016 5.60195Z",
    fill: "url(#paint292_linear_7270_1548)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M137.775 5.3957C137.809 5.3957 137.809 5.3957 137.844 5.36133C137.844 5.3957 137.741 5.43007 137.672 5.43007C137.741 5.3957 137.775 5.43007 137.775 5.3957Z",
    fill: "url(#paint293_linear_7270_1548)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M137.639 5.49941C137.707 5.49941 137.742 5.43066 137.776 5.43066C137.742 5.43066 137.742 5.46504 137.673 5.46504C137.707 5.46504 137.639 5.53378 137.639 5.49941Z",
    fill: "url(#paint294_linear_7270_1548)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M137.638 5.49941C137.707 5.46504 137.707 5.46504 137.741 5.43066C137.741 5.46504 137.638 5.49941 137.638 5.49941C137.604 5.49941 137.604 5.53378 137.604 5.53378C137.604 5.53378 137.604 5.53378 137.604 5.49941C137.57 5.49941 137.57 5.53378 137.535 5.49941C137.57 5.53378 137.604 5.49941 137.638 5.49941C137.604 5.49941 137.604 5.49941 137.638 5.49941C137.638 5.46504 137.604 5.53378 137.638 5.49941Z",
    fill: "url(#paint295_linear_7270_1548)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M137.432 5.6024C137.398 5.63677 137.432 5.63677 137.398 5.67114C137.398 5.67114 137.398 5.67114 137.432 5.67114C137.467 5.63677 137.467 5.63677 137.432 5.6024C137.432 5.67114 137.501 5.63677 137.432 5.70551C137.364 5.70551 137.329 5.77426 137.295 5.73988C137.398 5.67114 137.398 5.63677 137.398 5.63677C137.398 5.63677 137.432 5.56803 137.432 5.6024Z",
    fill: "url(#paint296_linear_7270_1548)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M137.192 5.73941C137.192 5.77379 137.226 5.70504 137.261 5.73941C137.226 5.73941 137.157 5.80816 137.123 5.80816C137.157 5.73941 137.157 5.73941 137.192 5.73941Z",
    fill: "url(#paint297_linear_7270_1548)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M137.191 5.77441C137.191 5.80879 137.26 5.77441 137.191 5.77441C137.191 5.80879 137.191 5.84316 137.191 5.77441C137.191 5.80879 137.191 5.80879 137.191 5.77441Z",
    fill: "url(#paint298_linear_7270_1548)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M136.641 6.04941C136.745 6.01503 136.848 5.94629 136.882 5.94629C136.882 5.94629 136.882 5.94629 136.848 5.94629C136.848 5.94629 136.848 5.94629 136.848 5.98066C136.848 5.98066 136.813 6.01503 136.779 6.01503C136.745 6.01503 136.607 6.08378 136.538 6.11815C136.504 6.11815 136.573 6.11815 136.538 6.08378C136.538 6.08378 136.538 6.08378 136.504 6.08378C136.538 6.11815 136.573 6.08378 136.641 6.04941C136.607 6.04941 136.607 6.04941 136.641 6.04941Z",
    fill: "url(#paint299_linear_7270_1548)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M136.641 6.32361C136.641 6.35798 136.573 6.32361 136.573 6.35798C136.573 6.35798 136.607 6.35798 136.641 6.32361C136.573 6.35798 136.538 6.39235 136.504 6.39235C136.573 6.39235 136.538 6.35798 136.504 6.35798C136.538 6.32361 136.641 6.32361 136.676 6.28924C136.641 6.28924 136.607 6.28924 136.573 6.28924C136.573 6.28924 136.607 6.28924 136.607 6.25487C136.573 6.25487 136.538 6.28924 136.504 6.25487C136.504 6.28924 136.435 6.28924 136.366 6.35798C136.298 6.39235 136.229 6.4611 136.16 6.4611C136.126 6.49547 135.954 6.56421 135.92 6.63295C135.92 6.63295 135.92 6.63295 135.885 6.63295C135.92 6.59858 135.816 6.66733 135.851 6.63295C135.885 6.63295 135.92 6.59858 135.954 6.56421C136.057 6.56421 136.16 6.42672 136.229 6.42672C136.263 6.42672 136.298 6.39235 136.332 6.35798C136.366 6.32361 136.332 6.35798 136.366 6.35798C136.366 6.32361 136.401 6.35798 136.435 6.32361C136.504 6.25487 136.573 6.22049 136.676 6.18612C136.676 6.18612 136.676 6.18612 136.71 6.15175C136.745 6.15175 136.813 6.15175 136.779 6.15175C136.779 6.15175 136.779 6.15175 136.745 6.15175C136.745 6.15175 136.71 6.15175 136.745 6.18612C136.745 6.18612 136.813 6.15175 136.813 6.18612C136.813 6.18612 136.779 6.18612 136.779 6.22049C136.813 6.22049 136.813 6.22049 136.848 6.18612C136.848 6.15175 136.916 6.15175 136.951 6.08301H136.985C136.951 6.08301 136.916 6.11738 136.951 6.15175C136.779 6.25487 136.71 6.28924 136.641 6.32361C136.676 6.32361 136.607 6.35798 136.641 6.32361Z",
    fill: "url(#paint300_linear_7270_1548)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M136.539 6.49548C136.573 6.42674 136.814 6.39237 136.814 6.32363C136.883 6.32363 136.952 6.25488 136.986 6.25488C136.917 6.28925 136.848 6.32363 136.78 6.358C136.677 6.39237 136.608 6.46111 136.539 6.49548Z",
    fill: "url(#paint301_linear_7270_1548)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M136.47 6.22128C136.505 6.18691 136.505 6.22128 136.539 6.18691C136.539 6.18691 136.573 6.18691 136.642 6.18691C136.642 6.18691 136.677 6.18691 136.711 6.15254C136.711 6.15254 136.78 6.15254 136.78 6.11816C136.745 6.15254 136.608 6.22128 136.539 6.25565C136.573 6.22128 136.505 6.22128 136.47 6.22128C136.47 6.25565 136.539 6.22128 136.505 6.22128C136.505 6.25565 136.539 6.25565 136.47 6.22128C136.47 6.25565 136.436 6.29002 136.367 6.32439C136.367 6.29002 136.539 6.25565 136.47 6.22128Z",
    fill: "url(#paint302_linear_7270_1548)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M136.779 6.15234C136.744 6.15234 136.744 6.18671 136.744 6.18671L136.779 6.15234H136.744C136.779 6.15234 136.779 6.15234 136.779 6.15234Z",
    fill: "url(#paint303_linear_7270_1548)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M136.471 6.15234C136.436 6.18672 136.368 6.22109 136.299 6.22109C136.368 6.18672 136.402 6.15234 136.471 6.15234Z",
    fill: "url(#paint304_linear_7270_1548)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M135.886 6.46191C135.852 6.46191 135.817 6.49629 135.783 6.53066C135.817 6.53066 135.783 6.56503 135.817 6.53066C135.783 6.53066 135.714 6.56503 135.783 6.53066C135.783 6.53066 135.748 6.53066 135.714 6.53066C135.714 6.53066 135.714 6.53066 135.714 6.56503C135.714 6.56503 135.783 6.53066 135.748 6.56503C135.748 6.56503 135.714 6.5994 135.68 6.5994C135.714 6.53066 135.852 6.46191 135.886 6.46191Z",
    fill: "url(#paint305_linear_7270_1548)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M135.747 6.77089H135.713C135.713 6.73652 135.747 6.73652 135.782 6.70215C135.782 6.73652 135.747 6.73652 135.747 6.77089Z",
    fill: "url(#paint306_linear_7270_1548)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M135.336 6.97674C135.336 6.97674 135.336 6.97674 135.37 6.94237C135.473 6.90799 135.542 6.83925 135.645 6.77051H135.68C135.577 6.83925 135.508 6.87362 135.405 6.90799C135.405 6.94237 135.37 6.94237 135.336 6.97674Z",
    fill: "url(#paint307_linear_7270_1548)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M135.507 6.70175C135.542 6.70175 135.542 6.66738 135.542 6.66738C135.576 6.633 135.645 6.59863 135.645 6.59863C135.611 6.59863 135.542 6.633 135.542 6.66738C135.576 6.633 135.542 6.70175 135.542 6.70175C135.542 6.66738 135.507 6.70175 135.507 6.70175C135.507 6.66738 135.473 6.70175 135.507 6.70175C135.542 6.66738 135.473 6.66738 135.507 6.70175Z",
    fill: "url(#paint308_linear_7270_1548)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M135.748 6.9082C135.679 6.94257 135.61 6.97695 135.541 7.01132C135.507 7.01132 135.473 7.04569 135.438 7.04569C135.37 7.08006 135.301 7.1488 135.232 7.1488C135.232 7.1488 135.232 7.1488 135.266 7.1488L135.232 7.18318C135.232 7.21755 135.129 7.25192 135.129 7.28629C135.232 7.21755 135.335 7.18318 135.438 7.11443C135.507 7.04569 135.644 6.97695 135.748 6.9082ZM135.301 7.1488C135.335 7.1488 135.335 7.1488 135.301 7.1488V7.1488Z",
    fill: "url(#paint309_linear_7270_1548)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M135.473 7.21796C135.507 7.18359 135.541 7.18359 135.576 7.18359L135.541 7.21796C135.541 7.14922 135.507 7.21796 135.473 7.21796Z",
    fill: "url(#paint310_linear_7270_1548)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M135.197 6.77066C135.163 6.80504 135.232 6.73629 135.197 6.77066H135.232C135.266 6.77066 135.232 6.77066 135.197 6.77066Z",
    fill: "url(#paint311_linear_7270_1548)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M135.268 7.08039C135.336 7.01164 135.405 7.01164 135.371 7.04601C135.336 7.04601 135.371 7.04601 135.336 7.04601C135.336 7.04601 135.336 7.04602 135.302 7.08039C135.268 7.14913 135.164 7.14913 135.096 7.1835C135.096 7.1835 135.096 7.1835 135.096 7.14913C135.096 7.1835 135.13 7.11476 135.096 7.14913C135.096 7.14913 135.096 7.11476 135.13 7.11476C135.13 7.11476 135.13 7.11476 135.164 7.11476C135.199 7.11476 135.302 7.08039 135.268 7.08039C135.302 7.08039 135.302 7.04602 135.268 7.08039Z",
    fill: "url(#paint312_linear_7270_1548)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M135.164 7.07987C135.13 7.07987 135.095 7.11424 135.095 7.11424C135.061 7.11424 134.992 7.18298 134.992 7.14861C135.095 7.07987 135.198 7.01113 135.302 6.94238C135.267 7.01113 135.198 7.01113 135.164 7.07987Z",
    fill: "url(#paint313_linear_7270_1548)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M135.061 6.94238C135.061 6.94238 135.027 6.97675 134.992 6.94238C135.061 6.94238 135.061 6.94238 135.061 6.94238Z",
    fill: "url(#paint314_linear_7270_1548)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M135.163 7.32059H135.129C135.129 7.32059 135.163 7.25185 135.163 7.32059C135.198 7.28622 135.129 7.32059 135.163 7.32059Z",
    fill: "url(#paint315_linear_7270_1548)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M135.095 7.18359C135.095 7.18359 135.061 7.21797 135.027 7.25234C135.061 7.25234 135.095 7.21797 135.095 7.18359C135.061 7.21797 135.061 7.25234 135.061 7.25234C135.061 7.25234 135.027 7.25234 134.992 7.25234C135.027 7.25234 135.061 7.18359 135.095 7.18359Z",
    fill: "url(#paint316_linear_7270_1548)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M135.268 7.90547C135.302 7.90547 135.302 7.90547 135.302 7.87109C135.336 7.87109 135.302 7.8711 135.268 7.90547Z",
    fill: "url(#paint317_linear_7270_1548)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M134.545 7.49238C134.545 7.49238 134.545 7.45801 134.51 7.49238C134.476 7.52675 134.441 7.56112 134.441 7.52675C134.476 7.49238 134.51 7.49238 134.545 7.45801C134.51 7.49238 134.579 7.45801 134.545 7.49238Z",
    fill: "url(#paint318_linear_7270_1548)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M134.855 8.18031C134.821 8.14594 134.958 8.11157 134.89 8.18031C134.89 8.18031 134.924 8.14594 134.855 8.18031C134.89 8.14594 134.855 8.14594 134.855 8.18031Z",
    fill: "url(#paint319_linear_7270_1548)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M134.716 8.21392C134.785 8.21392 134.819 8.14517 134.853 8.17955C134.819 8.21392 134.785 8.17955 134.819 8.21392C134.785 8.21392 134.75 8.24829 134.682 8.28266C134.682 8.24829 134.75 8.21392 134.716 8.21392Z",
    fill: "url(#paint320_linear_7270_1548)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M133.754 8.83301C133.685 8.86738 133.651 8.90175 133.582 8.93612C133.616 8.90175 133.685 8.86738 133.754 8.83301Z",
    fill: "url(#paint321_linear_7270_1548)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M133.549 8.90176C133.583 8.86738 133.583 8.86738 133.549 8.90176C133.549 8.86738 133.583 8.90176 133.549 8.90176Z",
    fill: "url(#paint322_linear_7270_1548)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M149.188 3.47126H149.222C149.154 3.47126 149.154 3.47126 149.119 3.47126C149.154 3.43689 149.119 3.47126 149.119 3.43689C149.119 3.40252 149.222 3.33378 149.222 3.29941C149.222 3.26503 149.325 3.23066 149.257 3.19629C149.36 3.19629 149.325 3.23066 149.291 3.26503C149.291 3.26503 149.325 3.33378 149.291 3.33378H149.325C149.325 3.33378 149.257 3.33378 149.291 3.36815H149.257C149.222 3.43689 149.188 3.43689 149.188 3.47126Z",
    fill: "url(#paint323_linear_7270_1548)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M143.86 4.33046C143.894 4.33046 143.894 4.33046 143.929 4.33046C143.894 4.33046 143.825 4.33046 143.791 4.33046C143.825 4.33046 143.894 4.29609 143.929 4.29609C143.894 4.29609 143.894 4.29609 143.86 4.33046C143.894 4.33046 143.963 4.29609 143.963 4.26172C143.963 4.29609 143.997 4.26172 143.997 4.26172C143.997 4.26172 143.963 4.26172 143.929 4.29609C143.929 4.29609 143.928 4.29609 143.86 4.33046Z",
    fill: "url(#paint324_linear_7270_1548)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M143.482 4.36508C143.414 4.36508 143.345 4.39945 143.311 4.36508C143.345 4.36508 143.379 4.36508 143.414 4.33071C143.448 4.33071 143.517 4.29633 143.517 4.33071C143.482 4.36508 143.517 4.36508 143.482 4.36508Z",
    fill: "url(#paint325_linear_7270_1548)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M138.911 5.05233C138.911 5.05233 138.877 5.05233 138.842 5.05233C138.842 5.05233 138.877 5.05233 138.877 5.01796C138.842 5.01796 138.842 5.05233 138.808 5.01796C138.808 5.01796 138.842 5.01796 138.842 4.98359C138.808 4.98359 138.808 5.01796 138.773 4.98359C138.808 4.98359 138.842 4.94922 138.877 4.94922C138.842 5.05233 138.945 5.01796 138.911 5.05233Z",
    fill: "url(#paint326_linear_7270_1548)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M138.084 5.32734C138.119 5.32734 138.119 5.29297 138.153 5.29297C138.119 5.29297 138.119 5.32734 138.153 5.32734C138.119 5.32734 138.119 5.32734 138.119 5.36171C138.119 5.36171 138.084 5.36171 138.05 5.36171C138.05 5.39608 137.981 5.39608 137.981 5.39608C137.912 5.43046 137.844 5.46483 137.775 5.4992C137.775 5.4992 137.775 5.4992 137.775 5.53357C137.741 5.53357 137.672 5.56794 137.672 5.56794C137.741 5.56794 137.775 5.53357 137.844 5.46483C137.844 5.46483 137.844 5.46483 137.878 5.46483C137.878 5.4992 137.947 5.46483 137.981 5.43045H137.947C137.981 5.39608 138.084 5.39608 138.084 5.32734Z",
    fill: "url(#paint327_linear_7270_1548)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M135.026 7.28613C134.957 7.35488 134.888 7.35488 134.819 7.42362C134.819 7.45799 134.751 7.45799 134.716 7.49236C134.682 7.49236 134.716 7.52673 134.682 7.52673C134.647 7.52673 134.613 7.56111 134.579 7.56111C134.544 7.56111 134.579 7.52673 134.613 7.49236C134.647 7.49236 134.613 7.49236 134.647 7.49236C134.647 7.49236 134.716 7.42362 134.682 7.45799C134.785 7.45799 134.819 7.35488 134.922 7.3205C134.922 7.3205 134.957 7.28613 135.026 7.28613Z",
    fill: "url(#paint328_linear_7270_1548)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M151.524 2.74921C151.558 2.74921 151.524 2.74921 151.558 2.74921C151.524 2.74921 151.558 2.74922 151.558 2.71484C151.593 2.71484 151.558 2.74921 151.558 2.74921C151.524 2.78359 151.49 2.78359 151.524 2.74921Z",
    fill: "url(#paint329_linear_7270_1548)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M151.869 1.82129C151.904 1.82129 151.904 1.82129 151.869 1.85566V1.82129Z",
    fill: "url(#paint330_linear_7270_1548)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M151.594 2.40527C151.594 2.40527 151.662 2.40527 151.628 2.40527C151.594 2.43965 151.594 2.40527 151.594 2.40527Z",
    fill: "url(#paint331_linear_7270_1548)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M151.662 2.16542C151.662 2.13105 151.696 2.16542 151.696 2.13105C151.662 2.13105 151.662 2.13105 151.662 2.09668C151.696 2.09668 151.696 2.09668 151.731 2.09668C151.731 2.09668 151.696 2.13105 151.731 2.13105C151.696 2.19979 151.696 2.16542 151.662 2.16542Z",
    fill: "url(#paint332_linear_7270_1548)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M151.627 2.43945C151.627 2.43945 151.593 2.43945 151.559 2.47382C151.559 2.43945 151.593 2.43945 151.627 2.43945Z",
    fill: "url(#paint333_linear_7270_1548)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M151.661 2.33691C151.661 2.33691 151.661 2.37129 151.627 2.37129C151.627 2.37129 151.627 2.33691 151.661 2.33691Z",
    fill: "url(#paint334_linear_7270_1548)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M151.352 2.88711C151.318 2.88711 151.318 2.88711 151.352 2.88711C151.318 2.85274 151.352 2.85274 151.352 2.88711Z",
    fill: "url(#paint335_linear_7270_1548)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M151.353 2.74965C151.353 2.74965 151.284 2.78402 151.318 2.74965C151.353 2.71528 151.318 2.74965 151.353 2.74965Z",
    fill: "url(#paint336_linear_7270_1548)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M151.319 2.74902C151.285 2.7834 151.319 2.81777 151.319 2.85214C151.285 2.85214 151.25 2.88651 151.216 2.92088C151.182 2.85214 151.216 2.74902 151.319 2.74902Z",
    fill: "url(#paint337_linear_7270_1548)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M151.49 1.75223C151.525 1.71786 151.525 1.75223 151.49 1.75223C151.525 1.68349 151.525 1.75223 151.525 1.75223C151.525 1.75223 151.525 1.75223 151.49 1.75223Z",
    fill: "url(#paint338_linear_7270_1548)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M150.596 2.98989C150.664 2.95551 150.63 2.98989 150.63 2.98989H150.596Z",
    fill: "url(#paint339_linear_7270_1548)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M150.494 2.95508C150.494 3.02382 150.563 2.95508 150.494 2.95508V2.95508Z",
    fill: "url(#paint340_linear_7270_1548)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M143.928 3.05879C143.996 3.05879 143.962 3.05879 144.031 3.02441C144.031 3.05879 144.065 3.02441 144.031 3.02441C143.996 3.02441 143.928 3.09316 143.928 3.05879Z",
    fill: "url(#paint341_linear_7270_1548)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M143.276 2.61172C143.242 2.64609 143.173 2.64609 143.139 2.64609C143.173 2.61172 143.242 2.61172 143.276 2.61172C143.276 2.57734 143.276 2.57734 143.276 2.61172Z",
    fill: "url(#paint342_linear_7270_1548)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M142.828 2.81801C142.897 2.81801 142.931 2.78364 142.966 2.81801C142.931 2.78364 142.862 2.81801 142.828 2.81801Z",
    fill: "url(#paint343_linear_7270_1548)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M142.76 2.81801C142.76 2.81801 142.829 2.78364 142.829 2.81801C142.794 2.81801 142.76 2.81801 142.76 2.81801Z",
    fill: "url(#paint344_linear_7270_1548)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M142.451 2.92153C142.451 2.92153 142.52 2.88715 142.52 2.92153C142.486 2.92153 142.486 2.92153 142.451 2.92153Z",
    fill: "url(#paint345_linear_7270_1548)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M142.381 2.98965C142.381 2.95527 142.45 2.95527 142.381 2.98965C142.415 2.95527 142.415 2.98965 142.381 2.98965Z",
    fill: "url(#paint346_linear_7270_1548)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M142.244 3.6084C142.244 3.64277 142.313 3.6084 142.244 3.6084C142.244 3.64277 142.279 3.64277 142.244 3.6084Z",
    fill: "url(#paint347_linear_7270_1548)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M142.004 3.71132C142.038 3.71132 142.038 3.71132 142.004 3.71132C142.107 3.71132 142.176 3.71132 142.245 3.64258C142.141 3.64258 142.107 3.67695 142.004 3.71132C142.073 3.71132 142.107 3.67695 142.141 3.64258C142.141 3.71132 142.038 3.71132 142.004 3.71132ZM142.21 3.67695H142.176C142.176 3.67695 142.21 3.64258 142.21 3.67695Z",
    fill: "url(#paint348_linear_7270_1548)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M142.072 3.02441C142.038 3.02441 142.038 3.02441 142.072 3.02441C142.004 3.02441 141.969 3.05879 141.9 3.05879C141.935 3.05879 142.072 3.02441 142.072 3.02441Z",
    fill: "url(#paint349_linear_7270_1548)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M142.037 3.64258H142.071C142.071 3.67695 142.071 3.64258 142.037 3.64258Z",
    fill: "url(#paint350_linear_7270_1548)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M141.592 3.16132L141.626 3.12695C141.592 3.16132 141.626 3.16132 141.592 3.16132Z",
    fill: "url(#paint351_linear_7270_1548)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M141.18 3.3332C141.214 3.3332 141.283 3.29883 141.352 3.29883C141.317 3.3332 141.214 3.36757 141.18 3.3332Z",
    fill: "url(#paint352_linear_7270_1548)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M141.075 3.53969C141.041 3.53969 140.972 3.57406 140.938 3.57406C141.006 3.53969 141.006 3.53969 141.075 3.53969Z",
    fill: "url(#paint353_linear_7270_1548)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M140.87 3.40234C140.835 3.40234 140.801 3.40234 140.801 3.43671L140.87 3.40234Z",
    fill: "url(#paint354_linear_7270_1548)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M140.801 3.60824C140.835 3.60824 140.801 3.60824 140.835 3.57387C140.87 3.5395 140.87 3.57387 140.87 3.57387C140.87 3.60824 140.835 3.60824 140.801 3.60824Z",
    fill: "url(#paint355_linear_7270_1548)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M140.8 3.71211C140.8 3.67773 140.835 3.67773 140.869 3.67773C140.8 3.67773 140.8 3.71211 140.8 3.71211Z",
    fill: "url(#paint356_linear_7270_1548)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M140.8 3.71211C140.869 3.71211 140.903 3.67773 140.938 3.67773L140.903 3.71211C140.869 3.71211 140.8 3.74648 140.8 3.71211C140.766 3.74648 140.766 3.74648 140.732 3.74648H140.697C140.697 3.74648 140.732 3.74648 140.732 3.71211C140.766 3.71211 140.8 3.71211 140.8 3.71211Z",
    fill: "url(#paint357_linear_7270_1548)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M140.87 4.26137C140.87 4.26137 140.836 4.29574 140.836 4.26137C140.836 4.227 140.87 4.26137 140.87 4.26137Z",
    fill: "url(#paint358_linear_7270_1548)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M140.8 4.2959L140.697 4.33027C140.697 4.33027 140.766 4.2959 140.8 4.2959Z",
    fill: "url(#paint359_linear_7270_1548)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M140.561 3.57422C140.526 3.57422 140.457 3.60859 140.492 3.57422C140.492 3.60859 140.526 3.57422 140.561 3.57422Z",
    fill: "url(#paint360_linear_7270_1548)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M140.525 4.12367C140.56 4.12367 140.594 4.0893 140.594 4.12367C140.594 4.12367 140.56 4.12367 140.525 4.12367Z",
    fill: "url(#paint361_linear_7270_1548)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M140.422 3.53969C140.422 3.53969 140.456 3.50532 140.456 3.53969C140.456 3.53969 140.422 3.57406 140.422 3.53969Z",
    fill: "url(#paint362_linear_7270_1548)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M140.422 3.77992C140.422 3.77992 140.354 3.8143 140.354 3.77992C140.388 3.77992 140.388 3.74555 140.422 3.77992Z",
    fill: "url(#paint363_linear_7270_1548)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M140.456 4.43359C140.456 4.43359 140.422 4.46797 140.422 4.43359H140.456Z",
    fill: "url(#paint364_linear_7270_1548)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M140.423 4.43359C140.389 4.46797 140.32 4.46797 140.32 4.43359C140.355 4.43359 140.389 4.43359 140.423 4.43359Z",
    fill: "url(#paint365_linear_7270_1548)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M140.217 3.71157C140.183 3.71157 140.148 3.71157 140.148 3.71157C140.183 3.67719 140.183 3.71157 140.217 3.71157Z",
    fill: "url(#paint366_linear_7270_1548)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M139.977 3.95253C140.045 3.95253 140.148 3.88379 140.183 3.88379C140.08 3.91816 140.045 3.95253 139.977 3.95253Z",
    fill: "url(#paint367_linear_7270_1548)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M140.25 4.46777H140.284C140.319 4.46777 140.319 4.46777 140.25 4.46777C140.284 4.50215 140.284 4.46777 140.25 4.46777Z",
    fill: "url(#paint368_linear_7270_1548)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M139.804 3.8832C139.839 3.84882 139.907 3.81445 139.942 3.81445C139.907 3.84882 139.839 3.8832 139.804 3.8832Z",
    fill: "url(#paint369_linear_7270_1548)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M139.839 3.78066C139.839 3.78066 139.804 3.81503 139.804 3.78066C139.804 3.74629 139.804 3.74629 139.839 3.78066C139.804 3.78066 139.77 3.81503 139.839 3.78066Z",
    fill: "url(#paint370_linear_7270_1548)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M139.908 3.98633L139.873 4.0207C139.839 4.0207 139.805 4.05507 139.805 4.0207C139.839 3.98633 139.873 3.98633 139.908 3.98633Z",
    fill: "url(#paint371_linear_7270_1548)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M140.009 4.53711C139.975 4.53711 139.906 4.57148 139.906 4.57148C139.906 4.53711 139.975 4.53711 140.009 4.53711Z",
    fill: "url(#paint372_linear_7270_1548)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M139.803 3.9518C139.769 3.9518 139.769 3.98617 139.803 3.9518C139.769 3.9518 139.803 3.91743 139.803 3.9518Z",
    fill: "url(#paint373_linear_7270_1548)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M139.701 3.91762C139.632 3.91762 139.632 3.95199 139.598 3.95199C139.632 3.95199 139.632 3.95199 139.632 3.91762C139.666 3.91762 139.701 3.88325 139.701 3.91762Z",
    fill: "url(#paint374_linear_7270_1548)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M139.734 4.15883C139.769 4.12446 139.769 4.15883 139.734 4.15883V4.15883Z",
    fill: "url(#paint375_linear_7270_1548)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M139.564 3.88379C139.53 3.88379 139.53 3.91816 139.564 3.88379C139.495 3.88379 139.461 3.91816 139.461 3.88379C139.495 3.91816 139.53 3.88379 139.564 3.88379Z",
    fill: "url(#paint376_linear_7270_1548)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M139.7 4.74282C139.7 4.74282 139.666 4.77719 139.666 4.74282C139.666 4.70844 139.7 4.74282 139.7 4.74282Z",
    fill: "url(#paint377_linear_7270_1548)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M139.632 4.60547C139.597 4.63984 139.529 4.67421 139.494 4.67421H139.529C139.563 4.67421 139.563 4.67421 139.597 4.63984L139.632 4.60547Z",
    fill: "url(#paint378_linear_7270_1548)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M139.391 4.22754C139.391 4.22754 139.357 4.26191 139.322 4.22754C139.357 4.26191 139.357 4.22754 139.391 4.22754Z",
    fill: "url(#paint379_linear_7270_1548)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M139.186 4.36445V4.33008C139.22 4.33008 139.22 4.36445 139.186 4.36445Z",
    fill: "url(#paint380_linear_7270_1548)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M139.185 5.01797C139.185 5.01797 139.15 5.05234 139.15 5.01797C139.15 4.98359 139.185 4.98359 139.185 5.01797Z",
    fill: "url(#paint381_linear_7270_1548)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M139.047 5.05195C139.047 5.05195 139.081 5.05195 139.116 5.01758C139.081 5.05195 139.081 5.08632 139.047 5.05195Z",
    fill: "url(#paint382_linear_7270_1548)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M138.498 4.39941C138.498 4.39941 138.463 4.43379 138.463 4.39941C138.429 4.39941 138.463 4.39941 138.498 4.39941Z",
    fill: "url(#paint383_linear_7270_1548)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M138.498 4.64004C138.463 4.60566 138.498 4.60566 138.498 4.64004C138.498 4.60566 138.532 4.60566 138.498 4.64004Z",
    fill: "url(#paint384_linear_7270_1548)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M138.256 4.50258C138.222 4.50258 138.188 4.53695 138.188 4.53695C138.187 4.50258 138.222 4.50258 138.256 4.50258C138.222 4.50258 138.222 4.46821 138.256 4.50258Z",
    fill: "url(#paint385_linear_7270_1548)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M151.526 2.40596C151.491 2.40596 151.491 2.37159 151.491 2.33722C151.526 2.33722 151.56 2.33722 151.594 2.33722C151.56 2.33722 151.594 2.30284 151.594 2.30284C151.629 2.26847 151.663 2.19973 151.663 2.13099C151.629 2.13099 151.629 2.13099 151.594 2.13099H151.56C151.56 2.09661 151.56 2.09661 151.594 2.06224C151.629 2.06224 151.629 2.06224 151.663 2.06224C151.663 1.9935 151.629 1.95913 151.629 1.92476C151.663 1.92476 151.663 1.92476 151.697 1.92476C151.732 1.92476 151.732 1.89038 151.766 1.89038C151.766 1.85601 151.766 1.89038 151.766 1.85601C151.732 1.85601 151.732 1.82164 151.697 1.78727C151.663 1.78727 151.663 1.78727 151.663 1.78727C151.629 1.78727 151.594 1.78727 151.56 1.78727C151.594 1.78727 151.526 1.7529 151.491 1.78727C151.526 1.7529 151.526 1.71853 151.594 1.71853C151.594 1.71853 151.594 1.71853 151.629 1.71853C151.629 1.71853 151.629 1.7529 151.663 1.7529C151.663 1.7529 151.697 1.7529 151.732 1.7529C151.732 1.71853 151.663 1.7529 151.697 1.71853H151.663C151.663 1.71853 151.629 1.71853 151.594 1.71853V1.68415C151.594 1.68415 151.594 1.71853 151.56 1.71853H151.526C151.491 1.71853 151.491 1.68415 151.457 1.64978C151.457 1.64978 151.457 1.64978 151.491 1.61541C151.457 1.61541 151.491 1.58104 151.491 1.54667C151.457 1.54667 151.457 1.54667 151.457 1.5123C151.422 1.5123 151.422 1.47792 151.388 1.47792V1.44355C151.354 1.44355 151.319 1.44355 151.319 1.44355C151.319 1.44355 151.319 1.44355 151.319 1.47792C151.285 1.5123 151.285 1.44355 151.251 1.47792V1.44355C151.285 1.44355 151.319 1.44355 151.354 1.44355C151.354 1.40918 151.182 1.44355 151.182 1.40918L151.079 1.44355C150.976 1.40918 150.872 1.40918 150.735 1.44355H150.769C150.701 1.44355 150.666 1.44355 150.598 1.44355C150.598 1.44355 150.598 1.44355 150.598 1.47792L150.563 1.5123C150.563 1.5123 150.563 1.5123 150.563 1.47792C150.529 1.47792 150.529 1.5123 150.529 1.47792C150.598 1.47792 150.598 1.40918 150.632 1.37481C150.529 1.30607 150.735 1.27169 150.701 1.16858C150.701 1.13421 150.666 1.13421 150.666 1.09984C150.563 1.06546 150.46 1.13421 150.323 1.13421C150.323 1.16858 150.357 1.20295 150.288 1.23732C150.288 1.23732 150.288 1.23732 150.254 1.23732C150.288 1.23732 150.219 1.27169 150.219 1.30607C150.185 1.30607 150.151 1.30607 150.116 1.30607C150.116 1.34044 150.219 1.34044 150.116 1.37481H150.048C150.048 1.40918 150.151 1.37481 150.151 1.44355H150.082C150.116 1.44355 150.185 1.40918 150.151 1.44355C150.116 1.44355 150.082 1.44355 150.048 1.47792H150.013V1.44355C149.979 1.47792 149.979 1.44355 149.91 1.44355C149.91 1.44355 149.91 1.44355 149.91 1.47792C149.841 1.47792 149.91 1.47792 149.876 1.44355C149.841 1.47792 149.807 1.47792 149.773 1.44355C149.807 1.44355 149.738 1.47792 149.704 1.44355C149.669 1.40918 149.738 1.44355 149.738 1.44355C149.773 1.44355 149.669 1.44355 149.669 1.44355H149.635C149.635 1.44355 149.635 1.40918 149.601 1.44355C149.601 1.44355 149.601 1.44355 149.601 1.47792C149.601 1.5123 149.601 1.47792 149.601 1.44355C149.532 1.44355 149.498 1.44355 149.429 1.44355C149.429 1.44355 149.429 1.44355 149.429 1.47792C149.326 1.47792 149.291 1.5123 149.223 1.5123C149.223 1.54667 149.188 1.5123 149.188 1.5123C149.154 1.5123 149.12 1.54667 149.085 1.54667C148.982 1.54667 148.913 1.54667 148.845 1.54667C148.81 1.54667 148.776 1.54667 148.741 1.54667C148.741 1.54667 148.741 1.54667 148.776 1.54667C148.741 1.54667 148.741 1.54667 148.707 1.54667C148.707 1.54667 148.707 1.54667 148.673 1.54667H148.638C148.638 1.54667 148.638 1.54667 148.673 1.54667C148.673 1.54667 148.673 1.54667 148.638 1.54667C148.673 1.54667 148.741 1.5123 148.741 1.44355V1.40918C148.845 1.40918 148.948 1.40918 149.085 1.37481C149.154 1.34044 149.223 1.34044 149.223 1.27169C149.257 1.23732 149.257 1.20295 149.223 1.16858C149.257 1.16858 149.326 1.16858 149.326 1.16858H149.257C149.291 1.20295 149.36 1.20295 149.429 1.20295C149.429 1.23732 149.395 1.23732 149.395 1.23732C149.498 1.23732 149.601 1.27169 149.738 1.20295C149.773 1.20295 149.841 1.16858 149.841 1.13421C149.876 1.09984 149.876 1.03109 149.841 0.996722C149.841 0.996722 149.841 0.996722 149.807 0.996722C149.738 0.996722 149.704 0.96235 149.635 0.996722C149.532 0.996722 149.429 1.03109 149.326 1.09984C149.188 1.13421 149.085 0.996722 148.913 1.06547C148.879 1.13421 148.81 1.13421 148.776 1.16858C148.741 1.16858 148.707 1.16858 148.673 1.20295C148.707 1.20295 148.81 1.16858 148.776 1.20295H148.673H148.741C148.741 1.23732 148.673 1.27169 148.638 1.27169C148.638 1.30607 148.707 1.27169 148.741 1.27169C148.741 1.30607 148.707 1.27169 148.673 1.34044C148.638 1.27169 148.535 1.27169 148.466 1.30607C148.432 1.34044 148.329 1.34044 148.329 1.40918C148.329 1.40918 148.329 1.40918 148.363 1.40918H148.26H148.226H148.398C148.398 1.40918 148.432 1.40918 148.398 1.44355C148.363 1.47792 148.295 1.5123 148.226 1.5123C148.157 1.5123 148.123 1.5123 148.054 1.5123C148.02 1.54667 148.157 1.5123 148.191 1.5123H148.123C148.157 1.5123 148.191 1.5123 148.191 1.5123C148.157 1.5123 148.157 1.5123 148.123 1.5123C148.123 1.5123 148.088 1.5123 148.054 1.5123C148.054 1.5123 148.054 1.5123 148.02 1.5123H147.917C147.951 1.5123 147.951 1.47792 147.985 1.47792C147.985 1.47792 147.985 1.47792 148.02 1.47792C147.985 1.47792 148.054 1.47792 148.054 1.47792C147.985 1.47792 147.917 1.47792 147.882 1.47792C147.813 1.47792 147.779 1.47792 147.745 1.47792C147.676 1.47792 147.607 1.47792 147.538 1.5123C147.47 1.5123 147.401 1.5123 147.367 1.5123C147.332 1.5123 147.16 1.58104 147.126 1.54667C147.16 1.54667 147.16 1.54667 147.195 1.54667C147.16 1.54667 147.126 1.54667 147.092 1.54667C147.195 1.5123 147.092 1.54667 147.126 1.54667C147.092 1.54667 147.057 1.54667 147.023 1.54667C147.092 1.54667 146.988 1.5123 147.092 1.5123C147.023 1.5123 146.954 1.5123 146.885 1.5123C146.885 1.5123 146.885 1.5123 146.851 1.54667C146.817 1.54667 146.92 1.54667 146.851 1.54667C146.782 1.54667 146.645 1.61541 146.61 1.54667C146.542 1.58104 146.714 1.54667 146.61 1.58104C146.645 1.58104 146.714 1.54667 146.748 1.58104C146.714 1.58104 146.748 1.58104 146.714 1.61541H146.679C146.576 1.61541 146.473 1.64978 146.335 1.68415C146.232 1.68415 146.164 1.68415 146.06 1.68415C146.095 1.68415 145.957 1.71853 146.026 1.71853C145.957 1.7529 145.923 1.7529 145.923 1.71853C145.923 1.71853 145.957 1.71853 145.992 1.71853C145.957 1.71853 145.923 1.71853 145.889 1.7529C145.82 1.7529 145.854 1.7529 145.82 1.7529L145.717 1.78727H145.648C145.682 1.78727 145.614 1.78727 145.579 1.82164H145.545H145.511C145.545 1.82164 145.476 1.85601 145.442 1.85601C145.339 1.89038 145.27 1.85601 145.167 1.92476C145.132 1.92476 145.098 1.92476 145.064 1.92476C145.029 1.92476 144.995 1.92476 144.961 1.92476C144.961 1.92476 144.995 1.92476 145.029 1.92476H145.064C145.029 1.92476 144.995 1.95913 144.961 1.95913C144.892 1.95913 144.857 1.95913 144.789 1.9935C144.857 1.95913 144.961 1.92476 145.029 1.89038L144.995 1.92476C145.029 1.92476 145.098 1.92476 145.132 1.89038C145.098 1.89038 145.064 1.92476 145.098 1.92476C145.098 1.92476 145.132 1.92476 145.167 1.92476C145.132 1.92476 145.098 1.92476 145.098 1.95913C145.098 1.95913 145.132 1.95913 145.167 1.95913C145.236 1.92476 145.27 1.92476 145.339 1.89038C145.339 1.92476 145.442 1.85601 145.442 1.89038H145.407C145.373 1.89038 145.339 1.92476 145.304 1.92476C145.304 1.92476 145.373 1.92476 145.373 1.89038C145.304 1.89038 145.27 1.92476 145.201 1.95913C145.236 1.95913 145.304 1.92476 145.304 1.95913C145.339 1.95913 145.407 1.92476 145.442 1.89038H145.476C145.545 1.85601 145.407 1.89038 145.511 1.85601C145.614 1.82164 145.614 1.85601 145.682 1.85601C145.648 1.85601 145.579 1.85601 145.545 1.85601H145.579C145.545 1.85601 145.476 1.85601 145.442 1.89038C145.511 1.89038 145.407 1.89038 145.373 1.92476C145.407 1.92476 145.442 1.92476 145.476 1.89038C145.339 1.92476 145.373 1.89038 145.236 1.92476C145.304 1.92476 145.236 1.95913 145.201 1.95913C145.201 1.95913 145.132 1.95913 145.098 1.95913V1.92476C145.029 1.92476 144.995 1.9935 144.926 1.9935C144.926 1.9935 144.995 1.95913 144.995 1.9935C144.892 1.9935 144.823 2.06224 144.754 2.09661C144.754 2.09661 144.754 2.09661 144.72 2.09661C144.72 2.09661 144.72 2.13099 144.754 2.09661C144.72 2.09661 144.686 2.09661 144.651 2.09661C144.72 2.06224 144.617 2.09661 144.617 2.09661C144.617 2.09661 144.617 2.09661 144.651 2.09661C144.617 2.09661 144.582 2.13099 144.582 2.13099C144.582 2.13099 144.651 2.13099 144.72 2.13099H144.686C144.686 2.13099 144.72 2.13099 144.754 2.13099C144.72 2.13099 144.72 2.16536 144.754 2.16536C144.789 2.16536 144.789 2.16536 144.789 2.16536C144.823 2.16536 144.754 2.19973 144.72 2.19973H144.686H144.548C144.514 2.19973 144.445 2.2341 144.411 2.26847C144.342 2.26847 144.307 2.30284 144.342 2.30284H144.273C144.376 2.30284 144.273 2.33722 144.308 2.33722H144.239C144.239 2.33722 144.239 2.33722 144.204 2.33722C144.204 2.33722 144.17 2.33722 144.17 2.37159C144.101 2.37159 144.033 2.40596 143.964 2.44033H143.929C143.998 2.40596 143.964 2.44033 143.964 2.40596C144.033 2.40596 144.067 2.37159 144.136 2.37159C144.136 2.37159 144.101 2.37159 144.067 2.37159C144.101 2.37159 144.17 2.37159 144.204 2.33722H144.239C144.204 2.33722 144.239 2.33722 144.17 2.33722C144.17 2.33722 144.239 2.33722 144.273 2.30284H144.308C144.308 2.30284 144.376 2.26847 144.308 2.26847H144.204H144.239H144.136C143.998 2.30284 144.101 2.30284 143.964 2.33722C143.895 2.33722 143.861 2.33722 143.792 2.37159C143.861 2.37159 143.792 2.37159 143.826 2.37159C143.792 2.37159 143.758 2.40596 143.723 2.37159C143.723 2.37159 143.689 2.40596 143.758 2.37159C143.758 2.37159 143.689 2.37159 143.689 2.40596C143.654 2.40596 143.62 2.40596 143.586 2.40596C143.551 2.40596 143.551 2.40596 143.517 2.40596C143.483 2.40596 143.414 2.40596 143.414 2.44033H143.379C143.311 2.44033 143.276 2.4747 143.173 2.50907C143.173 2.50907 143.173 2.50907 143.139 2.50907H143.104C143.07 2.50907 143.001 2.54345 142.933 2.54345H143.036L143.001 2.57782C142.933 2.61219 142.898 2.61219 142.83 2.64656C142.83 2.64656 142.864 2.61219 142.898 2.61219L142.83 2.64656C142.83 2.64656 142.795 2.64656 142.761 2.68093H142.726H142.692C142.726 2.68093 142.692 2.64656 142.726 2.64656H142.692C142.692 2.64656 142.692 2.7153 142.589 2.74968C142.589 2.74968 142.589 2.74968 142.555 2.74968H142.52H142.486C142.486 2.74968 142.417 2.78405 142.383 2.78405C142.348 2.78405 142.28 2.78405 142.28 2.81842C142.245 2.81842 142.211 2.81842 142.176 2.85279C142.176 2.85279 142.176 2.88716 142.176 2.92153H142.108C142.108 2.92153 142.142 2.92153 142.211 2.92153C142.176 2.92153 142.176 2.92153 142.142 2.95591C142.176 2.95591 142.211 2.9559 142.245 2.92153H142.176H142.211H142.108C142.176 2.92153 142.073 2.92153 142.039 2.95591C142.005 2.99028 142.005 2.95591 142.005 2.95591C142.039 2.95591 142.073 2.9559 142.108 2.92153C142.108 2.92153 142.108 2.92153 142.073 2.92153H142.039C142.039 2.92153 142.039 2.92153 142.005 2.92153H141.97C141.936 2.92153 141.936 2.92153 141.97 2.95591C141.97 2.95591 141.97 2.95591 141.936 2.95591C141.901 2.95591 141.901 2.95591 141.867 2.99028C141.867 3.02465 141.764 3.02465 141.764 3.05902C141.73 3.05902 141.661 3.09339 141.627 3.12776C141.627 3.12776 141.627 3.12776 141.661 3.12776L141.592 3.16214C141.523 3.16214 141.489 3.19651 141.455 3.23088H141.386H141.352H141.317H141.283H141.248H141.214C141.214 3.23088 141.248 3.23088 141.283 3.23088C141.317 3.23088 141.283 3.29962 141.386 3.23088C141.386 3.19651 141.489 3.19651 141.489 3.19651C141.489 3.19651 141.523 3.19651 141.489 3.23088C141.455 3.23088 141.42 3.23088 141.386 3.26525L141.317 3.29962C141.283 3.33399 141.248 3.33399 141.18 3.36836C141.145 3.36836 141.008 3.43711 141.042 3.36836C141.008 3.40274 140.939 3.40274 140.905 3.40274L140.973 3.36836C140.939 3.36836 140.87 3.36836 140.87 3.36836H140.836H140.802L140.733 3.40274H140.698C140.698 3.40274 140.664 3.40274 140.63 3.40274C140.595 3.40274 140.595 3.40274 140.595 3.40274H140.561L140.527 3.43711H140.492C140.389 3.47148 140.355 3.54022 140.286 3.50585C140.32 3.50585 140.252 3.54022 140.252 3.54022L140.217 3.5746C140.183 3.5746 140.183 3.60897 140.183 3.60897C140.217 3.60897 140.252 3.5746 140.286 3.5746H140.32C140.389 3.54022 140.389 3.57459 140.424 3.54022L140.389 3.5746H140.492C140.458 3.5746 140.423 3.60897 140.389 3.60897H140.424C140.424 3.60897 140.389 3.60897 140.355 3.60897C140.32 3.60897 140.32 3.60897 140.286 3.64334C140.217 3.64334 140.183 3.67771 140.149 3.71208H140.114C140.149 3.67771 140.08 3.67771 140.114 3.64334C140.045 3.67771 140.011 3.67771 140.011 3.71208C140.08 3.71208 140.08 3.71208 140.08 3.71208L139.977 3.74645C139.977 3.74645 139.977 3.74645 139.942 3.74645C139.874 3.78082 139.908 3.74645 139.839 3.78082L139.736 3.8152V3.78082C139.702 3.78082 139.736 3.8152 139.736 3.8152C139.736 3.8152 139.77 3.8152 139.805 3.8152L139.77 3.84957C139.736 3.84957 139.702 3.84957 139.667 3.84957C139.564 3.91831 139.461 3.88394 139.358 3.95268L139.53 3.91831L139.495 3.95268H139.564C139.53 3.98705 139.461 3.95268 139.461 3.98706H139.495C139.461 3.98706 139.461 3.98705 139.427 4.02143C139.461 4.02143 139.495 4.02143 139.53 4.02143C139.53 4.02143 139.495 4.02143 139.461 4.0558H139.427L139.392 4.09017C139.427 4.09017 139.461 4.0558 139.495 4.0558C139.53 4.0558 139.564 4.0558 139.599 4.0558C139.564 4.0558 139.53 4.09017 139.495 4.09017H139.53C139.599 4.0558 139.633 4.0558 139.702 4.02143C139.77 4.02143 139.805 3.95268 139.874 3.95268H139.839L140.045 3.91831H140.08L140.183 3.88394C140.183 3.88394 140.183 3.88394 140.149 3.91831C140.149 3.91831 140.045 3.95268 140.08 3.91831C140.045 3.95268 139.977 3.95268 139.977 3.95268C140.011 3.91831 139.942 3.95268 139.942 3.95268L139.874 3.98706C139.874 3.98706 139.874 3.98706 139.908 3.98706C139.942 3.98706 139.839 4.02143 139.908 4.02143C139.839 4.02143 139.736 4.09017 139.667 4.12454L139.702 4.09017C139.667 4.09017 139.633 4.12454 139.599 4.15891L139.702 4.12454L139.633 4.15891H139.53H139.564C139.495 4.15891 139.461 4.19328 139.392 4.22766C139.427 4.22766 139.495 4.19328 139.564 4.15891C139.633 4.15891 139.564 4.19328 139.599 4.15891C139.599 4.15891 139.564 4.15891 139.53 4.15891C139.564 4.15891 139.667 4.12454 139.736 4.12454C139.77 4.09017 139.839 4.09017 139.874 4.0558H139.839C139.839 4.0558 139.874 4.0558 139.908 4.0558C139.874 4.09017 139.908 4.0558 139.874 4.09017C139.908 4.09017 139.942 4.09017 139.977 4.0558C139.977 4.0558 140.011 4.0558 140.045 4.02143H140.08C140.011 4.0558 140.114 4.02143 140.114 4.02143C140.114 4.02143 140.149 4.02143 140.183 4.02143C140.149 4.02143 140.114 4.02143 140.149 4.02143C140.149 4.02143 140.183 4.02143 140.217 4.02143H140.183L140.286 3.98706C140.32 3.98706 140.32 3.98706 140.355 3.98706C140.355 3.98706 140.389 3.95268 140.424 3.95268H140.389C140.423 3.91831 140.492 3.91831 140.527 3.91831C140.561 3.91831 140.32 3.95268 140.527 3.88394C140.595 3.84957 140.595 3.88394 140.63 3.88394C140.664 3.88394 140.664 3.88394 140.698 3.88394C140.698 3.88394 140.664 3.88394 140.63 3.91831C140.63 3.91831 140.698 3.88394 140.733 3.88394C140.698 3.88394 140.802 3.84957 140.767 3.84957C140.836 3.8152 140.87 3.78082 140.939 3.78082C140.973 3.74645 141.008 3.74645 141.077 3.71208H141.042C141.008 3.71208 141.111 3.67771 141.042 3.67771H141.008L141.042 3.64334C141.077 3.64334 141.077 3.60897 141.111 3.60897H141.145C141.248 3.57459 141.352 3.54022 141.455 3.50585C141.455 3.50585 141.489 3.50585 141.523 3.50585H141.489V3.54022H141.523V3.50585H141.558L141.661 3.47148L141.489 3.84957L141.592 3.8152C141.661 3.78083 141.592 3.78082 141.695 3.74645C141.695 3.74645 141.695 3.74645 141.695 3.78082L141.764 3.74645H141.833C141.867 3.71208 141.764 3.74645 141.764 3.74645C141.764 3.74645 141.764 3.74645 141.798 3.71208C141.73 3.71208 141.695 3.74645 141.627 3.74645C141.627 3.74645 141.627 3.74645 141.627 3.71208C141.695 3.67771 141.764 3.67771 141.833 3.67771C141.867 3.67771 141.97 3.60897 141.901 3.60897C141.97 3.60897 141.97 3.64334 142.039 3.60897C141.936 3.64334 141.936 3.60897 141.833 3.64334C141.833 3.64334 141.798 3.67771 141.833 3.67771C141.867 3.67771 141.867 3.64334 141.901 3.64334C141.901 3.64334 141.798 3.67771 141.867 3.67771H141.798L141.867 3.64334C141.867 3.64334 141.867 3.64334 141.901 3.64334L142.176 3.54022C142.176 3.54022 142.211 3.54022 142.245 3.54022C142.245 3.54022 142.245 3.54022 142.28 3.54022L142.383 3.50585C142.383 3.50585 142.417 3.50585 142.451 3.50585H142.486L142.658 3.47148C142.658 3.47148 142.726 3.47148 142.761 3.47148C142.726 3.47148 142.726 3.47148 142.726 3.47148H142.761C142.795 3.47148 142.933 3.40274 142.898 3.43711C142.933 3.43711 142.967 3.40274 143.001 3.40274C142.967 3.40274 142.967 3.40274 142.967 3.40274C142.967 3.40274 143.001 3.40274 143.036 3.40274C143.07 3.40274 142.967 3.40274 142.967 3.40274C142.898 3.40274 142.864 3.43711 142.864 3.43711L142.898 3.40274C142.795 3.43711 142.795 3.40274 142.692 3.43711C142.726 3.43711 142.864 3.40274 142.795 3.43711H142.726C142.692 3.43711 142.726 3.43711 142.761 3.43711C142.726 3.43711 142.692 3.47148 142.658 3.47148C142.658 3.47148 142.726 3.43711 142.658 3.43711L142.486 3.47148C142.52 3.47148 142.52 3.47148 142.52 3.47148C142.486 3.47148 142.486 3.47148 142.417 3.47148H142.486C142.417 3.50585 142.348 3.50585 142.28 3.54022C142.245 3.54022 142.176 3.5746 142.142 3.5746C142.211 3.5746 142.28 3.54022 142.348 3.50585C142.314 3.50585 142.348 3.47148 142.417 3.43711H142.486C142.486 3.43711 142.451 3.47148 142.486 3.47148C142.486 3.47148 142.486 3.47148 142.486 3.43711C142.52 3.43711 142.555 3.43711 142.589 3.40274C142.623 3.40274 142.692 3.40274 142.726 3.36836H142.761C142.761 3.36836 142.795 3.36836 142.83 3.36836H142.898C142.933 3.36836 142.933 3.36836 142.933 3.36836L143.036 3.33399C142.967 3.36837 143.104 3.33399 143.001 3.36836C142.898 3.40274 142.898 3.36837 142.83 3.40274C142.864 3.40274 142.933 3.40274 142.967 3.40274H142.933C142.967 3.40274 143.036 3.40274 143.07 3.36836C143.001 3.36836 143.104 3.36837 143.139 3.33399C143.104 3.33399 143.07 3.36836 143.036 3.36836C143.173 3.33399 143.139 3.36837 143.276 3.33399C143.208 3.33399 143.276 3.29962 143.311 3.29962C143.311 3.29962 143.379 3.29962 143.414 3.29962V3.33399C143.448 3.33399 143.483 3.29962 143.517 3.29962H143.551C143.62 3.29962 143.689 3.26525 143.758 3.19651H143.792C143.792 3.19651 143.792 3.19651 143.826 3.19651H143.895H143.964C143.998 3.19651 143.964 3.19651 143.929 3.19651H143.964H143.998C143.998 3.19651 143.998 3.19651 144.033 3.19651H144.067H144.101H144.136C144.136 3.19651 144.17 3.19651 144.204 3.19651C144.239 3.19651 144.204 3.23088 144.239 3.23088H144.204C144.17 3.26525 144.136 3.26525 144.067 3.26525C144.067 3.26525 144.033 3.26525 144.067 3.29962C144.067 3.29962 144.067 3.29962 144.033 3.29962H143.964H143.998H144.033C143.964 3.29962 143.861 3.33399 143.792 3.36836C143.723 3.36836 143.758 3.40274 143.792 3.40274C143.792 3.40274 143.792 3.40274 143.758 3.40274V3.36836C143.723 3.40274 143.654 3.40274 143.62 3.43711C143.62 3.43711 143.62 3.43711 143.586 3.43711C143.551 3.43711 143.517 3.43711 143.483 3.43711H143.448C143.448 3.43711 143.448 3.43711 143.414 3.43711H143.448C143.448 3.43711 143.414 3.43711 143.379 3.43711C143.345 3.43711 143.311 3.47148 143.276 3.47148C143.242 3.47148 143.311 3.43711 143.276 3.40274C143.276 3.40274 143.242 3.43711 143.208 3.43711C143.173 3.43711 143.173 3.43711 143.139 3.47148C143.139 3.47148 143.139 3.47148 143.173 3.47148H143.139C143.139 3.47148 143.139 3.47148 143.104 3.47148C143.104 3.47148 143.104 3.47148 143.104 3.50585C143.104 3.50585 143.036 3.50585 143.07 3.50585H143.036C143.036 3.50585 143.001 3.54022 143.036 3.54022C143.036 3.54022 142.967 3.54022 143.001 3.5746C142.967 3.5746 142.933 3.57459 142.898 3.60897C142.898 3.60897 142.898 3.60897 142.933 3.60897C142.933 3.60897 142.898 3.64334 142.864 3.64334C142.864 3.64334 142.83 3.64334 142.795 3.64334C142.795 3.64334 142.795 3.64334 142.761 3.64334C142.726 3.64334 142.726 3.64334 142.692 3.67771C142.726 3.64334 142.623 3.67771 142.623 3.71208C142.555 3.71208 142.52 3.74645 142.52 3.78082C142.555 3.78082 142.555 3.78082 142.555 3.74645C142.555 3.71208 142.555 3.74645 142.589 3.74645C142.589 3.74645 142.555 3.74645 142.589 3.78082C142.52 3.78082 142.555 3.78082 142.52 3.78082L142.451 3.8152H142.383C142.383 3.8152 142.383 3.8152 142.417 3.8152C142.383 3.8152 142.314 3.84957 142.314 3.8152C142.348 3.8152 142.383 3.78082 142.417 3.78082C142.417 3.78082 142.417 3.78082 142.451 3.78082C142.383 3.78082 142.383 3.8152 142.314 3.84957C142.314 3.84957 142.314 3.84957 142.28 3.88394H142.314C142.348 3.88394 142.348 3.88394 142.383 3.84957L142.28 3.88394C142.245 3.88394 142.28 3.88394 142.245 3.84957C142.211 3.88394 142.211 3.84957 142.142 3.88394H142.176C142.176 3.88394 142.108 3.91831 142.108 3.88394C142.073 3.88394 142.142 3.88394 142.108 3.88394H142.142C142.108 3.88394 142.073 3.91831 142.039 3.91831C142.039 3.91831 142.073 3.91831 142.073 3.88394H142.039C142.005 3.88394 141.97 3.91831 141.97 3.91831H141.936C141.936 3.91831 141.867 3.98705 141.867 3.95268C141.798 3.95268 141.798 3.98706 141.764 3.98706C141.73 3.98706 141.764 3.98705 141.764 3.95268H141.73C141.764 3.98705 141.592 3.98705 141.558 4.0558C141.558 4.0558 141.558 4.0558 141.523 4.0558C141.489 4.0558 141.455 4.09017 141.42 4.09017C141.352 4.09017 141.283 4.12454 141.214 4.15891C141.248 4.15891 141.283 4.15891 141.317 4.12454V4.19328V4.22766C141.352 4.22766 141.317 4.26203 141.352 4.22766C141.352 4.22766 141.317 4.22766 141.283 4.26203C141.283 4.2964 141.386 4.22766 141.42 4.19328C141.42 4.19328 141.42 4.22766 141.455 4.22766C141.352 4.2964 141.283 4.26203 141.214 4.33077C141.18 4.33077 141.145 4.33077 141.145 4.33077H141.18C141.145 4.33077 141.18 4.33077 141.111 4.33077C141.077 4.33077 141.111 4.36514 141.077 4.36514H141.145C141.111 4.36514 141.111 4.39951 141.042 4.43389C141.111 4.43389 141.214 4.36514 141.18 4.43389H141.145C141.077 4.43389 140.973 4.43389 140.973 4.50263L140.905 4.537C140.905 4.537 140.905 4.537 140.939 4.50263C140.905 4.50263 140.87 4.537 140.836 4.537C140.836 4.57137 140.836 4.57137 140.836 4.57137C140.802 4.57137 140.802 4.57137 140.767 4.60574C140.733 4.60574 140.664 4.64012 140.664 4.60574C140.664 4.60574 140.698 4.64012 140.63 4.64012L140.424 4.74323C140.424 4.74323 140.32 4.7776 140.32 4.74323C140.32 4.74323 140.32 4.74323 140.286 4.74323C140.286 4.74323 140.286 4.74323 140.252 4.74323C140.217 4.74323 140.183 4.74323 140.183 4.7776C140.217 4.7776 140.286 4.74323 140.286 4.70886C140.286 4.70886 140.32 4.70886 140.355 4.70886C140.389 4.70886 140.424 4.70886 140.458 4.67449C140.424 4.67449 140.389 4.67449 140.389 4.70886C140.458 4.70886 140.389 4.70886 140.355 4.70886H140.32C140.32 4.70886 140.286 4.70886 140.252 4.74323C140.217 4.7776 140.217 4.7776 140.149 4.81197V4.84635H140.114C140.08 4.84635 140.114 4.84635 140.114 4.81197C140.149 4.81197 140.183 4.81197 140.217 4.7776H140.183C140.217 4.7776 140.286 4.7776 140.32 4.74323C140.355 4.74323 140.424 4.70886 140.424 4.70886C140.458 4.67449 140.527 4.67449 140.561 4.64012C140.561 4.64012 140.561 4.64012 140.527 4.64012C140.63 4.64012 140.698 4.60574 140.802 4.537C140.767 4.537 140.767 4.537 140.802 4.537C140.767 4.537 140.836 4.537 140.802 4.537C140.767 4.537 140.733 4.57137 140.698 4.60574C140.664 4.60574 140.698 4.60574 140.698 4.57137C140.664 4.57137 140.63 4.60574 140.595 4.60574C140.63 4.60574 140.664 4.60574 140.698 4.57137C140.664 4.57137 140.63 4.57137 140.595 4.60574C140.561 4.64012 140.527 4.64012 140.492 4.67449C140.458 4.70886 140.424 4.70886 140.355 4.74323H140.32C140.32 4.74323 140.217 4.7776 140.114 4.7776C140.045 4.81197 140.045 4.7776 139.942 4.81197C139.942 4.81197 139.942 4.81197 139.942 4.7776C139.908 4.7776 139.839 4.81197 139.839 4.81197C139.839 4.81197 139.839 4.81197 139.805 4.81197C139.805 4.84635 139.805 4.84635 139.839 4.88072C139.805 4.88072 139.839 4.88072 139.77 4.88072C139.77 4.88072 139.77 4.88072 139.77 4.84635C139.736 4.88072 139.736 4.84635 139.702 4.84635C139.702 4.88072 139.667 4.84635 139.667 4.88072C139.667 4.91509 139.667 4.88072 139.633 4.91509C139.599 4.94946 139.667 4.91509 139.633 4.88072C139.599 4.84635 139.564 4.91509 139.599 4.88072C139.564 4.88072 139.53 4.88072 139.495 4.88072C139.564 4.84635 139.633 4.81197 139.702 4.7776C139.702 4.7776 139.702 4.7776 139.702 4.74323C139.702 4.70886 139.736 4.74323 139.736 4.74323C139.736 4.74323 139.77 4.70886 139.805 4.70886C139.805 4.74323 139.874 4.70886 139.908 4.70886C139.942 4.70886 139.874 4.70886 139.839 4.70886C139.874 4.70886 139.908 4.67449 139.908 4.70886C139.908 4.70886 139.942 4.70886 139.977 4.70886C139.977 4.70886 139.977 4.70886 139.942 4.70886L140.045 4.67449C140.045 4.67449 140.08 4.67449 140.08 4.64012C140.08 4.64012 140.08 4.64012 140.045 4.64012C140.08 4.64012 140.114 4.60574 140.149 4.60574C140.252 4.60574 140.355 4.57137 140.424 4.50263C140.492 4.46826 140.527 4.46826 140.561 4.43389H140.63C140.63 4.43389 140.561 4.43389 140.527 4.43389C140.492 4.46826 140.423 4.46826 140.389 4.50263C140.389 4.50263 140.424 4.50263 140.424 4.46826C140.424 4.43389 140.389 4.50263 140.389 4.46826H140.458C140.492 4.46826 140.561 4.43389 140.561 4.43389C140.595 4.43389 140.561 4.39951 140.595 4.39951C140.595 4.39951 140.527 4.39951 140.561 4.39951C140.561 4.39951 140.561 4.39951 140.527 4.39951C140.527 4.43389 140.492 4.43389 140.458 4.43389H140.389C140.389 4.43389 140.389 4.43389 140.355 4.43389C140.286 4.46826 140.252 4.46826 140.183 4.50263C140.183 4.50263 140.252 4.50263 140.217 4.50263C140.217 4.50263 140.252 4.50263 140.286 4.50263C140.217 4.537 140.355 4.46826 140.389 4.50263C140.355 4.50263 140.286 4.537 140.355 4.537C140.32 4.537 140.32 4.537 140.32 4.537C140.252 4.60574 140.149 4.60574 140.114 4.64012C140.114 4.64012 140.08 4.64012 140.08 4.67449C140.011 4.67449 140.011 4.70886 139.942 4.74323C139.977 4.70886 139.942 4.70886 139.908 4.70886C139.908 4.70886 139.908 4.70886 139.874 4.74323C139.908 4.74323 139.908 4.74323 139.908 4.7776C139.874 4.7776 139.874 4.7776 139.839 4.7776H139.77H139.736C139.702 4.81197 139.667 4.81197 139.633 4.81197C139.599 4.81197 139.599 4.84635 139.564 4.88072C139.53 4.88072 139.53 4.91509 139.495 4.91509C139.495 4.91509 139.461 4.91509 139.427 4.94946C139.427 4.94946 139.461 4.98383 139.495 4.94946C139.427 4.94946 139.392 4.94946 139.392 4.94946C139.358 4.94946 139.392 4.98383 139.358 4.98383C139.358 4.98383 139.358 4.94946 139.289 4.98383H139.255C139.186 5.0182 139.152 5.05258 139.083 5.05258C139.049 5.05258 139.049 5.05258 139.014 5.05258C138.98 5.05258 138.946 5.08695 138.946 5.12132C138.946 5.12132 138.946 5.12132 138.98 5.12132C139.014 5.08695 139.152 5.08695 139.186 5.0182C139.255 5.0182 139.324 4.98383 139.392 4.94946H139.427C139.427 4.94946 139.358 4.98383 139.392 5.0182C139.427 5.0182 139.427 5.0182 139.461 4.98383C139.358 5.05258 139.289 5.08695 139.186 5.12132C139.186 5.12132 139.255 5.08695 139.289 5.08695C139.255 5.08695 139.289 5.08695 139.289 5.12132H139.324C139.324 5.12132 139.324 5.08695 139.289 5.12132C139.289 5.12132 139.358 5.08695 139.324 5.08695C139.358 5.05258 139.358 5.08695 139.427 5.05258C139.427 5.05258 139.461 5.05258 139.461 5.08695C139.461 5.08695 139.461 5.12132 139.392 5.15569C139.289 5.15569 139.186 5.25881 139.049 5.29318C138.98 5.36192 138.911 5.36192 138.842 5.39629C138.842 5.39629 138.842 5.36192 138.877 5.36192H138.946C138.911 5.36192 138.842 5.39629 138.808 5.39629C138.808 5.39629 138.842 5.39629 138.877 5.39629H138.842C138.842 5.43066 138.877 5.43066 138.842 5.46504L138.774 5.49941C138.842 5.46503 138.877 5.46503 138.877 5.43066C138.877 5.43066 138.911 5.43066 138.946 5.43066C138.911 5.46503 138.808 5.49941 138.739 5.53378H138.705C138.739 5.53378 138.739 5.49941 138.774 5.49941C138.739 5.49941 138.705 5.49941 138.671 5.53378C138.671 5.53378 138.705 5.53378 138.671 5.49941H138.705L138.671 5.53378H138.705C138.671 5.53378 138.671 5.56815 138.636 5.56815C138.636 5.56815 138.636 5.56815 138.602 5.56815C138.567 5.60252 138.533 5.67127 138.464 5.67127C138.464 5.67127 138.499 5.63689 138.533 5.63689H138.464C138.464 5.63689 138.464 5.63689 138.464 5.67127C138.464 5.70564 138.464 5.67127 138.43 5.67127C138.43 5.67127 138.396 5.70564 138.361 5.70564C138.361 5.70564 138.327 5.74001 138.292 5.74001C138.258 5.74001 138.327 5.70564 138.292 5.74001C138.292 5.77438 138.292 5.77438 138.224 5.80875C138.155 5.84312 138.121 5.8775 138.052 5.8775C137.949 5.91187 137.811 5.98061 137.708 6.04935H137.674C137.639 6.04935 137.674 6.01498 137.639 6.04935C137.605 6.04935 137.605 6.04935 137.605 6.08372C137.605 6.1181 137.674 6.04935 137.708 6.04935C137.708 6.04935 137.777 6.01498 137.811 6.01498H137.777C137.777 5.98061 137.811 5.98061 137.846 5.98061C137.846 5.98061 137.846 5.98061 137.846 6.01498C137.88 6.01498 137.88 5.98061 137.914 5.98061C137.914 5.98061 137.914 5.98061 137.914 6.01498C137.914 6.01498 137.88 6.04935 137.846 6.01498C137.846 6.04935 137.949 5.98061 137.983 5.94624C137.983 5.94624 137.949 5.94624 137.914 5.94624C137.914 5.94624 137.983 5.94624 137.949 5.91187H137.983L138.258 5.80875C138.258 5.80875 138.258 5.80875 138.258 5.77438C138.292 5.77438 138.292 5.77438 138.292 5.77438C138.327 5.74001 138.327 5.77438 138.361 5.77438H138.327C138.361 5.77438 138.361 5.77438 138.361 5.77438C138.533 5.70564 138.774 5.60252 138.98 5.49941C138.98 5.49941 139.049 5.49941 139.083 5.49941C139.083 5.49941 139.049 5.49941 139.014 5.53378H139.049C139.049 5.53378 139.049 5.53378 139.014 5.56815C138.98 5.56815 138.946 5.60252 138.911 5.60252H138.946C138.911 5.63689 138.842 5.63689 138.774 5.67127H138.808C138.808 5.67127 138.774 5.70564 138.739 5.70564C138.705 5.70564 138.636 5.74001 138.671 5.70564L138.602 5.74001C138.567 5.77438 138.464 5.84312 138.464 5.84312C138.499 5.84312 138.567 5.84312 138.602 5.80875C138.705 5.74001 138.808 5.70564 138.911 5.63689C138.946 5.63689 138.98 5.63689 139.014 5.60252C138.98 5.60252 138.877 5.67126 138.911 5.60252C138.946 5.60252 138.98 5.56815 139.014 5.53378H139.049C138.98 5.56815 139.117 5.53378 138.946 5.60252C138.98 5.60252 139.014 5.60252 139.083 5.56815C139.186 5.49941 138.877 5.63689 139.117 5.49941H139.152L139.289 5.43066C139.22 5.46503 139.186 5.46503 139.117 5.49941C139.22 5.46503 139.289 5.39629 139.358 5.36192H139.427H139.392C139.392 5.36192 139.392 5.36192 139.427 5.36192H139.392L139.461 5.32755C139.461 5.32755 139.495 5.32755 139.53 5.29318H139.564C139.53 5.29318 139.53 5.32755 139.495 5.32755C139.564 5.32755 139.633 5.29318 139.702 5.2588H139.736C139.702 5.2588 139.702 5.2588 139.667 5.2588C139.736 5.2588 139.667 5.29318 139.702 5.32755C139.702 5.32755 139.702 5.29318 139.667 5.32755L139.564 5.36192H139.599C139.702 5.32755 139.667 5.32755 139.633 5.32755C139.633 5.32755 139.633 5.32755 139.599 5.32755C139.599 5.32755 139.599 5.32755 139.564 5.32755C139.53 5.32755 139.495 5.36192 139.461 5.36192C139.392 5.36192 139.358 5.39629 139.289 5.43066L139.255 5.46504L139.049 5.56815C139.049 5.56815 139.049 5.56815 139.014 5.56815L138.946 5.60252H138.98C138.877 5.67126 138.911 5.60252 138.842 5.63689C138.842 5.63689 138.842 5.63689 138.808 5.63689L138.705 5.67127C138.705 5.67127 138.774 5.67127 138.842 5.63689C138.877 5.63689 138.877 5.63689 138.911 5.60252C138.946 5.60252 138.98 5.56815 139.014 5.53378C139.049 5.53378 139.049 5.53378 139.049 5.49941H139.083C139.117 5.46503 139.152 5.46503 139.186 5.43066C139.186 5.43066 139.289 5.39629 139.358 5.36192C139.358 5.36192 139.289 5.39629 139.255 5.39629C139.289 5.39629 139.324 5.36192 139.324 5.39629C139.358 5.39629 139.358 5.36192 139.392 5.36192H139.427H139.461C139.461 5.36192 139.427 5.36192 139.427 5.39629C139.427 5.39629 139.392 5.39629 139.358 5.39629H139.392C139.358 5.39629 139.358 5.39629 139.324 5.39629C139.152 5.46504 139.083 5.49941 138.946 5.56815C138.946 5.60252 138.911 5.63689 138.877 5.63689H138.842C138.842 5.63689 138.808 5.63689 138.774 5.63689C138.739 5.63689 138.739 5.63689 138.705 5.63689C138.808 5.56815 138.808 5.60252 138.842 5.56815C138.911 5.53378 138.842 5.56815 138.911 5.49941C138.877 5.53378 138.671 5.60252 138.636 5.63689C138.533 5.70564 138.567 5.74001 138.396 5.77438L138.327 5.80875C138.258 5.84312 138.189 5.91187 138.121 5.91187C138.052 5.94624 137.983 5.98061 137.914 6.01498C137.88 6.04935 137.914 6.01498 137.949 6.01498C137.846 6.08372 137.708 6.1181 137.571 6.15247L137.502 6.22121C137.536 6.22121 137.605 6.18684 137.605 6.18684C137.571 6.18684 137.536 6.22121 137.502 6.22121C137.536 6.22121 137.536 6.22121 137.571 6.22121H137.536C137.468 6.25558 137.502 6.18684 137.433 6.25558C137.399 6.25558 137.364 6.28995 137.33 6.25558L137.261 6.32433C137.227 6.32433 137.158 6.3587 137.124 6.3587H137.158C137.124 6.3587 137.055 6.3587 137.055 6.39307C137.055 6.42744 136.883 6.49618 136.849 6.53056C136.643 6.63367 136.402 6.73679 136.265 6.80553C136.23 6.8399 136.161 6.87427 136.196 6.87427C136.058 6.94302 135.955 6.97739 135.818 7.0805L135.886 7.04613C135.783 7.0805 135.715 7.14925 135.577 7.21799H135.611C135.611 7.21799 135.543 7.25236 135.508 7.25236C135.474 7.25236 135.543 7.25236 135.508 7.25236C135.233 7.42422 134.993 7.52733 134.718 7.66482C134.821 7.63045 134.821 7.63045 134.855 7.63045L134.787 7.66482C134.752 7.66482 134.683 7.69919 134.649 7.73357C134.512 7.83668 134.374 7.83668 134.202 7.9398L134.477 7.83668L134.443 7.87105L134.546 7.83668C134.477 7.87105 134.443 7.90542 134.443 7.90542H134.477C134.443 7.9398 134.408 7.93979 134.374 7.97417C134.512 7.90542 134.683 7.87105 134.821 7.76794L134.787 7.80231C134.821 7.76794 134.89 7.73356 134.924 7.69919H134.89H134.821C134.855 7.66482 134.89 7.63045 134.958 7.59608C135.027 7.56171 134.924 7.63045 134.89 7.63045C134.89 7.63045 134.924 7.63045 134.958 7.63045C134.958 7.63045 135.165 7.52733 135.165 7.49296C135.371 7.38985 135.165 7.52734 135.337 7.42422L135.371 7.38985C135.474 7.35548 135.577 7.28673 135.68 7.25236L135.783 7.18362H135.749C135.818 7.14925 135.886 7.11487 135.955 7.04613C136.058 7.01176 136.265 6.94302 136.368 6.87427C136.368 6.8399 136.196 6.94302 136.161 6.97739L136.265 6.90865C136.23 6.94302 136.161 6.94302 136.127 6.97739C136.196 6.94302 136.265 6.90864 136.333 6.87427C136.333 6.87427 136.333 6.87427 136.368 6.8399L136.54 6.77116C136.505 6.80553 136.505 6.80553 136.471 6.8399C136.471 6.8399 136.436 6.8399 136.402 6.87427C136.436 6.87427 136.368 6.90865 136.368 6.90865C136.471 6.87427 136.574 6.80553 136.608 6.77116C136.677 6.73679 136.78 6.66804 136.814 6.66804C136.918 6.5993 137.021 6.56493 137.089 6.53056C137.193 6.49618 137.296 6.46181 137.364 6.42744C137.399 6.42744 137.605 6.28995 137.708 6.25558C137.708 6.25558 137.639 6.28995 137.605 6.28995C137.674 6.25558 137.708 6.25558 137.743 6.22121C137.605 6.28996 137.743 6.22121 137.674 6.22121C137.743 6.18684 137.777 6.15247 137.846 6.15247C137.743 6.22121 137.914 6.15247 137.777 6.22121C137.846 6.22121 137.88 6.18684 137.949 6.15247H137.983L138.086 6.1181C138.086 6.1181 138.086 6.1181 138.121 6.08372H138.155C138.052 6.1181 138.189 6.04935 138.155 6.08372C138.224 6.04935 138.361 5.98061 138.43 5.94624C138.43 5.94624 138.464 5.94624 138.499 5.94624C138.533 5.91187 138.499 5.94624 138.464 5.94624L138.533 5.8775C138.533 5.8775 138.499 5.8775 138.464 5.8775C138.396 5.8775 138.292 5.98061 138.258 5.94624C138.327 5.91187 138.258 5.91187 138.327 5.91187L138.396 5.8775C138.533 5.84312 138.705 5.74001 138.877 5.63689H138.911C138.877 5.63689 138.842 5.67127 138.774 5.70564C138.774 5.70564 138.842 5.70564 138.842 5.67127H138.877C138.911 5.63689 138.946 5.67126 139.014 5.60252H139.049H139.083C139.083 5.60252 139.117 5.60252 139.152 5.56815L139.117 5.60252H139.083L139.049 5.63689H139.083C139.014 5.67127 138.946 5.70564 138.877 5.74001L138.774 5.80875C138.774 5.80875 138.808 5.77438 138.877 5.74001C138.774 5.77438 138.739 5.80875 138.671 5.84312H138.636L138.567 5.8775C138.567 5.8775 138.602 5.8775 138.636 5.8775C138.602 5.8775 138.567 5.8775 138.533 5.91187C138.464 5.91187 138.43 5.98061 138.361 5.98061C138.396 5.94624 138.464 5.94624 138.499 5.91187H138.464C138.464 5.91187 138.43 5.91187 138.396 5.94624H138.464H138.43C138.396 5.94624 138.396 5.98061 138.396 5.98061C138.361 5.98061 138.292 6.01498 138.292 6.04935C138.258 6.04935 138.189 6.08372 138.155 6.1181V6.15247H138.189H138.224L138.155 6.18684C138.121 6.18684 138.086 6.18684 138.052 6.18684C137.983 6.22121 137.949 6.25558 137.88 6.28995L137.811 6.32433C137.708 6.39307 137.605 6.42744 137.502 6.49619C137.536 6.46181 137.571 6.46181 137.605 6.42744C137.571 6.46181 137.639 6.42744 137.605 6.42744L137.502 6.46181L137.433 6.49619C137.502 6.49619 137.536 6.46181 137.605 6.42744C137.536 6.46181 137.468 6.49618 137.399 6.53056L137.468 6.49619H137.399C137.296 6.53056 137.193 6.56493 137.124 6.63367C137.158 6.63367 137.158 6.63367 137.124 6.63367C137.021 6.70241 136.918 6.77116 136.814 6.8399C136.883 6.80553 136.883 6.77116 136.883 6.77116L136.814 6.80553V6.94302H136.78C136.78 6.94302 136.78 6.94302 136.814 6.94302C136.78 6.97739 136.711 6.97739 136.711 7.01176C136.746 7.01176 136.78 7.01176 136.746 7.04613C136.78 7.01176 136.918 6.94302 136.986 6.90865C136.918 6.90865 136.849 6.94302 136.78 6.97739C136.78 6.90864 136.986 6.87427 136.986 6.8399C137.021 6.8399 137.055 6.80553 137.089 6.77116C137.089 6.77116 137.124 6.77116 137.158 6.73679C137.227 6.73679 137.296 6.70241 137.364 6.63367H137.433C137.33 6.70241 137.227 6.77116 137.089 6.8399H137.124C137.055 6.87427 137.021 6.90864 136.952 6.94302C136.849 6.97739 136.883 6.97739 136.849 7.04613C136.78 7.0805 136.746 7.11487 136.677 7.14925H136.711L136.677 7.18362C136.677 7.18362 136.643 7.18362 136.643 7.21799C136.608 7.25236 136.574 7.25236 136.54 7.28673L136.677 7.18362C136.608 7.21799 136.643 7.18362 136.574 7.21799C136.677 7.18362 136.505 7.25236 136.505 7.28673L136.436 7.3211C136.402 7.35548 136.368 7.35548 136.333 7.38985C136.402 7.35548 136.436 7.28673 136.54 7.28673C136.471 7.3211 136.333 7.38985 136.333 7.38985C136.265 7.42422 136.23 7.45859 136.161 7.49296C136.265 7.42422 136.161 7.56171 136.368 7.42422C136.368 7.42422 136.368 7.42422 136.333 7.42422C136.333 7.38985 136.471 7.35548 136.54 7.3211L136.505 7.35548C136.54 7.32111 136.402 7.35548 136.333 7.42422H136.368L136.265 7.49296C136.196 7.52733 136.127 7.59608 136.058 7.63045C135.99 7.66482 135.749 7.80231 135.852 7.73357C135.783 7.76794 135.715 7.83668 135.646 7.87105L135.749 7.80231C135.68 7.83668 135.611 7.87105 135.543 7.90542C135.371 8.00854 135.233 8.11165 135.062 8.21477C135.027 8.24914 134.993 8.24914 134.958 8.28351C134.924 8.28351 134.924 8.31788 134.89 8.31788C134.89 8.31788 134.89 8.31788 134.924 8.31788C134.89 8.35225 134.855 8.35225 134.821 8.38662C134.787 8.38662 134.821 8.35225 134.718 8.421C134.683 8.421 134.615 8.45537 134.58 8.48974C134.58 8.48974 134.546 8.48974 134.512 8.52411C134.477 8.55848 134.408 8.59286 134.408 8.59286C134.374 8.62723 134.271 8.69597 134.305 8.69597C134.374 8.62723 134.443 8.59285 134.546 8.55848H134.58C134.58 8.55848 134.615 8.55848 134.615 8.52411C134.649 8.48974 134.718 8.45537 134.752 8.421C134.752 8.421 134.718 8.48974 134.683 8.48974C134.683 8.48974 134.924 8.35225 134.855 8.421C134.718 8.52411 134.649 8.48974 134.546 8.59286C134.615 8.55849 134.649 8.52411 134.752 8.48974L134.649 8.55848L134.58 8.59286C134.443 8.69597 134.408 8.6616 134.271 8.76471C134.34 8.69597 134.237 8.76471 134.271 8.69597V8.6616C134.271 8.6616 134.065 8.76471 134.099 8.76471C134.133 8.73034 134.202 8.69597 134.271 8.6616C134.202 8.69597 134.168 8.73034 134.202 8.73034C134.408 8.62723 134.237 8.73034 134.408 8.62723C134.374 8.6616 134.477 8.62723 134.374 8.69597C134.271 8.76471 134.374 8.6616 134.271 8.73034C134.202 8.76471 134.202 8.76471 134.133 8.79909C134.065 8.86783 134.03 8.83346 133.996 8.9022C133.996 8.86783 133.927 8.9022 133.893 8.93657C133.962 8.86783 134.03 8.83346 134.099 8.76471C134.133 8.76471 134.099 8.76471 134.168 8.76471L134.065 8.83346L134.133 8.79909L134.202 8.73034C134.099 8.79908 134.133 8.73034 134.065 8.76471C133.962 8.83346 133.996 8.79909 133.927 8.86783C133.927 8.86783 133.755 9.00531 133.652 9.07406L133.687 9.03969C133.79 9.00531 133.652 9.07406 133.652 9.10843L133.584 9.1428C133.515 9.17717 133.48 9.17717 133.412 9.24592C133.412 9.24592 133.48 9.24592 133.446 9.24592C133.412 9.31466 133.343 9.34903 133.309 9.3834C133.274 9.3834 133.274 9.41777 133.24 9.41777L133.171 9.48652C133.24 9.45215 133.274 9.3834 133.343 9.3834C133.377 9.34903 133.446 9.31466 133.48 9.31466C133.412 9.34903 133.377 9.3834 133.309 9.41777H133.377H133.343C133.446 9.34903 133.515 9.31466 133.618 9.24592C133.721 9.21154 133.79 9.10843 133.927 9.07406H133.893L134.237 8.9022C134.237 8.9022 134.271 8.9022 134.305 8.86783L134.477 8.76471L134.443 8.79909C134.408 8.79909 134.305 8.9022 134.305 8.86783C134.271 8.9022 134.168 8.97094 134.133 8.97094C134.202 8.9022 134.065 8.97094 134.065 8.97094L133.962 9.03969C133.962 9.03969 133.996 9.00532 134.03 9.00532C134.133 8.97094 133.927 9.10843 133.996 9.03969C133.893 9.10843 133.721 9.21155 133.584 9.28029L133.652 9.24592C133.618 9.28029 133.48 9.34903 133.48 9.3834C133.515 9.34903 133.584 9.31466 133.618 9.28029C133.618 9.28029 133.515 9.34903 133.515 9.3834L133.412 9.41777C133.309 9.48652 133.24 9.52089 133.137 9.62401C133.24 9.58963 133.309 9.52089 133.377 9.45215C133.446 9.41778 133.343 9.48652 133.412 9.45215C133.377 9.48652 133.343 9.48652 133.309 9.52089H133.274C133.309 9.48652 133.377 9.48652 133.412 9.45215C133.48 9.41778 133.515 9.3834 133.584 9.34903H133.549C133.618 9.28029 133.687 9.24592 133.755 9.21154C133.755 9.21154 133.721 9.24592 133.687 9.24592C133.687 9.24592 133.755 9.21154 133.79 9.21154C133.721 9.24592 133.79 9.21154 133.755 9.24592C133.79 9.21154 133.859 9.17717 133.893 9.1428C133.893 9.10843 133.859 9.1428 133.859 9.1428C133.927 9.10843 133.927 9.07406 133.996 9.03969C133.893 9.10843 134.03 9.03969 134.099 9.03969C134.133 9.03969 134.168 9.00532 134.202 8.97094C134.168 9.00532 134.099 9.03969 134.099 9.00532C134.133 9.00532 134.168 8.97094 134.202 8.93657H134.168L134.305 8.83346C134.34 8.83346 134.374 8.83346 134.408 8.83346C134.443 8.79909 134.477 8.76471 134.512 8.76471C134.58 8.69597 134.649 8.6616 134.718 8.62723C134.752 8.59286 134.374 8.79909 134.683 8.59286C134.787 8.52411 134.787 8.55848 134.855 8.52411C134.89 8.52411 134.924 8.48974 134.958 8.45537C134.924 8.48974 134.89 8.48974 134.855 8.52411C134.89 8.52411 134.958 8.45537 135.027 8.421C134.958 8.421 135.13 8.35225 135.062 8.35225C135.165 8.28351 135.233 8.24914 135.337 8.1804C135.405 8.11165 135.474 8.11165 135.577 8.00854C135.577 8.00854 135.543 8.04291 135.508 8.04291C135.44 8.07728 135.611 7.97417 135.508 8.00854L135.44 8.04291L135.543 7.97417H135.508L135.646 7.87105C135.818 7.76793 136.024 7.66482 136.161 7.56171C136.23 7.56171 136.54 7.35548 136.677 7.3211C136.643 7.3211 136.608 7.3211 136.608 7.3211C136.574 7.3211 136.505 7.35548 136.471 7.38985C136.471 7.38985 136.402 7.45859 136.436 7.42422C136.265 7.52734 136.436 7.38985 136.402 7.42422C136.608 7.32111 136.711 7.28673 136.849 7.21799L136.952 7.18362C136.883 7.21799 136.918 7.25236 136.986 7.18362C137.055 7.11487 137.158 7.0805 137.227 7.04613H137.296C137.33 7.04613 137.364 6.97739 137.399 6.94302C137.502 6.87427 137.605 6.8399 137.708 6.80553C137.743 6.77116 137.949 6.66804 137.811 6.70241C137.949 6.63367 137.949 6.70242 138.121 6.56493C138.121 6.56493 138.155 6.56493 138.155 6.53056L138.224 6.49619L138.396 6.42744L138.464 6.39307L138.567 6.3587C138.567 6.3587 138.602 6.3587 138.602 6.32433L138.636 6.28995C138.636 6.28995 138.671 6.25558 138.705 6.22121C138.636 6.25558 138.739 6.22121 138.774 6.22121C138.808 6.22121 138.808 6.22121 138.842 6.18684C138.808 6.18684 138.774 6.22121 138.774 6.18684C138.774 6.18684 138.808 6.18684 138.842 6.15247H138.808L138.911 6.08372C138.946 6.08372 138.808 6.15247 138.911 6.1181C138.911 6.1181 138.911 6.1181 138.946 6.04935H138.98C138.98 6.04935 139.014 6.01498 139.049 6.01498C139.049 6.01498 139.083 5.98061 139.117 5.98061C139.186 5.94624 139.289 5.91187 139.358 5.8775C139.358 5.8775 139.392 5.87749 139.392 5.84312C139.427 5.84312 139.495 5.80875 139.53 5.77438C139.53 5.77438 139.495 5.77438 139.427 5.80875L139.461 5.77438C139.53 5.74001 139.599 5.70564 139.667 5.70564C139.77 5.67127 139.839 5.63689 139.942 5.60252H139.874C139.977 5.53378 140.08 5.49941 140.217 5.43066C140.183 5.43066 140.149 5.46504 140.114 5.46504C140.183 5.43066 140.286 5.39629 140.355 5.36192L140.527 5.29318C140.527 5.29318 140.63 5.22443 140.561 5.2588C140.63 5.22443 140.733 5.19006 140.802 5.15569C140.905 5.08695 140.698 5.19006 140.664 5.19006C140.802 5.12132 140.939 5.05258 141.077 5.0182C141.042 5.0182 141.042 5.05258 141.042 5.05258C141.077 5.05258 141.111 5.0182 141.145 4.98383H141.18C141.214 4.94946 141.248 4.94946 141.18 4.98383C141.248 4.98383 141.317 4.94946 141.386 4.91509C141.283 4.94946 141.18 5.0182 141.111 5.0182C141.317 4.91509 141.317 4.91509 141.558 4.7776C141.661 4.74323 141.592 4.7776 141.627 4.7776C141.558 4.7776 141.523 4.84635 141.455 4.88072H141.489L141.558 4.84635H141.592C141.592 4.84635 141.661 4.7776 141.73 4.74323C141.661 4.7776 141.695 4.7776 141.661 4.81197C141.764 4.7776 141.764 4.74323 141.867 4.70886C141.867 4.70886 141.764 4.74323 141.833 4.70886C141.936 4.67449 141.901 4.70886 141.936 4.67449C141.867 4.67449 141.901 4.67449 141.833 4.67449L141.661 4.74323L141.764 4.67449C141.661 4.70886 141.661 4.67449 141.661 4.67449C141.833 4.57137 141.798 4.64012 141.936 4.57137C141.833 4.60574 142.005 4.57137 141.936 4.57137C142.039 4.537 141.97 4.57137 142.073 4.537C142.108 4.537 142.142 4.50263 142.176 4.50263C142.211 4.50263 142.142 4.57137 142.348 4.50263H142.383C142.589 4.39951 142.692 4.36514 142.898 4.2964C142.933 4.2964 142.933 4.2964 142.967 4.26203L143.07 4.22766C143.036 4.26203 143.139 4.19328 143.07 4.22766C143.07 4.22766 143.104 4.22766 143.104 4.19328C143.104 4.19328 143.07 4.19328 143.104 4.22766V4.19328H143.173C143.173 4.19328 143.208 4.19328 143.242 4.15891H143.276C143.311 4.15891 143.345 4.12454 143.379 4.12454C143.345 4.12454 143.379 4.12454 143.345 4.15891C143.345 4.15891 143.379 4.12454 143.414 4.12454C143.414 4.12454 143.414 4.09017 143.448 4.09017C143.483 4.09017 143.483 4.09017 143.483 4.0558C143.551 4.0558 143.483 4.09017 143.483 4.12454C143.551 4.12454 143.483 4.09017 143.551 4.09017C143.586 4.09017 143.551 4.12454 143.586 4.12454C143.586 4.12454 143.483 4.15891 143.483 4.19328C143.483 4.19328 143.551 4.19328 143.551 4.15891C143.586 4.15891 143.586 4.15891 143.654 4.15891C143.654 4.15891 143.654 4.15891 143.654 4.12454C143.689 4.12454 143.689 4.15891 143.723 4.15891C143.723 4.15891 143.689 4.15891 143.723 4.12454H143.689C143.689 4.12454 143.689 4.12454 143.689 4.09017C143.689 4.09017 143.723 4.09017 143.758 4.09017C143.723 4.09017 143.826 4.0558 143.792 4.0558C143.826 4.0558 143.826 4.0558 143.861 4.0558C143.826 4.09017 143.826 4.09017 143.826 4.12454H143.861C143.826 4.12454 143.861 4.12454 143.826 4.12454C143.826 4.12454 143.861 4.12454 143.895 4.12454C143.895 4.12454 143.895 4.12454 143.861 4.15891C143.861 4.15891 143.929 4.12454 143.964 4.15891C144.033 4.12454 144.067 4.12454 144.136 4.09017C144.136 4.09017 144.101 4.09017 144.067 4.09017C144.067 4.09017 144.136 4.09017 144.136 4.0558C144.136 4.0558 144.136 4.09017 144.136 4.12454C144.136 4.12454 144.204 4.09017 144.17 4.12454L144.204 4.09017C144.204 4.09017 144.204 4.09017 144.204 4.12454C144.239 4.12454 144.273 4.12454 144.308 4.12454C144.308 4.12454 144.342 4.12454 144.342 4.09017C144.342 4.09017 144.342 4.09017 144.308 4.09017C144.342 4.09017 144.342 4.09017 144.376 4.09017C144.376 4.12454 144.411 4.12454 144.479 4.09017C144.479 4.09017 144.445 4.09017 144.411 4.09017H144.445C144.445 4.09017 144.479 4.09017 144.445 4.0558C144.445 4.0558 144.479 4.0558 144.514 4.0558C144.514 4.0558 144.514 4.0558 144.514 4.09017C144.514 4.09017 144.514 4.09017 144.548 4.09017C144.548 4.09017 144.548 4.12454 144.582 4.12454C144.582 4.12454 144.514 4.12454 144.514 4.15891C144.514 4.15891 144.514 4.15891 144.479 4.15891C144.479 4.15891 144.514 4.15891 144.514 4.19328C144.548 4.19328 144.514 4.19328 144.514 4.15891C144.548 4.15891 144.582 4.15891 144.582 4.15891C144.617 4.15891 144.651 4.12454 144.686 4.12454H144.72C144.72 4.12454 144.72 4.12454 144.72 4.09017C144.754 4.09017 144.823 4.09017 144.857 4.0558C144.857 4.0558 144.857 4.09017 144.823 4.09017C144.823 4.09017 144.892 4.09017 144.857 4.0558C144.892 4.0558 144.892 4.0558 144.926 4.0558H144.892C144.961 4.0558 145.029 4.0558 145.098 4.02143C145.064 4.0558 145.132 4.02143 145.132 4.02143C145.132 4.02143 145.132 4.02143 145.167 3.98706C145.167 3.98706 145.167 3.98706 145.132 3.98706C145.132 3.98706 145.201 3.98706 145.236 3.98706H145.201C145.236 3.98706 145.27 3.98706 145.304 3.98706C145.304 3.98706 145.304 3.98705 145.304 3.95268C145.304 3.95268 145.27 3.95268 145.304 3.91831C145.339 3.91831 145.339 3.91831 145.373 3.95268C145.442 3.95268 145.511 3.95268 145.511 3.91831C145.545 3.91831 145.511 3.91831 145.511 3.95268C145.511 3.98705 145.579 3.91831 145.545 3.91831C145.579 3.91831 145.579 3.91831 145.579 3.91831C145.579 3.91831 145.579 3.91831 145.579 3.88394C145.614 3.88394 145.614 3.88394 145.614 3.91831C145.614 3.91831 145.614 3.91831 145.648 3.91831C145.682 3.91831 145.682 3.88394 145.717 3.88394C145.682 3.88394 145.682 3.91831 145.682 3.91831C145.648 3.91831 145.751 3.91831 145.785 3.91831H145.751C145.785 3.91831 145.82 3.91831 145.854 3.88394C145.889 3.88394 145.854 3.91831 145.854 3.91831C145.854 3.91831 145.889 3.88394 145.923 3.88394H145.957C146.026 3.84957 146.06 3.84957 146.129 3.84957C146.164 3.88394 146.335 3.84957 146.404 3.8152C146.404 3.8152 146.404 3.8152 146.439 3.8152C146.439 3.8152 146.439 3.8152 146.404 3.8152C146.439 3.8152 146.507 3.78083 146.542 3.8152C146.576 3.8152 146.61 3.78082 146.645 3.78082C146.748 3.74645 146.817 3.74645 146.92 3.74645C146.954 3.74645 146.954 3.74645 146.988 3.74645C147.023 3.74645 147.126 3.71208 147.195 3.71208V3.67771C147.229 3.67771 147.263 3.67771 147.263 3.67771C147.263 3.67771 147.263 3.67771 147.298 3.67771C147.298 3.67771 147.263 3.67771 147.298 3.71208C147.332 3.71208 147.332 3.71208 147.367 3.71208C147.332 3.67771 147.47 3.67771 147.504 3.67771C147.47 3.67771 147.504 3.71208 147.47 3.71208C147.47 3.71208 147.47 3.71208 147.504 3.71208C147.573 3.71208 147.573 3.71208 147.607 3.71208C147.642 3.71208 147.642 3.71208 147.676 3.67771C147.676 3.67771 147.71 3.67771 147.745 3.67771H147.779C147.779 3.67771 147.779 3.67771 147.813 3.67771C147.848 3.67771 147.779 3.67771 147.779 3.67771C147.779 3.71208 147.745 3.71208 147.745 3.74645C147.848 3.71208 147.882 3.64334 147.985 3.5746C148.02 3.5746 147.917 3.60897 147.985 3.60897C147.985 3.60897 147.951 3.60897 147.951 3.64334C147.917 3.64334 147.917 3.64334 147.917 3.64334H147.951C147.951 3.64334 147.917 3.67771 147.951 3.67771C147.951 3.67771 147.882 3.71208 147.917 3.71208C147.951 3.71208 147.985 3.71208 147.985 3.71208C147.985 3.67771 148.054 3.64334 148.054 3.60897C148.088 3.60897 148.088 3.5746 148.088 3.5746C148.123 3.5746 148.191 3.5746 148.191 3.5746C148.191 3.5746 148.157 3.5746 148.123 3.5746C148.088 3.5746 148.157 3.60897 148.123 3.64334C148.123 3.64334 148.157 3.64334 148.191 3.64334C148.191 3.60897 148.192 3.60897 148.26 3.5746C148.26 3.5746 148.26 3.5746 148.226 3.5746C148.26 3.5746 148.295 3.54022 148.329 3.54022C148.329 3.54022 148.329 3.54022 148.329 3.5746C148.329 3.60897 148.398 3.5746 148.398 3.5746C148.398 3.5746 148.363 3.5746 148.329 3.5746C148.26 3.60897 148.329 3.60897 148.295 3.64334C148.329 3.64334 148.329 3.64334 148.295 3.67771H148.329C148.329 3.67771 148.329 3.67771 148.363 3.67771C148.398 3.67771 148.398 3.67771 148.398 3.67771H148.363C148.398 3.64334 148.466 3.57459 148.501 3.60897C148.466 3.60897 148.501 3.64334 148.501 3.67771C148.466 3.67771 148.432 3.71208 148.466 3.74645C148.604 3.67771 148.57 3.57459 148.707 3.54022C148.741 3.54022 148.707 3.5746 148.741 3.5746C148.673 3.60897 148.673 3.67771 148.638 3.71208C148.707 3.71208 148.673 3.64334 148.741 3.64334C148.741 3.60897 148.81 3.57459 148.81 3.54022C148.81 3.54022 148.81 3.54022 148.845 3.54022C148.879 3.54022 148.913 3.50585 148.948 3.50585C148.948 3.54022 148.879 3.57459 148.913 3.60897C148.879 3.64334 148.879 3.64334 148.879 3.67771C148.982 3.64334 149.016 3.57459 148.982 3.54022H149.016C148.982 3.50585 149.085 3.43711 149.016 3.43711C149.051 3.43711 149.051 3.43711 149.016 3.40274C149.085 3.40274 149.12 3.33399 149.154 3.36836C149.154 3.36836 149.12 3.40274 149.154 3.40274C149.154 3.40274 149.154 3.40274 149.12 3.40274H149.154C149.188 3.40274 149.188 3.36837 149.223 3.33399C149.188 3.33399 149.223 3.33399 149.223 3.29962C149.223 3.29962 149.257 3.29962 149.291 3.29962C149.257 3.29962 149.291 3.26525 149.291 3.26525C149.291 3.26525 149.291 3.26525 149.326 3.26525C149.326 3.23088 149.36 3.16214 149.326 3.12776C149.326 3.12776 149.36 3.12776 149.36 3.09339C149.291 3.09339 149.326 3.05902 149.326 3.05902C149.36 3.05902 149.394 3.05902 149.429 3.05902C149.394 3.05902 149.429 3.02465 149.395 3.02465H149.429C149.463 3.02465 149.498 2.99028 149.532 3.02465C149.601 3.02465 149.669 2.99028 149.738 2.99028C149.738 2.99028 149.773 2.99028 149.807 2.99028C149.841 2.99028 149.91 2.95591 149.979 2.99028C149.979 2.99028 149.979 2.99028 149.979 2.95591C150.013 2.95591 150.013 2.95591 150.013 2.95591C150.013 2.95591 150.013 2.95591 150.048 2.95591C150.048 2.95591 150.013 2.95591 150.048 2.99028C150.082 2.99028 150.082 2.99028 150.082 2.99028C150.048 2.95591 150.151 2.95591 150.185 2.95591C150.185 2.95591 150.185 2.99028 150.151 2.99028C150.219 2.99028 150.185 2.99028 150.219 2.99028C150.254 2.99028 150.254 2.99028 150.288 2.99028C150.288 2.99028 150.323 3.02465 150.323 2.99028H150.357C150.357 2.99028 150.357 2.99028 150.391 2.99028C150.426 2.99028 150.357 2.99028 150.357 2.99028C150.357 3.02465 150.323 3.02465 150.323 3.05902C150.391 3.02465 150.46 2.9559 150.529 2.92153C150.563 2.92153 150.494 2.95591 150.529 2.95591C150.529 2.95591 150.494 2.95591 150.494 2.99028C150.494 2.99028 150.46 3.02465 150.494 3.02465C150.494 3.02465 150.426 3.05902 150.46 3.05902C150.46 3.05902 150.494 3.05902 150.529 3.05902C150.529 3.02465 150.598 3.02465 150.598 2.99028C150.598 2.99028 150.632 2.99028 150.632 2.95591C150.666 2.95591 150.701 2.95591 150.701 2.95591H150.666C150.666 2.95591 150.701 3.02465 150.666 3.02465C150.666 3.02465 150.666 3.02465 150.701 3.02465C150.701 2.99028 150.701 2.99028 150.735 2.95591C150.769 2.95591 150.769 2.92153 150.804 2.92153C150.804 2.92153 150.804 2.92153 150.804 2.95591C150.804 2.99028 150.838 2.95591 150.838 2.95591H150.804C150.769 2.99028 150.804 2.99028 150.769 3.02465C150.769 3.02465 150.804 3.02465 150.769 3.05902H150.804C150.838 3.02465 150.907 2.92153 150.941 2.95591C150.941 2.95591 150.907 2.99028 150.941 3.02465C150.941 3.02465 150.872 3.05902 150.907 3.09339C151.01 3.05902 151.01 2.92153 151.113 2.88716V2.92153C151.079 2.9559 151.044 3.02465 151.01 3.05902C151.079 3.05902 151.044 2.99028 151.113 2.99028C151.113 2.95591 151.182 2.92153 151.182 2.88716C151.182 2.88716 151.182 2.88716 151.216 2.88716C151.251 2.88716 151.285 2.85279 151.285 2.85279C151.285 2.88716 151.216 2.92153 151.251 2.95591C151.216 2.95591 151.216 2.99028 151.216 3.02465C151.285 3.02465 151.319 2.92153 151.319 2.88716C151.319 2.85279 151.354 2.88716 151.354 2.88716C151.354 2.85279 151.422 2.78405 151.388 2.78405C151.422 2.78405 151.422 2.78405 151.388 2.74968C151.422 2.74968 151.457 2.7153 151.491 2.7153C151.491 2.7153 151.457 2.74968 151.491 2.74968H151.457C151.457 2.74968 151.457 2.74968 151.422 2.74968C151.457 2.74968 151.457 2.7153 151.491 2.68093C151.491 2.68093 151.491 2.68093 151.491 2.64656H151.526V2.61219C151.526 2.61219 151.526 2.61219 151.56 2.61219C151.56 2.57782 151.594 2.50907 151.56 2.4747C151.491 2.40596 151.526 2.40596 151.526 2.40596ZM148.913 3.29962C148.948 3.29962 149.016 3.29962 149.016 3.29962H148.982C149.016 3.29962 149.051 3.29962 149.085 3.29962C149.085 3.29962 148.948 3.29962 148.913 3.29962ZM148.776 3.33399C148.81 3.33399 148.776 3.33399 148.845 3.29962H148.879C148.879 3.29962 148.913 3.29962 148.879 3.33399H148.845H148.81C148.845 3.33399 148.845 3.33399 148.879 3.33399C148.845 3.33399 148.81 3.33399 148.81 3.33399C148.81 3.33399 148.845 3.33399 148.845 3.36836C148.81 3.36836 148.776 3.36837 148.776 3.40274C148.741 3.40274 148.707 3.43711 148.673 3.40274C148.673 3.40274 148.707 3.40274 148.673 3.36836C148.707 3.36836 148.707 3.36836 148.707 3.36836C148.707 3.36836 148.707 3.36837 148.741 3.33399C148.776 3.40274 148.776 3.36837 148.776 3.33399C148.776 3.36837 148.776 3.36837 148.776 3.33399ZM148.81 3.29962C148.845 3.29962 148.879 3.26525 148.913 3.29962C148.879 3.29962 148.81 3.33399 148.81 3.29962ZM148.776 3.29962H148.81C148.776 3.29962 148.741 3.33399 148.707 3.29962C148.707 3.33399 148.741 3.29962 148.776 3.29962ZM139.564 5.22443C139.53 5.22443 139.53 5.22443 139.564 5.22443C139.53 5.22443 139.53 5.22443 139.53 5.22443H139.495C139.53 5.22443 139.564 5.19006 139.564 5.22443ZM139.77 5.15569C139.736 5.15569 139.702 5.19006 139.667 5.15569C139.702 5.15569 139.702 5.15569 139.77 5.15569ZM139.392 4.84635C139.392 4.84635 139.392 4.7776 139.461 4.7776C139.392 4.81197 139.427 4.81197 139.392 4.84635ZM139.255 4.88072C139.22 4.91509 139.22 4.88072 139.186 4.88072H139.255ZM139.702 4.70886C139.702 4.70886 139.77 4.70886 139.736 4.67449C139.77 4.67449 139.805 4.64012 139.805 4.64012L139.77 4.67449C139.77 4.67449 139.77 4.67449 139.805 4.67449C139.805 4.67449 139.839 4.64012 139.839 4.67449C139.805 4.64012 139.702 4.70886 139.702 4.70886ZM142.623 3.54022C142.589 3.54022 142.555 3.54022 142.555 3.54022C142.589 3.54022 142.623 3.54022 142.623 3.54022ZM144.136 2.50907C144.101 2.50907 144.101 2.50907 144.136 2.50907V2.50907ZM144.686 2.30284H144.651C144.651 2.30284 144.651 2.30284 144.686 2.30284ZM149.566 1.40918C149.532 1.40918 149.532 1.40918 149.566 1.40918V1.40918ZM151.319 1.85601C151.319 1.89038 151.354 1.85601 151.354 1.85601C151.319 1.89038 151.251 1.85601 151.319 1.85601ZM142.039 3.19651C142.039 3.16213 142.039 3.16213 142.039 3.19651C142.073 3.12776 142.108 3.16214 142.108 3.16214C142.142 3.12776 142.108 3.16213 142.039 3.19651ZM142.417 3.02465C142.348 3.02465 142.28 3.09339 142.28 3.05902L142.245 3.09339C142.211 3.09339 142.245 3.12776 142.314 3.09339C142.314 3.09339 142.314 3.09339 142.348 3.09339H142.314C142.28 3.09339 142.28 3.09339 142.245 3.09339C142.211 3.09339 142.176 3.05902 142.142 3.05902C142.176 3.05902 142.211 3.02465 142.245 3.02465C142.245 3.02465 142.245 3.02465 142.28 3.02465C142.314 3.02465 142.314 3.02465 142.348 3.02465C142.348 3.02465 142.348 3.02465 142.417 3.02465C142.417 3.02465 142.383 3.02465 142.348 3.02465C142.383 3.05902 142.417 3.02465 142.417 3.02465ZM144.789 2.78405C144.789 2.78405 144.823 2.78405 144.857 2.78405C144.857 2.78405 144.823 2.78405 144.789 2.78405C144.823 2.78405 144.754 2.81842 144.789 2.78405ZM141.936 3.95268C141.936 3.98705 141.936 3.98705 141.936 3.95268C141.901 3.98705 141.901 3.95268 141.867 3.98706C141.867 3.98706 141.901 3.95268 141.833 3.98706C141.833 3.98706 141.867 3.98705 141.867 3.95268C141.901 3.95268 141.901 4.02143 141.936 3.95268ZM141.833 3.91831C141.833 3.95268 141.833 3.95268 141.833 3.91831L141.798 3.95268C141.798 3.95268 141.798 3.95268 141.764 3.95268C141.73 3.95268 141.73 3.95268 141.73 3.95268H141.764C141.764 3.98705 141.833 3.91831 141.867 3.91831C141.833 3.91831 141.833 3.91831 141.833 3.91831ZM141.386 4.12454C141.352 4.15891 141.283 4.15891 141.283 4.19328C141.283 4.19328 141.283 4.19328 141.317 4.19328C141.317 4.19328 141.317 4.19328 141.317 4.22766C141.317 4.26203 141.317 4.22766 141.283 4.22766C141.317 4.22766 141.283 4.22766 141.283 4.19328C141.317 4.19328 141.352 4.12454 141.386 4.12454ZM139.942 4.81197C139.942 4.81197 139.908 4.81197 139.874 4.81197C139.908 4.81197 139.908 4.81197 139.942 4.81197ZM139.564 4.94946C139.53 4.98383 139.53 4.98383 139.53 4.98383C139.53 4.94946 139.53 4.94946 139.564 4.94946ZM140.114 4.94946C140.183 4.91509 140.183 4.88072 140.114 4.91509C140.149 4.91509 140.183 4.88072 140.217 4.88072C140.217 4.88072 140.252 4.88072 140.286 4.88072C140.286 4.88072 140.286 4.88072 140.32 4.84635H140.355H140.389H140.32H140.217C140.252 4.7776 140.32 4.81197 140.32 4.7776C140.355 4.7776 140.389 4.7776 140.424 4.74323C140.458 4.74323 140.492 4.70886 140.527 4.70886L140.561 4.67449C140.527 4.67449 140.458 4.67449 140.424 4.70886C140.458 4.70886 140.492 4.67449 140.527 4.67449C140.527 4.67449 140.527 4.67449 140.561 4.67449C140.595 4.67449 140.595 4.67449 140.595 4.64012C140.595 4.64012 140.595 4.64012 140.63 4.64012H140.664C140.63 4.64012 140.595 4.67449 140.561 4.67449H140.595C140.595 4.67449 140.595 4.67449 140.595 4.70886C140.63 4.67449 140.698 4.67449 140.767 4.64012C140.733 4.64012 140.733 4.64012 140.767 4.64012C140.802 4.64012 140.802 4.64012 140.87 4.60574C140.905 4.60574 140.87 4.64012 140.905 4.60574C140.905 4.60574 140.905 4.60574 140.939 4.57137H140.973C141.008 4.57137 141.008 4.57137 141.008 4.57137C141.042 4.57137 141.008 4.537 141.042 4.57137C141.077 4.537 141.008 4.57137 141.077 4.537C141.145 4.50263 141.111 4.537 141.145 4.537C141.18 4.537 141.18 4.57137 141.18 4.57137L141.145 4.60574H141.111C141.077 4.60574 141.077 4.60574 141.042 4.60574C141.077 4.60574 141.042 4.60574 141.042 4.64012H141.077L140.939 4.70886C140.905 4.74323 141.077 4.67449 141.077 4.67449L141.18 4.64012C141.18 4.64012 140.973 4.74323 141.077 4.67449L141.18 4.64012C141.283 4.60574 141.248 4.60574 141.283 4.60574C141.283 4.60574 141.283 4.60574 141.317 4.60574C141.317 4.60574 141.317 4.60574 141.283 4.60574C141.283 4.60574 141.283 4.60574 141.317 4.60574C141.248 4.60574 141.214 4.64012 141.18 4.67449C141.214 4.67449 141.248 4.64012 141.283 4.64012L141.008 4.7776L141.111 4.70886C141.077 4.74323 141.008 4.74323 140.973 4.7776H140.939H140.905L140.973 4.74323H140.939C140.939 4.74323 140.973 4.74323 140.973 4.70886H140.939C140.939 4.70886 140.939 4.70886 140.905 4.70886L140.664 4.81197H140.698C140.63 4.84635 140.63 4.81197 140.561 4.84635H140.527H140.492C140.492 4.84635 140.492 4.84635 140.527 4.84635L140.733 4.81197C140.698 4.81197 140.733 4.7776 140.802 4.74323H140.767C140.802 4.74323 140.836 4.74323 140.87 4.70886C140.87 4.70886 140.87 4.70886 140.87 4.74323L140.802 4.7776H140.767L140.698 4.81197H140.664C140.63 4.81197 140.595 4.81197 140.561 4.84635C140.561 4.84635 140.527 4.84635 140.492 4.84635L140.424 4.88072C140.389 4.88072 140.32 4.91509 140.32 4.91509C140.32 4.91509 140.286 4.91509 140.252 4.91509C140.252 4.91509 140.286 4.91509 140.32 4.91509C140.355 4.91509 140.355 4.91509 140.355 4.91509L140.32 4.94946C140.32 4.94946 140.286 4.94946 140.286 4.98383H140.252C140.252 4.98383 140.32 4.98383 140.32 4.94946C140.286 4.98383 140.286 4.94946 140.286 4.94946C140.286 4.94946 140.32 4.94946 140.252 4.98383C140.114 4.94946 140.114 4.94946 140.114 4.94946ZM139.461 5.53378C139.427 5.53378 139.427 5.53378 139.461 5.53378C139.461 5.49941 139.461 5.53378 139.495 5.53378C139.53 5.53378 139.495 5.53378 139.461 5.53378C139.495 5.53378 139.53 5.53378 139.564 5.49941L139.461 5.53378ZM138.636 6.04935L138.671 6.01498C138.739 5.98061 138.739 5.98061 138.739 6.01498L138.636 6.04935C138.671 6.04935 138.671 6.04935 138.636 6.04935ZM137.914 6.56493L137.846 6.63367H137.777C137.846 6.5993 137.88 6.56493 137.983 6.53056C137.88 6.5993 138.017 6.53056 138.017 6.53056C137.983 6.56493 137.914 6.56493 137.983 6.53056L138.017 6.49619C138.086 6.46181 138.121 6.42744 138.189 6.39307C138.189 6.42744 138.121 6.46181 138.086 6.49619H138.052L138.017 6.53056C137.983 6.53056 137.983 6.56493 137.949 6.56493C137.983 6.56493 137.914 6.5993 137.914 6.56493C137.983 6.53056 137.949 6.56493 137.914 6.56493ZM137.949 6.5993L137.914 6.63367C138.017 6.5993 138.086 6.56493 138.155 6.53056C138.155 6.53056 138.155 6.53056 138.189 6.53056C138.189 6.53056 138.189 6.53056 138.224 6.53056C138.292 6.49618 138.258 6.49619 138.258 6.49619C138.292 6.49619 138.327 6.46181 138.361 6.46181C138.327 6.49618 138.292 6.49618 138.258 6.53056H138.292C138.327 6.49618 138.396 6.49618 138.464 6.42744C138.499 6.42744 138.396 6.46181 138.327 6.49619H138.396C138.43 6.46181 138.499 6.42744 138.533 6.42744C138.567 6.39307 138.602 6.3587 138.636 6.32433C138.636 6.32433 138.671 6.32433 138.671 6.28995C138.636 6.32433 138.567 6.3587 138.602 6.3587H138.567C138.567 6.3587 138.533 6.3587 138.533 6.39307L138.499 6.42744H138.464C138.43 6.42744 138.396 6.46181 138.361 6.46181L138.396 6.42744C138.361 6.42744 138.327 6.46181 138.292 6.49619C138.258 6.53056 138.224 6.53056 138.224 6.49619C138.155 6.53056 138.121 6.56493 138.052 6.5993C138.017 6.5993 138.052 6.56493 137.949 6.63367C137.846 6.73679 137.708 6.80553 137.571 6.8399L137.502 6.87427C137.502 6.87427 137.639 6.80553 137.605 6.80553L137.536 6.8399C137.502 6.8399 137.536 6.8399 137.571 6.80553C137.605 6.80553 137.571 6.80553 137.639 6.77116C137.639 6.77116 137.639 6.77116 137.674 6.73679H137.708C137.708 6.73679 137.674 6.77116 137.639 6.77116C137.639 6.77116 137.674 6.77116 137.708 6.73679H137.674C137.674 6.73679 137.708 6.70242 137.743 6.66804C137.914 6.63367 137.949 6.5993 137.949 6.5993ZM138.189 6.5993C138.189 6.5993 138.189 6.56493 138.258 6.56493H138.292C138.258 6.56493 138.224 6.56493 138.189 6.5993ZM138.567 6.42744C138.533 6.46181 138.499 6.46181 138.464 6.49619C138.499 6.46181 138.533 6.42744 138.567 6.42744C138.567 6.42744 138.567 6.42744 138.533 6.42744H138.567ZM138.327 6.49619L138.361 6.46181C138.361 6.46181 138.361 6.49619 138.327 6.49619ZM142.52 4.50263C142.555 4.50263 142.555 4.50263 142.555 4.50263C142.555 4.537 142.555 4.50263 142.52 4.50263ZM142.314 3.12776C142.348 3.12776 142.383 3.12776 142.417 3.12776H142.451C142.451 3.12776 142.486 3.12776 142.52 3.12776H142.555L142.417 3.19651C142.383 3.19651 142.417 3.19651 142.348 3.19651C142.314 3.12776 142.314 3.12776 142.314 3.12776ZM145.064 2.7153C145.029 2.7153 145.029 2.7153 145.029 2.7153C144.995 2.68093 145.029 2.7153 145.064 2.7153ZM145.064 2.7153L145.132 2.68093C145.167 2.68093 145.167 2.68093 145.236 2.64656L145.167 2.68093C145.167 2.68093 145.201 2.68093 145.167 2.64656C145.132 2.68093 145.132 2.68093 145.064 2.7153ZM141.145 4.36514C141.145 4.36514 141.111 4.36514 141.077 4.36514H141.145ZM141.042 4.39951L140.973 4.43389C141.008 4.43389 141.042 4.39951 141.042 4.39951ZM140.664 4.64012C140.664 4.60574 140.698 4.60574 140.664 4.64012C140.698 4.64012 140.698 4.64012 140.733 4.64012C140.733 4.60574 140.733 4.64012 140.664 4.64012C140.664 4.67449 140.63 4.70886 140.595 4.70886L140.664 4.64012ZM140.905 4.537C140.87 4.537 140.87 4.57137 140.905 4.537V4.537ZM140.939 4.50263L140.87 4.537C140.905 4.537 140.939 4.50263 140.973 4.50263C140.939 4.50263 140.905 4.50263 140.87 4.537C140.905 4.50263 140.939 4.46826 140.939 4.50263ZM140.836 4.537C140.836 4.537 140.802 4.537 140.802 4.57137L140.836 4.537ZM141.077 4.46826C141.042 4.46826 141.008 4.50263 140.973 4.50263L141.042 4.46826H141.008C141.042 4.46826 141.042 4.43389 141.042 4.43389C141.077 4.43389 141.077 4.43389 141.111 4.39951C141.077 4.43389 141.042 4.46826 141.077 4.46826ZM141.111 4.39951C141.111 4.43389 141.18 4.39951 141.111 4.39951L141.042 4.43389C141.077 4.43389 141.111 4.43389 141.111 4.39951ZM141.145 4.50263L141.111 4.537C141.111 4.537 141.111 4.537 141.145 4.50263ZM141.317 4.46826C141.283 4.46826 141.283 4.50263 141.248 4.50263C141.248 4.50263 141.283 4.46826 141.317 4.46826ZM140.045 5.05258C140.011 5.0182 140.011 5.05258 140.045 5.05258V5.05258ZM139.495 5.49941C139.53 5.46503 139.599 5.43066 139.633 5.43066C139.564 5.46503 139.633 5.43066 139.564 5.46504C139.53 5.49941 139.495 5.53378 139.495 5.49941ZM138.155 6.49619C138.155 6.49619 138.189 6.46181 138.224 6.46181C138.224 6.46181 138.189 6.46181 138.155 6.49619ZM142.83 4.46826C142.83 4.43389 142.83 4.43389 142.83 4.46826V4.46826ZM142.623 3.02465C142.623 3.05902 142.589 3.05902 142.555 3.05902L142.623 3.02465ZM142.073 3.33399C142.039 3.36837 142.005 3.36836 141.97 3.36836L142.073 3.33399ZM144.514 2.78405C144.514 2.81842 144.548 2.78405 144.582 2.78405H144.548C144.582 2.78405 144.582 2.78405 144.582 2.78405H144.548C144.582 2.81842 144.548 2.81842 144.514 2.78405ZM145.27 2.64656H145.236C145.236 2.64656 145.27 2.64656 145.304 2.61219L145.27 2.64656C145.236 2.64656 145.236 2.64656 145.236 2.64656C145.236 2.61219 145.27 2.64656 145.27 2.64656ZM146.267 2.19973C146.267 2.2341 146.267 2.2341 146.267 2.19973C146.232 2.19973 146.232 2.19973 146.232 2.19973H146.267ZM145.511 2.33722C145.476 2.33722 145.511 2.37159 145.511 2.33722V2.33722ZM145.476 2.33722C145.476 2.37159 145.476 2.37159 145.476 2.33722C145.476 2.37159 145.476 2.40596 145.476 2.40596V2.44033H145.407C145.407 2.44033 145.407 2.44033 145.373 2.44033H145.339C145.339 2.44033 145.339 2.44033 145.373 2.44033C145.407 2.44033 145.304 2.44033 145.304 2.44033C145.339 2.44033 145.373 2.44033 145.373 2.44033C145.373 2.44033 145.407 2.44033 145.442 2.44033H145.407C145.407 2.44033 145.442 2.44033 145.442 2.40596C145.442 2.40596 145.407 2.40596 145.373 2.40596C145.407 2.37159 145.407 2.37159 145.476 2.33722ZM142.692 2.99028L142.658 3.02465C142.692 2.99028 142.692 2.95591 142.692 2.99028ZM142.795 2.99028C142.795 2.99028 142.761 2.99028 142.726 2.99028H142.795ZM142.211 3.26525C142.245 3.26525 142.245 3.26525 142.28 3.26525H142.245H142.211C142.245 3.26525 142.245 3.26525 142.211 3.26525ZM139.977 5.2588C139.977 5.2588 139.942 5.29318 139.908 5.29318L139.977 5.2588ZM139.77 5.36192C139.736 5.39629 139.736 5.43066 139.77 5.36192V5.36192ZM139.839 5.32755C139.874 5.32755 139.874 5.32755 139.874 5.32755H139.839C139.805 5.36192 139.805 5.36192 139.839 5.32755C139.874 5.32755 139.805 5.36192 139.839 5.32755ZM139.564 5.74001L139.667 5.67127H139.702C139.702 5.67127 139.702 5.67127 139.736 5.67127C139.736 5.67127 139.736 5.67127 139.702 5.70564C139.667 5.70564 139.667 5.70564 139.633 5.74001H139.564C139.599 5.74001 139.599 5.74001 139.564 5.74001ZM146.129 2.16536C146.129 2.19973 146.129 2.19973 146.129 2.16536V2.16536ZM145.236 2.40596H145.339C145.304 2.40596 145.304 2.40596 145.236 2.40596C145.304 2.40596 145.27 2.44033 145.236 2.4747H145.27C145.236 2.4747 145.167 2.50907 145.167 2.4747H145.132C145.167 2.44033 145.236 2.44033 145.27 2.44033L145.236 2.40596ZM144.342 2.61219C144.376 2.61219 144.376 2.61219 144.342 2.61219V2.61219ZM146.335 2.19973C146.37 2.19973 146.37 2.19973 146.37 2.19973C146.37 2.19973 146.335 2.2341 146.335 2.19973C146.37 2.19973 146.37 2.19973 146.335 2.19973ZM146.026 2.30284H145.957C145.957 2.30284 145.992 2.30284 146.026 2.30284ZM145.889 2.33722C145.889 2.33722 145.854 2.33722 145.82 2.33722H145.785C145.785 2.33722 145.785 2.33722 145.82 2.33722C145.785 2.37159 145.889 2.30284 145.889 2.33722ZM144.548 2.61219C144.582 2.61219 144.651 2.57782 144.686 2.57782C144.72 2.57782 144.789 2.57782 144.823 2.57782H144.789H144.754H144.72H144.686H144.651L144.548 2.61219H144.514L144.582 2.57782C144.617 2.57782 144.582 2.54345 144.617 2.54345C144.72 2.57782 144.72 2.54345 144.548 2.61219ZM144.892 2.50907H144.857C144.892 2.50907 144.892 2.50907 144.892 2.50907ZM145.236 2.44033H145.201C145.167 2.44033 145.201 2.44033 145.236 2.44033ZM140.698 4.94946C140.698 4.91509 140.733 4.91509 140.698 4.94946V4.94946ZM142.417 4.12454C142.417 4.12454 142.314 4.15891 142.348 4.12454C142.383 4.15891 142.417 4.12454 142.417 4.12454ZM141.111 4.84635L141.18 4.81197C141.145 4.84635 141.111 4.84635 141.111 4.84635ZM140.527 5.05258L140.492 5.08695C140.492 5.05258 140.492 5.05258 140.527 5.05258ZM140.561 4.98383C140.527 5.0182 140.561 5.0182 140.561 4.98383V4.98383ZM145.957 2.44033C145.957 2.40596 145.992 2.40596 145.957 2.44033V2.44033ZM140.87 5.08695L140.905 5.05258C140.905 5.08695 140.87 5.08695 140.87 5.08695ZM145.476 2.61219C145.511 2.61219 145.511 2.61219 145.476 2.61219V2.61219ZM144.411 2.64656L144.479 2.61219C144.479 2.61219 144.479 2.61219 144.445 2.61219L144.411 2.64656ZM144.995 2.4747C144.995 2.4747 145.029 2.4747 145.064 2.4747H145.098C145.064 2.4747 145.064 2.4747 145.029 2.50907L144.995 2.4747ZM145.132 2.40596C145.167 2.44033 145.167 2.44033 145.132 2.40596C145.098 2.44033 145.132 2.44033 145.132 2.40596ZM145.339 2.40596H145.304C145.339 2.40596 145.339 2.40596 145.339 2.40596ZM145.442 2.40596C145.407 2.40596 145.407 2.40596 145.442 2.40596V2.40596ZM146.06 2.26847C146.06 2.30284 146.095 2.30284 146.06 2.26847C146.026 2.30284 146.06 2.30284 146.06 2.26847ZM146.164 2.2341C146.198 2.2341 146.198 2.2341 146.198 2.2341C146.198 2.26847 146.198 2.26847 146.164 2.2341ZM146.714 2.09661C146.679 2.09661 146.679 2.09661 146.714 2.09661V2.09661ZM141.145 5.0182L141.18 4.98383H141.214L141.145 5.0182ZM139.839 5.39629H139.805C139.805 5.39629 139.805 5.39629 139.839 5.39629ZM145.407 2.57782C145.407 2.54345 145.407 2.54345 145.407 2.57782V2.57782ZM144.445 2.81842H144.411C144.411 2.81842 144.445 2.78405 144.445 2.81842ZM142.348 3.23088C142.348 3.26525 142.348 3.26525 142.348 3.23088V3.23088ZM143.001 3.02465C142.967 3.02465 142.967 3.05902 142.933 3.02465H143.001ZM142.314 3.23088H142.383V3.26525C142.348 3.23088 142.314 3.23088 142.314 3.23088C142.314 3.26525 142.314 3.26525 142.314 3.23088ZM144.926 2.44033C144.926 2.44033 144.961 2.44033 144.995 2.44033C144.995 2.44033 144.961 2.44033 144.926 2.44033ZM138.911 5.94624C138.911 5.91187 138.946 5.8775 138.98 5.8775H139.014C139.014 5.8775 139.014 5.8775 139.049 5.8775L139.152 5.84312C139.117 5.84312 139.049 5.8775 139.049 5.8775C139.014 5.8775 138.98 5.91187 138.98 5.91187H139.014C138.98 5.91187 138.946 5.91187 138.911 5.94624ZM139.633 5.43066C139.667 5.43066 139.667 5.43066 139.633 5.43066V5.43066ZM141.317 4.43389C141.352 4.43389 141.352 4.43389 141.317 4.43389V4.43389ZM141.901 4.0558C141.936 4.0558 142.005 4.02143 142.039 4.02143L141.97 4.0558C141.936 4.02143 141.901 4.0558 141.901 4.0558ZM145.064 2.74968C145.098 2.74968 145.098 2.74968 145.064 2.74968V2.74968ZM145.167 2.7153C145.132 2.7153 145.132 2.74968 145.167 2.7153V2.7153ZM145.304 2.64656C145.304 2.64656 145.339 2.61219 145.339 2.64656H145.304ZM145.236 2.61219C145.201 2.61219 145.201 2.61219 145.167 2.61219C145.236 2.61219 145.27 2.61219 145.339 2.61219C145.339 2.61219 145.304 2.64656 145.27 2.64656H145.339C145.373 2.64656 145.442 2.64656 145.407 2.68093C145.407 2.68093 145.407 2.68093 145.407 2.64656C145.304 2.61219 145.27 2.57782 145.236 2.61219ZM144.754 2.78405C144.72 2.78405 144.72 2.78405 144.686 2.78405C144.686 2.78405 144.72 2.78405 144.754 2.78405ZM144.72 2.74968C144.686 2.78405 144.651 2.74968 144.617 2.78405C144.617 2.74968 144.651 2.7153 144.72 2.74968C144.686 2.7153 144.686 2.7153 144.686 2.7153C144.686 2.7153 144.72 2.7153 144.754 2.74968H144.72ZM142.555 3.09339L142.658 3.05902H142.623C142.623 3.05902 142.623 3.05902 142.589 3.05902C142.589 3.05902 142.555 3.05902 142.555 3.09339ZM142.864 2.95591C142.83 2.95591 142.795 2.99028 142.795 2.99028C142.83 2.99028 142.864 2.99028 142.864 2.95591ZM143.758 2.74968C143.758 2.74968 143.792 2.74968 143.826 2.74968C143.758 2.78405 143.723 2.81842 143.758 2.81842H143.723H143.62H143.654C143.689 2.81842 143.689 2.81842 143.723 2.78405L143.758 2.74968ZM146.267 2.16536C146.301 2.16536 146.301 2.16536 146.335 2.16536C146.301 2.16536 146.267 2.16536 146.267 2.16536C146.267 2.19973 146.232 2.19973 146.267 2.16536ZM146.439 2.09661C146.473 2.09661 146.473 2.09661 146.439 2.09661C146.439 2.13099 146.473 2.09661 146.439 2.09661ZM141.523 4.88072C141.489 4.88072 141.386 4.91509 141.352 4.91509L141.489 4.88072H141.523C141.592 4.84635 141.627 4.84635 141.661 4.81197C141.695 4.84635 141.558 4.88072 141.523 4.88072ZM140.286 5.39629C140.286 5.43066 140.286 5.43066 140.286 5.39629L140.252 5.43066C140.217 5.43066 140.286 5.43066 140.286 5.39629ZM139.599 5.77438C139.564 5.77438 139.564 5.77438 139.53 5.77438H139.599C139.633 5.74001 139.599 5.74001 139.599 5.77438ZM138.808 5.98061L138.842 5.94624L138.877 5.91187H138.911L138.808 5.98061ZM139.599 5.46504C139.564 5.46504 139.564 5.46504 139.564 5.46504H139.599C139.599 5.43066 139.599 5.43066 139.599 5.46504ZM141.18 4.43389C141.214 4.43389 141.248 4.43389 141.283 4.43389C141.214 4.43389 141.18 4.43389 141.18 4.43389ZM141.97 3.98706C142.005 3.98706 142.005 4.02143 141.97 3.98706C142.005 3.98706 142.005 3.98706 142.005 3.98706C141.97 4.02143 141.97 4.02143 141.97 3.98706ZM142.073 3.91831C142.073 3.95268 142.108 3.91831 142.073 3.91831C142.073 3.95268 142.073 3.95268 142.073 3.91831ZM145.132 2.7153C145.167 2.7153 145.201 2.7153 145.236 2.7153C145.167 2.7153 145.167 2.7153 145.132 2.7153ZM144.239 2.92153C144.239 2.88716 144.239 2.88716 144.239 2.92153C144.273 2.88716 144.273 2.88716 144.239 2.92153ZM143.929 2.95591C143.964 2.92153 143.964 2.92153 143.929 2.95591C143.964 2.95591 143.964 2.95591 143.929 2.95591ZM145.545 2.26847H145.511C145.511 2.26847 145.511 2.26847 145.545 2.26847ZM146.301 2.09661C146.335 2.09661 146.335 2.09661 146.301 2.09661C146.37 2.09661 146.404 2.09661 146.404 2.09661C146.404 2.09661 146.335 2.13099 146.37 2.09661C146.404 2.13099 146.335 2.13099 146.301 2.09661ZM144.857 4.02143C144.823 4.02143 144.789 4.0558 144.754 4.02143C144.823 4.02143 144.892 3.98705 144.857 4.02143ZM143.758 4.22766C143.723 4.22766 143.792 4.22766 143.758 4.22766V4.22766ZM142.623 4.50263C142.589 4.46826 142.623 4.46826 142.623 4.50263C142.623 4.43389 142.658 4.50263 142.623 4.50263ZM142.417 4.537C142.383 4.537 142.348 4.537 142.348 4.537C142.383 4.537 142.383 4.537 142.417 4.537ZM140.424 5.39629C140.355 5.36192 140.389 5.39629 140.424 5.39629C140.424 5.36192 140.355 5.36192 140.355 5.39629H140.389L140.492 5.36192H140.561L140.492 5.39629C140.492 5.39629 140.527 5.39629 140.527 5.36192H140.561C140.527 5.36192 140.492 5.39629 140.424 5.39629ZM140.32 5.43066C140.355 5.43066 140.389 5.39629 140.424 5.39629L140.32 5.43066ZM140.114 5.53378C140.011 5.56815 139.942 5.60252 139.874 5.63689C139.908 5.60252 140.011 5.56815 140.114 5.53378C140.114 5.53378 140.183 5.49941 140.217 5.46504C140.183 5.53378 140.149 5.53378 140.114 5.53378ZM139.702 5.70564L139.736 5.67127C139.77 5.67127 139.805 5.63689 139.839 5.60252C139.805 5.67126 139.805 5.70564 139.702 5.70564ZM138.602 6.08372C138.602 6.08372 138.636 6.04935 138.671 6.04935L138.602 6.08372ZM139.977 5.05258C140.011 5.05258 140.011 5.05258 139.977 5.05258V5.05258ZM139.908 4.91509C139.874 4.88072 139.908 4.88072 139.908 4.91509V4.91509ZM139.77 4.94946C139.77 4.91509 139.77 4.88072 139.839 4.91509C139.805 4.91509 139.805 4.94946 139.77 4.94946ZM139.839 4.91509C139.839 4.91509 139.839 4.88072 139.874 4.88072C139.908 4.88072 139.874 4.91509 139.839 4.91509ZM139.495 5.0182C139.495 5.05258 139.53 5.05258 139.495 5.0182C139.495 5.05258 139.495 5.05258 139.495 5.0182ZM139.908 4.84635C139.874 4.84635 139.874 4.84635 139.908 4.84635V4.84635ZM140.149 4.81197C140.149 4.84635 140.114 4.84635 140.08 4.88072C140.08 4.84635 140.045 4.88072 140.011 4.88072C140.011 4.88072 140.045 4.88072 140.045 4.84635C140.08 4.81197 140.114 4.84635 140.149 4.81197C140.114 4.81197 140.08 4.81197 140.08 4.81197C140.114 4.7776 140.114 4.81197 140.149 4.81197ZM141.798 3.98706C141.695 4.02143 141.695 4.02143 141.798 3.98706V3.98706ZM141.592 4.0558C141.627 4.0558 141.661 4.0558 141.627 4.0558C141.627 4.0558 141.627 4.09017 141.592 4.0558ZM141.936 3.91831C142.005 3.91831 142.039 3.91831 142.039 3.91831C142.005 3.91831 141.936 3.91831 141.936 3.91831ZM142.211 3.88394C142.211 3.88394 142.245 3.88394 142.28 3.88394C142.245 3.88394 142.245 3.88394 142.211 3.88394ZM144.342 2.99028C144.342 2.99028 144.308 2.99028 144.273 2.99028C144.273 3.02465 144.307 2.99028 144.342 2.99028ZM144.548 2.95591L144.617 2.92153C144.582 2.9559 144.548 2.95591 144.548 2.95591ZM144.651 2.92153C144.686 2.92153 144.686 2.92153 144.651 2.92153V2.92153ZM144.926 2.78405C144.892 2.78405 144.857 2.78405 144.857 2.78405H144.926C144.926 2.74968 144.926 2.74968 144.926 2.74968C144.926 2.74968 144.961 2.74968 144.926 2.78405ZM144.686 2.81842C144.651 2.81842 144.617 2.81842 144.582 2.85279C144.582 2.81842 144.582 2.81842 144.686 2.81842ZM144.411 2.88716C144.445 2.85279 144.445 2.88716 144.479 2.88716C144.479 2.88716 144.479 2.88716 144.514 2.88716C144.445 2.85279 144.445 2.85279 144.411 2.88716ZM140.973 3.91831C140.973 3.91831 140.87 3.91831 140.836 3.91831H140.87H140.905H140.973C140.973 3.88394 140.905 3.91831 140.905 3.91831L140.836 3.95268H140.802C140.836 3.95268 140.905 3.91831 140.939 3.91831C140.973 3.91831 141.042 3.88394 141.077 3.84957L141.042 3.88394C140.939 3.88394 140.939 3.88394 140.973 3.91831C140.973 3.88394 140.973 3.88394 140.973 3.91831L141.077 3.88394C141.042 3.88394 141.008 3.88394 140.973 3.91831ZM143.07 2.81842C143.036 2.81842 143.036 2.81842 143.07 2.81842V2.81842ZM143.139 2.78405C143.139 2.78405 143.173 2.78405 143.242 2.78405L143.208 2.81842H143.242V2.85279H143.208C143.208 2.85279 143.173 2.85279 143.208 2.81842H143.173C143.139 2.81842 143.139 2.81842 143.139 2.78405ZM148.054 3.5746C148.02 3.5746 148.02 3.60897 148.054 3.5746V3.5746ZM148.776 3.23088C148.81 3.23088 148.81 3.26525 148.776 3.23088V3.23088ZM149.051 3.09339H149.12C149.085 3.09339 149.051 3.09339 149.051 3.09339ZM147.917 3.5746H147.951C147.882 3.5746 147.917 3.60897 147.882 3.60897C147.882 3.60897 147.917 3.60897 147.917 3.5746ZM149.016 3.05902C149.051 3.05902 149.051 3.05902 149.051 3.05902H149.085C149.051 3.05902 149.016 3.09339 149.016 3.05902C149.085 3.05902 148.982 3.09339 149.016 3.05902ZM147.538 3.67771C147.573 3.67771 147.607 3.67771 147.607 3.67771C147.573 3.67771 147.573 3.71208 147.538 3.67771ZM147.47 3.67771C147.538 3.67771 147.538 3.71208 147.47 3.67771C147.47 3.71208 147.47 3.71208 147.47 3.67771ZM147.504 3.60897C147.538 3.60897 147.573 3.57459 147.573 3.60897C147.538 3.60897 147.504 3.60897 147.504 3.60897C147.538 3.60897 147.573 3.60897 147.573 3.64334C147.538 3.64334 147.538 3.64334 147.504 3.60897C147.504 3.64334 147.504 3.64334 147.504 3.64334C147.47 3.67771 147.47 3.64334 147.504 3.60897ZM147.642 3.54022C147.642 3.54022 147.642 3.54022 147.676 3.54022C147.676 3.54022 147.642 3.57459 147.642 3.54022ZM147.573 3.5746C147.573 3.60897 147.573 3.60897 147.573 3.5746L147.504 3.60897C147.504 3.60897 147.538 3.60897 147.573 3.5746ZM147.057 3.74645C147.092 3.74645 147.16 3.71208 147.16 3.71208C147.126 3.71208 147.092 3.71208 147.092 3.74645C147.092 3.74645 147.057 3.78082 147.057 3.74645ZM147.47 3.5746C147.401 3.60897 147.435 3.5746 147.47 3.5746V3.5746ZM147.813 3.33399C147.813 3.33399 147.779 3.36836 147.745 3.36836C147.745 3.36836 147.779 3.36837 147.813 3.33399ZM147.676 3.36836C147.676 3.40274 147.745 3.36836 147.676 3.36836C147.676 3.40274 147.676 3.40274 147.676 3.36836C147.676 3.40274 147.642 3.40274 147.676 3.36836ZM147.642 3.23088C147.642 3.23088 147.676 3.23088 147.71 3.23088C147.71 3.23088 147.71 3.23088 147.642 3.23088C147.71 3.23088 147.676 3.23088 147.642 3.23088ZM145.82 3.95268H145.854C145.82 3.98705 145.854 3.95268 145.82 3.95268ZM145.373 4.02143H145.442C145.476 4.02143 145.304 4.0558 145.373 4.02143ZM145.442 3.98706H145.476C145.511 3.98706 145.442 4.02143 145.442 3.98706C145.476 3.98706 145.407 3.98706 145.442 3.98706ZM144.857 4.09017C144.892 4.09017 144.857 4.09017 144.926 4.09017C144.892 4.12454 144.926 4.12454 144.961 4.12454C144.995 4.12454 144.995 4.09017 145.064 4.09017C145.064 4.09017 145.064 4.12454 145.029 4.12454C145.029 4.09017 144.961 4.12454 144.926 4.12454C144.926 4.09017 144.857 4.12454 144.857 4.09017ZM144.651 4.12454C144.651 4.15891 144.686 4.15891 144.651 4.12454C144.651 4.12454 144.617 4.15891 144.617 4.12454C144.651 4.15891 144.651 4.12454 144.651 4.12454ZM144.617 4.12454H144.651C144.651 4.12454 144.617 4.19328 144.617 4.15891C144.651 4.12454 144.617 4.12454 144.617 4.12454ZM144.582 4.12454C144.548 4.12454 144.548 4.15891 144.582 4.12454V4.12454ZM143.964 4.22766H143.998C143.998 4.22766 144.033 4.22766 143.964 4.22766C143.998 4.26203 143.929 4.22766 143.964 4.22766ZM143.861 4.22766C143.895 4.22766 143.895 4.19328 143.895 4.22766C143.861 4.22766 143.861 4.22766 143.861 4.22766ZM143.654 4.33077C143.689 4.33077 143.689 4.2964 143.723 4.2964C143.723 4.2964 143.689 4.33077 143.654 4.33077ZM143.62 4.2964H143.654C143.62 4.33077 143.654 4.33077 143.62 4.2964C143.62 4.33077 143.62 4.33077 143.62 4.2964ZM143.689 4.22766C143.654 4.26203 143.689 4.26203 143.689 4.22766C143.689 4.26203 143.723 4.26203 143.689 4.22766L143.654 4.26203C143.654 4.26203 143.689 4.26203 143.689 4.22766ZM143.586 4.26203C143.62 4.26203 143.62 4.26203 143.654 4.22766C143.654 4.26203 143.551 4.2964 143.62 4.2964H143.586C143.551 4.2964 143.586 4.26203 143.586 4.26203ZM143.448 4.26203C143.414 4.26203 143.414 4.2964 143.379 4.26203C143.414 4.2964 143.448 4.2964 143.448 4.26203ZM142.864 4.46826H142.898C142.898 4.46826 142.898 4.46826 142.864 4.46826ZM142.451 4.64012L142.52 4.60574C142.52 4.60574 142.486 4.64012 142.451 4.64012ZM142.176 4.64012C142.211 4.64012 142.245 4.64012 142.28 4.60574C142.211 4.60574 142.211 4.60574 142.176 4.64012H142.108H142.142C142.142 4.60574 142.142 4.60574 142.176 4.64012C142.176 4.57137 142.28 4.57137 142.348 4.537H142.314C142.348 4.537 142.314 4.537 142.348 4.537H142.383C142.383 4.537 142.348 4.537 142.348 4.57137C142.383 4.57137 142.417 4.57137 142.451 4.57137C142.451 4.57137 142.486 4.57137 142.451 4.537C142.486 4.537 142.486 4.537 142.486 4.537L142.658 4.50263C142.658 4.50263 142.658 4.50263 142.692 4.50263C142.658 4.50263 142.623 4.537 142.589 4.57137C142.623 4.57137 142.658 4.537 142.692 4.537C142.692 4.537 142.692 4.537 142.726 4.537H142.761C142.761 4.537 142.761 4.537 142.795 4.537H142.83H142.864C142.83 4.537 142.761 4.57137 142.726 4.60574H142.692H142.623C142.623 4.60574 142.623 4.60574 142.589 4.60574C142.555 4.60574 142.52 4.64012 142.486 4.64012C142.417 4.64012 142.451 4.67449 142.451 4.67449C142.417 4.67449 142.383 4.67449 142.348 4.70886L142.176 4.64012ZM139.908 5.70564L139.839 5.74001L139.77 5.77438C139.736 5.77438 139.702 5.80875 139.667 5.80875C139.667 5.80875 139.736 5.77438 139.667 5.77438H139.599L139.633 5.74001C139.77 5.74001 139.805 5.74001 139.908 5.70564ZM139.495 5.91187C139.495 5.91187 139.53 5.91187 139.564 5.8775L139.495 5.91187ZM139.22 6.08372C139.22 6.08372 139.186 6.08372 139.152 6.08372C139.255 6.01498 139.255 6.01498 139.22 6.01498C139.255 6.01498 139.255 6.01498 139.289 6.01498C139.324 6.01498 139.324 6.01498 139.358 5.98061L139.324 6.01498L139.22 6.08372ZM135.508 7.97417C135.577 7.93979 135.611 7.90542 135.68 7.87105H135.646L135.886 7.73357C136.093 7.63045 136.299 7.52734 136.505 7.42422C136.436 7.49296 136.402 7.52733 136.333 7.56171H136.402L136.436 7.52733L136.54 7.49296C136.54 7.49296 136.436 7.56171 136.402 7.59608C136.402 7.59608 136.23 7.66482 136.196 7.69919L136.299 7.63045C136.265 7.63045 136.093 7.73356 136.058 7.76794L136.161 7.69919C136.161 7.69919 136.058 7.76793 136.127 7.69919C136.024 7.76793 135.921 7.80231 135.818 7.90542C135.749 7.97417 135.749 7.90542 135.68 7.97417C135.783 7.90542 135.68 8.00854 135.783 7.9398C135.749 7.97417 135.783 7.93979 135.715 8.00854C135.611 8.04291 135.646 8.07728 135.543 8.11165C135.508 8.14602 135.611 8.11165 135.508 8.14602C135.405 8.21477 135.405 8.1804 135.371 8.1804C135.474 8.11165 135.474 8.14603 135.577 8.07728L135.405 8.14602C135.405 8.14602 135.44 8.11165 135.474 8.11165C135.44 8.11165 135.405 8.14602 135.371 8.14602H135.337C135.405 8.11165 135.44 8.07728 135.508 8.04291C135.44 8.00854 135.474 7.97417 135.508 7.97417ZM137.227 6.94302L137.33 6.90865H137.296L137.468 6.80553L137.639 6.73679L137.605 6.77116C137.605 6.77116 137.605 6.77116 137.639 6.77116C137.605 6.77116 137.571 6.80553 137.536 6.8399L137.433 6.90865C137.433 6.90865 137.399 6.90864 137.399 6.94302H137.433C137.468 6.94302 137.536 6.87427 137.536 6.87427L137.468 6.90865H137.502C137.468 6.90865 137.433 6.94302 137.399 6.97739C137.433 6.97739 137.502 6.90864 137.502 6.94302C137.468 6.97739 137.433 6.97739 137.399 7.01176H137.433C137.399 7.04613 137.33 7.04613 137.296 7.0805C137.193 7.11488 137.399 7.01176 137.364 6.97739L137.021 7.14925C137.055 7.14925 137.089 7.14925 137.089 7.14925C137.021 7.18362 137.089 7.14925 136.986 7.21799C136.986 7.18362 136.849 7.28673 136.78 7.3211C136.746 7.35548 136.746 7.35548 136.814 7.3211C136.814 7.3211 136.711 7.38985 136.677 7.42422L136.574 7.45859C136.608 7.42422 136.574 7.42422 136.505 7.45859C136.608 7.38985 136.711 7.32111 136.849 7.25236H136.814C136.918 7.14925 137.124 7.11487 137.158 7.04613C137.193 6.94302 137.227 6.94302 137.227 6.94302ZM137.708 6.66804L137.811 6.63367C137.811 6.63367 137.777 6.66804 137.743 6.66804H137.708C137.708 6.70242 137.708 6.70242 137.708 6.66804ZM137.364 6.66804L137.433 6.63367C137.399 6.66804 137.399 6.66804 137.364 6.66804ZM137.88 6.42744L138.017 6.3587C138.052 6.3587 138.086 6.32433 138.121 6.32433C138.258 6.28996 138.258 6.32433 138.189 6.32433C138.189 6.32433 137.983 6.42744 138.121 6.32433H138.086C138.052 6.32433 137.983 6.3587 137.983 6.39307C137.949 6.42744 137.88 6.46181 137.88 6.42744L137.743 6.53056H137.811L137.639 6.5993C137.743 6.56493 137.605 6.63367 137.536 6.66804C137.502 6.66804 137.433 6.70242 137.502 6.66804L137.571 6.63367H137.605L137.88 6.42744ZM137.88 6.39307L137.811 6.42744C137.846 6.42744 137.88 6.42744 137.88 6.39307ZM138.361 6.18684L138.464 6.1181H138.499L138.567 6.08372C138.602 6.08372 138.602 6.08373 138.636 6.04935C138.602 6.08373 138.602 6.08372 138.533 6.1181L138.396 6.18684H138.361ZM138.43 6.1181L138.396 6.15247C138.396 6.15247 138.396 6.15247 138.361 6.15247C138.396 6.1181 138.396 6.1181 138.43 6.1181ZM138.567 6.04935C138.567 6.04935 138.602 6.04935 138.602 6.01498C138.602 6.01498 138.602 6.04935 138.567 6.04935ZM138.567 6.01498C138.533 6.04935 138.533 6.04935 138.499 6.04935C138.499 6.04935 138.533 6.04935 138.567 6.01498ZM139.324 5.56815H139.358C139.392 5.56815 139.427 5.56815 139.427 5.53378L139.324 5.56815C139.324 5.60252 139.324 5.60252 139.324 5.56815ZM139.599 5.2588C139.564 5.29318 139.564 5.29318 139.599 5.2588V5.2588ZM139.599 5.22443C139.633 5.22443 139.633 5.22443 139.667 5.22443H139.633H139.599ZM139.908 5.05258C139.874 5.05258 139.839 5.08695 139.805 5.05258C139.839 5.08695 139.908 5.08695 139.908 5.05258ZM139.874 5.05258C139.908 5.05258 139.908 5.05258 139.908 5.05258H139.874ZM139.908 5.0182C139.942 5.0182 140.011 4.98383 140.045 4.94946C140.011 4.94946 139.942 4.98383 139.942 5.0182C139.942 5.0182 139.908 5.05258 139.908 5.0182ZM139.152 5.22443C139.186 5.22443 139.255 5.15569 139.255 5.19006C139.289 5.15569 139.255 5.19006 139.289 5.15569H139.324C139.255 5.19006 139.186 5.22443 139.117 5.2588C139.117 5.2588 139.152 5.25881 139.152 5.22443ZM138.464 5.53378L138.396 5.56815C138.43 5.53378 138.464 5.49941 138.464 5.53378ZM139.22 5.08695C139.22 5.05258 139.358 5.0182 139.392 4.98383C139.427 4.94946 139.461 4.94946 139.495 4.91509C139.495 4.91509 139.495 4.91509 139.461 4.91509H139.495C139.495 4.91509 139.495 4.94946 139.461 4.94946H139.427L139.392 4.98383H139.427C139.427 4.98383 139.392 4.98383 139.392 5.0182C139.392 5.0182 139.392 5.0182 139.427 5.0182C139.427 5.0182 139.392 5.0182 139.358 5.0182C139.324 5.0182 139.324 5.0182 139.324 5.05258H139.289C139.324 5.05258 139.324 5.05258 139.289 5.05258C139.255 5.05258 139.255 5.05258 139.255 5.05258H139.22C139.22 5.05258 139.22 5.05258 139.255 5.05258C139.255 5.05258 139.255 5.08695 139.22 5.08695C139.22 5.08695 139.22 5.08695 139.22 5.05258C139.22 5.05258 139.22 5.05258 139.186 5.08695C139.186 5.05258 139.255 5.0182 139.289 5.0182C139.255 5.0182 139.22 5.0182 139.186 5.0182C139.152 5.0182 139.117 5.05258 139.117 5.05258C139.083 5.05258 139.049 5.05258 139.014 5.08695C139.083 5.05258 139.152 5.05258 139.186 4.98383C139.186 5.12132 139.22 5.08695 139.22 5.08695ZM139.736 4.81197C139.736 4.84635 139.736 4.84635 139.736 4.81197V4.81197ZM139.599 4.84635C139.599 4.84635 139.633 4.84635 139.667 4.84635H139.599ZM139.874 4.74323C139.839 4.7776 139.805 4.81197 139.77 4.81197C139.77 4.81197 139.77 4.81197 139.805 4.81197C139.805 4.81197 139.805 4.81197 139.805 4.7776C139.77 4.7776 139.702 4.81197 139.702 4.81197C139.702 4.81197 139.702 4.81197 139.702 4.84635C139.702 4.84635 139.667 4.84635 139.702 4.81197C139.702 4.81197 139.702 4.81197 139.736 4.81197C139.736 4.81197 139.736 4.81197 139.77 4.81197C139.805 4.7776 139.805 4.74323 139.874 4.74323ZM140.183 4.67449C140.149 4.67449 140.149 4.67449 140.114 4.67449C140.114 4.67449 140.114 4.67449 140.114 4.64012C140.114 4.64012 140.183 4.64012 140.183 4.67449ZM140.217 4.67449C140.183 4.67449 140.149 4.67449 140.114 4.70886C140.114 4.70886 140.149 4.70886 140.217 4.67449ZM140.252 4.74323H140.217C140.183 4.74323 140.32 4.70886 140.217 4.74323C140.286 4.70886 140.183 4.74323 140.183 4.70886H140.217C140.217 4.74323 140.217 4.70886 140.252 4.70886C140.252 4.70886 140.217 4.70886 140.217 4.74323C140.252 4.70886 140.217 4.74323 140.252 4.74323ZM141.145 4.33077H141.077C141.111 4.33077 141.111 4.33077 141.145 4.33077ZM141.42 4.19328C141.352 4.22766 141.386 4.19328 141.42 4.19328V4.19328ZM141.214 4.22766C141.214 4.22766 141.248 4.22766 141.283 4.26203C141.214 4.2964 141.214 4.26203 141.214 4.22766ZM141.214 4.22766C141.214 4.22766 141.145 4.26203 141.145 4.22766C141.18 4.22766 141.214 4.22766 141.214 4.22766ZM141.523 4.0558C141.523 4.09017 141.489 4.09017 141.455 4.12454C141.489 4.09017 141.523 4.0558 141.523 4.0558ZM141.627 3.98706C141.661 3.98706 141.661 4.02143 141.627 3.98706C141.627 3.98706 141.627 4.0558 141.592 4.02143C141.627 4.02143 141.592 4.02143 141.558 4.02143C141.558 4.02143 141.558 4.02143 141.558 3.98706C141.592 3.98706 141.627 3.98706 141.627 3.98706ZM141.317 4.09017C141.352 4.0558 141.248 4.09017 141.283 4.0558C141.317 4.0558 141.386 4.02143 141.455 4.02143C141.42 4.02143 141.386 4.0558 141.352 4.0558C141.352 4.02143 141.352 4.0558 141.317 4.09017C141.386 4.0558 141.317 4.0558 141.317 4.09017ZM141.901 3.8152L141.97 3.78082C141.97 3.8152 141.936 3.8152 141.901 3.8152ZM142.176 3.74645C142.142 3.74645 142.142 3.74645 142.142 3.74645C142.176 3.74645 142.176 3.71208 142.176 3.74645C142.176 3.71208 142.176 3.71208 142.176 3.74645ZM142.039 3.84957C142.039 3.84957 142.108 3.84957 142.073 3.84957C142.039 3.88394 142.039 3.88394 142.039 3.84957C142.039 3.88394 142.039 3.88394 142.039 3.84957C142.005 3.8152 142.005 3.8152 142.039 3.84957ZM142.28 3.71208C142.245 3.74645 142.245 3.74645 142.245 3.74645L142.28 3.71208ZM142.451 3.67771C142.417 3.67771 142.383 3.71208 142.348 3.71208C142.383 3.71208 142.417 3.71208 142.348 3.71208C142.383 3.67771 142.417 3.67771 142.451 3.67771C142.486 3.67771 142.486 3.67771 142.451 3.67771ZM142.864 3.50585C142.864 3.50585 142.83 3.50585 142.795 3.54022C142.795 3.50585 142.898 3.50585 142.864 3.50585ZM143.104 3.40274C143.104 3.40274 143.139 3.36836 143.173 3.36836C143.139 3.36836 143.139 3.40274 143.104 3.40274ZM142.348 3.78082H142.314C142.28 3.78082 142.348 3.74645 142.348 3.78082ZM142.211 3.8152H142.245C142.211 3.84957 142.176 3.84957 142.211 3.8152ZM142.108 3.91831H142.176C142.142 3.91831 142.073 3.91831 142.108 3.91831ZM142.52 3.71208C142.52 3.71208 142.486 3.71208 142.451 3.74645C142.417 3.74645 142.486 3.71208 142.52 3.71208ZM144.101 3.05902C144.136 3.05902 144.136 3.05902 144.17 3.02465C144.17 3.02465 144.17 3.02465 144.17 3.05902C144.136 3.05902 144.17 3.02465 144.101 3.05902C144.136 3.05902 144.136 3.05902 144.136 3.05902H144.101C144.136 3.05902 144.101 3.09339 144.101 3.05902ZM144.308 2.92153C144.342 2.9559 144.342 2.92153 144.376 2.92153C144.411 2.9559 144.445 2.88716 144.479 2.92153C144.548 2.88716 144.582 2.92153 144.582 2.88716C144.617 2.88716 144.686 2.88716 144.72 2.85279L144.754 2.81842H144.789C144.789 2.81842 144.789 2.81842 144.823 2.81842C144.823 2.81842 144.823 2.81842 144.823 2.85279C144.823 2.85279 144.857 2.85279 144.892 2.85279H144.926C144.823 2.88716 144.651 2.95591 144.514 2.99028C144.479 2.99028 144.445 2.99028 144.411 2.99028C144.411 2.99028 144.411 2.99028 144.411 3.02465C144.376 3.02465 144.411 2.99028 144.376 3.02465C144.376 3.05902 144.308 3.02465 144.308 3.05902C144.273 3.05902 144.273 3.05902 144.239 3.05902C144.273 3.02465 144.273 3.05902 144.308 3.05902V3.02465V2.92153ZM143.654 3.12776C143.654 3.09339 143.654 3.09339 143.654 3.12776C143.654 3.09339 143.654 3.09339 143.689 3.09339C143.689 3.09339 143.792 3.05902 143.792 3.09339C143.826 3.09339 143.792 3.09339 143.826 3.05902C143.758 3.09339 143.689 3.09339 143.654 3.12776ZM143.448 3.12776H143.551C143.551 3.12776 143.586 3.12776 143.62 3.12776H143.586L143.483 3.16214C143.517 3.16214 143.551 3.12776 143.517 3.12776C143.483 3.12776 143.483 3.12776 143.448 3.12776ZM143.139 3.16214C143.242 3.16214 143.311 3.12776 143.414 3.09339C143.379 3.09339 143.311 3.12776 143.276 3.16214C143.276 3.12776 143.173 3.19651 143.173 3.16214H143.208H143.139ZM142.658 3.29962C142.692 3.29962 142.692 3.29962 142.692 3.26525C142.726 3.26525 142.726 3.29962 142.658 3.29962C142.692 3.29962 142.726 3.29962 142.726 3.29962H142.658C142.692 3.29962 142.692 3.29962 142.658 3.29962ZM142.314 3.43711C142.28 3.43711 142.211 3.47148 142.211 3.47148C142.142 3.50585 142.176 3.47148 142.108 3.47148C142.108 3.47148 142.108 3.47148 142.142 3.47148C142.176 3.47148 142.176 3.47148 142.211 3.47148H142.176C142.176 3.43711 142.28 3.43711 142.245 3.43711H142.28C142.28 3.43711 142.28 3.43711 142.314 3.43711L142.245 3.47148C142.245 3.43711 142.348 3.40274 142.314 3.43711ZM142.039 3.54022L142.142 3.50585C142.073 3.50585 142.108 3.54022 142.039 3.54022ZM141.317 3.8152C141.352 3.8152 141.352 3.8152 141.317 3.8152C141.455 3.74645 141.42 3.78082 141.523 3.74645C141.455 3.8152 141.386 3.8152 141.317 3.8152ZM141.008 3.88394C141.111 3.84957 141.18 3.84957 141.283 3.8152H141.352C141.352 3.8152 141.317 3.8152 141.317 3.84957C141.317 3.84957 141.283 3.84957 141.248 3.84957H141.18C141.145 3.84957 141.111 3.84957 141.077 3.84957C141.077 3.84957 141.042 3.88394 141.077 3.88394C140.939 3.91831 141.042 3.88394 141.008 3.88394ZM140.32 4.12454C140.389 4.09017 140.389 4.12454 140.424 4.09017L140.32 4.12454C140.355 4.09017 140.355 4.09017 140.389 4.09017C140.389 4.09017 140.355 4.09017 140.32 4.12454L140.424 4.0558H140.527C140.527 4.02143 140.423 4.0558 140.389 4.0558L140.458 4.02143C140.492 4.02143 140.492 4.02143 140.527 4.02143C140.527 4.02143 140.527 4.02143 140.561 4.02143H140.63H140.595H140.561C140.561 4.02143 140.527 4.02143 140.492 4.02143C140.561 3.98705 140.492 4.0558 140.527 4.02143C140.527 4.02143 140.527 4.02143 140.492 4.02143C140.492 4.02143 140.492 4.02143 140.527 4.02143H140.492C140.424 4.02143 140.458 4.0558 140.389 4.0558C140.355 4.0558 140.423 4.0558 140.389 4.09017C140.389 4.15891 140.355 4.12454 140.32 4.12454ZM139.564 4.22766H139.495C139.495 4.26203 139.53 4.22766 139.564 4.22766ZM141.248 3.54022C141.214 3.54022 141.214 3.54022 141.248 3.54022C141.248 3.54022 141.283 3.54022 141.317 3.50585C141.352 3.50585 141.386 3.47148 141.42 3.47148C141.455 3.47148 141.455 3.47148 141.489 3.47148H141.455C141.386 3.47148 141.42 3.50585 141.386 3.50585C141.352 3.50585 141.317 3.54022 141.317 3.50585L141.248 3.54022C141.214 3.57459 141.214 3.60897 141.18 3.60897L141.248 3.54022ZM141.042 3.60897C141.111 3.57459 141.145 3.5746 141.18 3.5746H141.145H141.111C141.111 3.60897 141.077 3.57459 141.042 3.60897ZM141.73 3.33399C141.695 3.36837 141.73 3.36837 141.73 3.33399H141.661C141.627 3.33399 141.661 3.33399 141.627 3.33399C141.558 3.33399 141.489 3.36837 141.42 3.40274C141.386 3.40274 141.352 3.40274 141.317 3.40274C141.352 3.36837 141.42 3.36837 141.42 3.33399C141.42 3.33399 141.455 3.33399 141.489 3.29962C141.523 3.29962 141.558 3.29962 141.627 3.26525C141.695 3.36836 141.73 3.33399 141.73 3.33399ZM142.005 3.23088C142.039 3.23088 142.108 3.19651 142.108 3.19651C142.142 3.19651 142.108 3.23088 142.108 3.23088C142.108 3.23088 141.97 3.26525 142.073 3.23088C142.073 3.23088 142.039 3.23088 142.005 3.23088ZM141.936 3.16214C141.97 3.16214 141.97 3.16214 142.005 3.16214H142.039C142.039 3.16214 142.005 3.16214 141.936 3.16214C141.97 3.16214 141.97 3.16214 141.936 3.16214ZM142.451 3.02465H142.417C142.417 3.02465 142.383 3.02465 142.348 3.02465C142.417 3.02465 142.451 3.02465 142.451 3.02465ZM143.139 2.74968H143.173C143.208 2.74968 143.242 2.74968 143.276 2.74968H143.208C143.208 2.74968 143.173 2.78405 143.139 2.74968ZM151.457 1.68415C151.491 1.68415 151.491 1.68415 151.457 1.68415V1.68415ZM151.422 1.85601C151.422 1.85601 151.422 1.85601 151.354 1.85601C151.354 1.82164 151.388 1.82164 151.422 1.85601C151.422 1.82164 151.388 1.85601 151.422 1.85601C151.457 1.82164 151.422 1.82164 151.422 1.85601ZM151.354 1.95913H151.319C151.354 1.92476 151.285 1.92476 151.319 1.85601C151.319 1.89038 151.319 1.92476 151.354 1.95913ZM150.323 2.44033C150.288 2.44033 150.357 2.40596 150.323 2.44033C150.288 2.44033 150.323 2.40596 150.323 2.44033ZM150.288 2.61219C150.288 2.57782 150.288 2.57782 150.288 2.61219C150.288 2.57782 150.357 2.57782 150.288 2.61219ZM150.391 2.57782C150.391 2.57782 150.357 2.61219 150.323 2.61219C150.357 2.57782 150.391 2.57782 150.391 2.57782ZM151.526 2.09661C151.56 2.06224 151.594 2.06224 151.526 2.09661C151.56 2.06224 151.56 2.09661 151.526 2.09661ZM149.704 2.92153C149.704 2.92153 149.669 2.9559 149.669 2.92153C149.704 2.9559 149.704 2.92153 149.704 2.92153ZM150.082 2.78405C150.116 2.78405 150.116 2.78405 150.082 2.78405V2.78405ZM149.807 2.92153H149.773C149.807 2.92153 149.841 2.88716 149.876 2.88716C149.841 2.92153 149.807 2.92153 149.807 2.92153ZM150.082 2.88716C150.116 2.85279 150.116 2.92153 150.082 2.88716V2.88716ZM150.151 2.81842C150.185 2.78405 150.185 2.81842 150.151 2.81842V2.81842ZM150.219 2.78405C150.219 2.78405 150.219 2.78405 150.254 2.78405C150.288 2.78405 150.254 2.78405 150.219 2.78405ZM150.151 2.88716C150.151 2.85279 150.116 2.88716 150.116 2.88716C150.116 2.88716 150.116 2.88716 150.116 2.85279C150.116 2.85279 150.151 2.81842 150.151 2.85279H150.116C150.151 2.85279 150.151 2.85279 150.151 2.88716ZM150.151 2.88716C150.185 2.88716 150.219 2.88716 150.219 2.88716C150.185 2.88716 150.151 2.88716 150.151 2.88716ZM151.251 2.61219C151.285 2.61219 151.319 2.61219 151.354 2.61219H151.319C151.354 2.61219 151.354 2.61219 151.388 2.61219C151.354 2.61219 151.285 2.57782 151.251 2.61219ZM151.079 2.74968C151.044 2.74968 151.044 2.74968 151.079 2.74968V2.74968ZM151.147 2.61219C151.182 2.61219 151.147 2.61219 151.216 2.61219H151.251C151.251 2.61219 151.251 2.61219 151.251 2.64656C151.251 2.64656 151.251 2.64656 151.216 2.64656C151.182 2.64656 151.182 2.61219 151.147 2.61219C151.182 2.61219 151.216 2.64656 151.216 2.64656C151.216 2.64656 151.182 2.64656 151.147 2.61219C151.182 2.64656 151.182 2.64656 151.216 2.68093C151.182 2.68093 151.182 2.68093 151.182 2.7153C151.147 2.7153 151.147 2.74968 151.113 2.7153C151.079 2.68093 151.113 2.7153 151.113 2.68093C151.113 2.64656 151.147 2.68093 151.147 2.68093C151.147 2.68093 151.147 2.68093 151.182 2.64656C151.147 2.64656 151.147 2.64656 151.147 2.64656C151.147 2.64656 151.147 2.64656 151.147 2.61219ZM151.182 2.61219C151.216 2.61219 151.251 2.57782 151.251 2.61219C151.216 2.57782 151.182 2.61219 151.182 2.61219ZM150.46 2.81842C150.426 2.81842 150.494 2.81842 150.46 2.81842V2.85279C150.46 2.85279 150.426 2.81842 150.46 2.81842ZM151.422 2.33722C151.388 2.37159 151.422 2.37159 151.422 2.33722L151.388 2.37159C151.354 2.37159 151.457 2.37159 151.388 2.37159C151.422 2.37159 151.388 2.33722 151.422 2.33722ZM151.491 2.30284C151.491 2.30284 151.526 2.30284 151.56 2.30284C151.526 2.33722 151.491 2.33722 151.491 2.30284ZM151.457 2.40596C151.422 2.40596 151.388 2.40596 151.388 2.44033C151.388 2.44033 151.388 2.44033 151.388 2.40596C151.388 2.40596 151.457 2.37159 151.457 2.40596ZM151.147 2.54345C151.182 2.50907 151.182 2.54345 151.147 2.54345V2.54345ZM150.563 2.85279H150.529C150.494 2.81842 150.494 2.81842 150.563 2.85279ZM151.147 2.57782C151.147 2.57782 151.113 2.61219 151.079 2.61219C151.113 2.61219 151.113 2.57782 151.147 2.57782Z",
    fill: "url(#paint386_linear_7270_1548)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M151.319 2.74941H151.25C151.284 2.71504 151.319 2.71504 151.319 2.74941C151.319 2.71504 151.319 2.71504 151.319 2.74941Z",
    fill: "url(#paint387_linear_7270_1548)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M142.657 2.85254C142.657 2.85254 142.691 2.85254 142.725 2.85254C142.725 2.88691 142.622 2.88691 142.588 2.88691C142.622 2.85254 142.657 2.88691 142.657 2.85254Z",
    fill: "url(#paint388_linear_7270_1548)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M142.658 2.92146C142.623 2.92146 142.623 2.92146 142.589 2.95584C142.589 2.92146 142.52 2.99021 142.555 2.95584C142.589 2.92146 142.623 2.88709 142.658 2.92146Z",
    fill: "url(#paint389_linear_7270_1548)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M142.519 2.9209C142.553 2.9209 142.519 2.9209 142.553 2.9209C142.587 2.9209 142.553 2.9209 142.587 2.9209C142.587 2.9209 142.622 2.9209 142.656 2.9209C142.622 2.9209 142.553 2.9209 142.519 2.9209V2.95527C142.484 2.98964 142.519 2.95527 142.519 2.9209C142.484 2.9209 142.484 2.95527 142.484 2.9209H142.519Z",
    fill: "url(#paint390_linear_7270_1548)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M142.142 3.02441C142.142 3.05879 142.176 3.02441 142.211 3.02441C142.176 3.02441 142.107 3.05879 142.107 3.02441C142.142 3.05879 142.142 3.05879 142.142 3.02441Z",
    fill: "url(#paint391_linear_7270_1548)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M141.832 3.16227C141.832 3.16227 141.832 3.16227 141.797 3.16227C141.797 3.16227 141.797 3.16227 141.797 3.19664H141.763C141.728 3.16227 141.625 3.19664 141.557 3.23101C141.557 3.23101 141.591 3.23101 141.557 3.19664C141.591 3.19664 141.625 3.19664 141.66 3.16227C141.66 3.16227 141.66 3.16227 141.694 3.16227C141.728 3.19664 141.832 3.12789 141.832 3.16227Z",
    fill: "url(#paint392_linear_7270_1548)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M141.42 3.26484C141.454 3.26484 141.523 3.23047 141.557 3.23047C141.489 3.26484 141.454 3.29921 141.42 3.26484Z",
    fill: "url(#paint393_linear_7270_1548)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M140.939 3.43691C140.939 3.47128 140.973 3.43691 140.939 3.43691C140.905 3.47128 140.939 3.47128 140.939 3.43691C140.905 3.43691 140.905 3.43691 140.87 3.43691H140.905C140.905 3.43691 140.87 3.43691 140.836 3.43691C140.87 3.40254 141.008 3.36816 141.008 3.36816C141.008 3.40254 140.973 3.43691 140.939 3.43691Z",
    fill: "url(#paint394_linear_7270_1548)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M140.87 3.6084L140.835 3.64277C140.835 3.64277 140.835 3.64277 140.801 3.64277C140.835 3.64277 140.87 3.6084 140.87 3.6084Z",
    fill: "url(#paint395_linear_7270_1548)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M140.527 3.74569C140.595 3.74569 140.698 3.67695 140.767 3.64258C140.767 3.64258 140.767 3.64258 140.802 3.64258C140.733 3.71132 140.664 3.71132 140.527 3.74569C140.561 3.78006 140.492 3.74569 140.492 3.78006C140.527 3.74569 140.527 3.74569 140.527 3.74569Z",
    fill: "url(#paint396_linear_7270_1548)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M140.732 3.50527C140.766 3.50527 140.732 3.53964 140.732 3.53964C140.732 3.53964 140.663 3.53964 140.629 3.53964C140.663 3.53964 140.698 3.53964 140.732 3.50527C140.732 3.53964 140.663 3.53964 140.663 3.53964C140.732 3.53964 140.732 3.50527 140.732 3.50527C140.732 3.50527 140.801 3.4709 140.835 3.50527C140.801 3.4709 140.766 3.4709 140.732 3.50527Z",
    fill: "url(#paint397_linear_7270_1548)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M140.32 3.84921C140.286 3.84921 140.217 3.88358 140.217 3.84921C140.32 3.81484 140.423 3.78047 140.526 3.74609C140.492 3.78047 140.423 3.74609 140.423 3.78046H140.389C140.389 3.78046 140.286 3.84921 140.32 3.84921Z",
    fill: "url(#paint398_linear_7270_1548)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M140.32 3.67715H140.285C140.32 3.64277 140.32 3.64277 140.32 3.67715C140.354 3.64277 140.32 3.64277 140.32 3.67715Z",
    fill: "url(#paint399_linear_7270_1548)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M139.804 4.02148C139.77 4.05586 139.839 4.05586 139.804 4.09023C139.804 4.09023 139.804 4.05586 139.77 4.09023C139.736 4.1246 139.701 4.1246 139.701 4.09023C139.701 4.02148 139.736 4.02148 139.804 4.02148Z",
    fill: "url(#paint400_linear_7270_1548)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M138.875 5.18945C138.841 5.22382 138.772 5.22382 138.703 5.2582C138.772 5.22382 138.841 5.18945 138.875 5.18945Z",
    fill: "url(#paint401_linear_7270_1548)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M138.703 5.18965C138.737 5.18965 138.703 5.18965 138.737 5.15527C138.737 5.18965 138.737 5.18965 138.703 5.18965C138.737 5.18965 138.737 5.18965 138.703 5.18965Z",
    fill: "url(#paint402_linear_7270_1548)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M151.457 2.81794C151.422 2.81794 151.388 2.81794 151.354 2.81794C151.388 2.78357 151.354 2.81794 151.388 2.78357C151.388 2.7492 151.491 2.71483 151.491 2.64608C151.525 2.61171 151.56 2.57734 151.56 2.54297C151.663 2.54297 151.594 2.57734 151.56 2.61171C151.56 2.61171 151.56 2.68045 151.525 2.68045H151.56C151.56 2.68045 151.491 2.68046 151.525 2.71483H151.491L151.457 2.7492C151.457 2.7492 151.457 2.78357 151.457 2.81794Z",
    fill: "url(#paint403_linear_7270_1548)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M149.255 1.54653C149.255 1.51215 149.289 1.54653 149.255 1.54653V1.54653Z",
    fill: "url(#paint404_linear_7270_1548)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M149.085 0.618322C149.016 0.618322 148.982 0.652694 148.948 0.687066C148.879 0.687066 148.81 0.652694 148.741 0.618322C148.673 0.58395 148.604 0.687065 148.535 0.618322C148.535 0.58395 148.57 0.583951 148.604 0.54958C148.638 0.54958 148.673 0.54958 148.707 0.54958C148.776 0.446465 148.913 0.412092 148.982 0.343349C149.085 0.274606 149.188 0.240234 149.326 0.240234C149.394 0.240234 149.532 0.240234 149.532 0.274605C149.566 0.308977 149.532 0.34335 149.566 0.377721C149.532 0.412093 149.532 0.446465 149.463 0.480836C149.429 0.515208 149.36 0.583951 149.257 0.583951C149.188 0.618322 149.119 0.618322 149.085 0.618322Z",
    fill: "url(#paint405_linear_7270_1548)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M149.152 1.61543C149.152 1.61543 149.187 1.61543 149.255 1.58105C149.221 1.61543 149.187 1.61543 149.152 1.61543Z",
    fill: "url(#paint406_linear_7270_1548)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M150.391 0.240426C150.391 0.240426 150.425 0.240426 150.459 0.240426C150.494 0.240426 150.494 0.240426 150.494 0.206055H150.459H150.425C150.425 0.206055 150.459 0.206055 150.494 0.206055C150.528 0.206055 150.494 0.240425 150.459 0.274797C150.425 0.240425 150.391 0.240426 150.391 0.240426Z",
    fill: "url(#paint407_linear_7270_1548)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M151.009 0.102539C150.975 0.102539 151.009 0.136911 151.009 0.102539C150.975 0.102539 151.009 0.171282 151.009 0.102539Z",
    fill: "url(#paint408_linear_7270_1548)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M132.035 20.5881C132.035 14.8481 135.404 9.00488 142.862 9.00488C150.596 9.00488 153.071 15.2262 153.071 20.1413C153.071 20.6569 153.036 21.1724 152.967 21.688C152.933 21.9974 152.658 22.2723 152.314 22.2723H138.497C138.119 22.2723 137.844 22.5817 137.844 22.9254C137.844 22.9941 137.844 23.0285 137.844 23.0973C138.463 25.5376 140.078 27.1187 143.206 27.1187C144.615 27.1187 145.921 26.8094 147.124 25.9845C148.018 25.3658 149.221 25.4002 150.046 26.122L150.218 26.2594C151.18 27.1187 151.283 28.5967 150.424 29.5935C150.287 29.731 150.115 29.9028 149.977 30.006C148.052 31.3465 145.784 31.9995 143.137 31.9995C135.61 31.9995 132.035 26.5344 132.035 20.5881ZM147.09 18.3883C147.468 18.3883 147.743 18.079 147.743 17.7009C147.743 17.6665 147.743 17.6322 147.743 17.5978C147.709 17.3916 147.674 17.1853 147.606 16.9791C147.056 14.7106 145.165 13.5419 142.828 13.5419C139.975 13.5419 138.566 15.2262 137.947 17.5634C137.844 17.9071 138.05 18.2852 138.428 18.354C138.497 18.354 138.531 18.354 138.6 18.354L147.09 18.3883Z",
    fill: "#66BDE4"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1794 12.3045C21.0827 10.311 18.2986 9.21106 15.377 9.21106H9.43072V3.16165C9.43072 1.68367 8.19334 0.446289 6.71536 0.446289C5.23738 0.446289 4 1.68367 4 3.16165V9.58915C4 9.65789 4 9.76101 4 9.82975C4 9.86412 4 9.93287 4 9.96724V20.5881C4 26.8781 9.12137 31.9651 15.4114 31.9651C15.652 31.9651 15.8926 31.9651 16.1676 31.9307C21.8045 31.5526 26.3759 26.9812 26.754 21.3443C26.9603 17.9758 25.6541 14.6762 23.1794 12.3045ZM21.014 21.2755C20.6359 24.4033 17.8174 26.6375 14.6896 26.2594C11.8367 25.9157 9.67132 23.5097 9.67132 20.5881V14.9168H15.377C18.5048 14.9168 21.0827 17.4946 21.0827 20.6224C21.0483 20.863 21.0483 21.0693 21.014 21.2755Z",
    fill: "#66BDE4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7270_1548",
    x1: 134.56,
    y1: 8.00391,
    x2: 134.531,
    y2: 8.03315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7270_1548",
    x1: 140.47,
    y1: 4.89263,
    x2: 140.362,
    y2: 5.00003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7270_1548",
    x1: 136.297,
    y1: 7.28002,
    x2: 136.181,
    y2: 7.39575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7270_1548",
    x1: 136.411,
    y1: 7.23257,
    x2: 136.329,
    y2: 7.31393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7270_1548",
    x1: 136.999,
    y1: 6.93093,
    x2: 136.959,
    y2: 6.97054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7270_1548",
    x1: 138.887,
    y1: 5.56372,
    x2: 138.838,
    y2: 5.61273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7270_1548",
    x1: 138.438,
    y1: 5.69699,
    x2: 138.148,
    y2: 5.98686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7270_1548",
    x1: 138.406,
    y1: 5.69974,
    x2: 138.36,
    y2: 5.74665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7270_1548",
    x1: 137.743,
    y1: 6.26702,
    x2: 137.675,
    y2: 6.33479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7270_1548",
    x1: 136.558,
    y1: 7.18103,
    x2: 136.514,
    y2: 7.22479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7270_1548",
    x1: 134.411,
    y1: 8.03549,
    x2: 134.284,
    y2: 8.16271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7270_1548",
    x1: 142.883,
    y1: 3.44788,
    x2: 142.846,
    y2: 3.48541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7270_1548",
    x1: 139.001,
    y1: 4.51335,
    x2: 138.921,
    y2: 4.59361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7270_1548",
    x1: 138.46,
    y1: 4.82256,
    x2: 138.259,
    y2: 5.02379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7270_1548",
    x1: 138.718,
    y1: 4.72571,
    x2: 138.542,
    y2: 4.90191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7270_1548",
    x1: 144.217,
    y1: 2.48713,
    x2: 144.1,
    y2: 2.6039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7270_1548",
    x1: 140.702,
    y1: 3.89707,
    x2: 140.679,
    y2: 3.92001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7270_1548",
    x1: 138.886,
    y1: 4.59495,
    x2: 138.713,
    y2: 4.76802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7270_1548",
    x1: 138.924,
    y1: 4.71197,
    x2: 138.888,
    y2: 4.74741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7270_1548",
    x1: 138.866,
    y1: 4.85723,
    x2: 138.756,
    y2: 4.96671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7270_1548",
    x1: 138.917,
    y1: 4.87935,
    x2: 138.887,
    y2: 4.90958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7270_1548",
    x1: 140.752,
    y1: 3.8157,
    x2: 140.7,
    y2: 3.86782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7270_1548",
    x1: 143.588,
    y1: 2.72733,
    x2: 143.551,
    y2: 2.76382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7270_1548",
    x1: 143.861,
    y1: 2.60139,
    x2: 143.83,
    y2: 2.6327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7270_1548",
    x1: 146.301,
    y1: 1.68204,
    x2: 145.528,
    y2: 2.45565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7270_1548",
    x1: 147.097,
    y1: 1.69933,
    x2: 146.673,
    y2: 2.12369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7270_1548",
    x1: 147.784,
    y1: 1.79235,
    x2: 147.74,
    y2: 1.83616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7270_1548",
    x1: 147.345,
    y1: 1.84097,
    x2: 147.324,
    y2: 1.86288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7270_1548",
    x1: 147.45,
    y1: 1.79819,
    x2: 147.398,
    y2: 1.85029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_7270_1548",
    x1: 138.054,
    y1: 6.78435,
    x2: 138.018,
    y2: 6.82084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_7270_1548",
    x1: 140.315,
    y1: 5.51029,
    x2: 140.282,
    y2: 5.54365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_7270_1548",
    x1: 134.731,
    y1: 9.03735,
    x2: 134.437,
    y2: 9.33139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_7270_1548",
    x1: 135.036,
    y1: 8.83165,
    x2: 134.762,
    y2: 9.10585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_7270_1548",
    x1: 142.881,
    y1: 5.0563,
    x2: 142.65,
    y2: 5.2867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_7270_1548",
    x1: 142.06,
    y1: 5.02765,
    x2: 141.888,
    y2: 5.19967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_7270_1548",
    x1: 142.85,
    y1: 5.0727,
    x2: 142.766,
    y2: 5.15716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_7270_1548",
    x1: 144.35,
    y1: 4.52125,
    x2: 143.395,
    y2: 5.47624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_7270_1548",
    x1: 144.273,
    y1: 4.62408,
    x2: 143.749,
    y2: 5.14827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_7270_1548",
    x1: 137.996,
    y1: 6.92813,
    x2: 137.975,
    y2: 6.94899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_7270_1548",
    x1: 137.434,
    y1: 7.30194,
    x2: 137.404,
    y2: 7.33217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_7270_1548",
    x1: 135.229,
    y1: 8.65524,
    x2: 134.974,
    y2: 8.91065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_7270_1548",
    x1: 139.134,
    y1: 6.43313,
    x2: 138.843,
    y2: 6.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_7270_1548",
    x1: 142.645,
    y1: 5.13147,
    x2: 142.587,
    y2: 5.18882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_7270_1548",
    x1: 135.576,
    y1: 6.3281,
    x2: 149.238,
    y2: 6.3281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_7270_1548",
    x1: 135.278,
    y1: 8.74745,
    x2: 135.224,
    y2: 8.80168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_7270_1548",
    x1: 135.265,
    y1: 8.77544,
    x2: 135.215,
    y2: 8.82449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_7270_1548",
    x1: 135.256,
    y1: 8.91451,
    x2: 135.1,
    y2: 9.07089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_7270_1548",
    x1: 135.32,
    y1: 8.91076,
    x2: 135.276,
    y2: 8.95454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_7270_1548",
    x1: 136.218,
    y1: 7.97279,
    x2: 136.175,
    y2: 8.01552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_7270_1548",
    x1: 137.5,
    y1: 7.1939,
    x2: 137.258,
    y2: 7.43578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_7270_1548",
    x1: 137.478,
    y1: 7.19261,
    x2: 137.4,
    y2: 7.2708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_7270_1548",
    x1: 137.943,
    y1: 6.92644,
    x2: 137.901,
    y2: 6.9692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_7270_1548",
    x1: 137.201,
    y1: 7.75582,
    x2: 137.146,
    y2: 7.8111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_7270_1548",
    x1: 137.549,
    y1: 7.42272,
    x2: 137.511,
    y2: 7.46025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_7270_1548",
    x1: 138.284,
    y1: 6.73974,
    x2: 138.24,
    y2: 6.78352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_7270_1548",
    x1: 137.955,
    y1: 7.26695,
    x2: 137.915,
    y2: 7.30761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_7270_1548",
    x1: 138.475,
    y1: 6.85103,
    x2: 138.428,
    y2: 6.89795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_7270_1548",
    x1: 138.742,
    y1: 6.71467,
    x2: 138.693,
    y2: 6.76367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_7270_1548",
    x1: 139.608,
    y1: 5.981,
    x2: 139.455,
    y2: 6.13426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_7270_1548",
    x1: 139.746,
    y1: 5.93588,
    x2: 139.706,
    y2: 5.97653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_7270_1548",
    x1: 139.535,
    y1: 6.28967,
    x2: 139.476,
    y2: 6.34916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_7270_1548",
    x1: 140.002,
    y1: 5.88047,
    x2: 139.964,
    y2: 5.91905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_7270_1548",
    x1: 139.676,
    y1: 6.21471,
    x2: 139.629,
    y2: 6.26166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_7270_1548",
    x1: 139.619,
    y1: 6.38817,
    x2: 139.545,
    y2: 6.46219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_7270_1548",
    x1: 140.036,
    y1: 6.19072,
    x2: 139.897,
    y2: 6.33038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_7270_1548",
    x1: 140.26,
    y1: 5.98925,
    x2: 140.203,
    y2: 6.0466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_7270_1548",
    x1: 141.201,
    y1: 5.74535,
    x2: 141.139,
    y2: 5.80792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_7270_1548",
    x1: 143.382,
    y1: 4.643,
    x2: 143.293,
    y2: 4.73268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_7270_1548",
    x1: 143.468,
    y1: 4.62943,
    x2: 143.419,
    y2: 4.67838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_7270_1548",
    x1: 143.487,
    y1: 4.97249,
    x2: 143.451,
    y2: 5.00894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_7270_1548",
    x1: 143.81,
    y1: 4.85487,
    x2: 143.746,
    y2: 4.91951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_7270_1548",
    x1: 143.79,
    y1: 4.97073,
    x2: 143.755,
    y2: 5.00622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_7270_1548",
    x1: 145.911,
    y1: 3.92057,
    x2: 145.333,
    y2: 4.49891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_7270_1548",
    x1: 146.391,
    y1: 4.04968,
    x2: 146.326,
    y2: 4.11535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_7270_1548",
    x1: 144.84,
    y1: 4.66212,
    x2: 144.634,
    y2: 4.86857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_7270_1548",
    x1: 132.428,
    y1: 9.93828,
    x2: 132.041,
    y2: 10.3251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_7270_1548",
    x1: 132.824,
    y1: 9.66623,
    x2: 132.466,
    y2: 10.0249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_7270_1548",
    x1: 135.966,
    y1: 7.6581,
    x2: 135.928,
    y2: 7.69668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_7270_1548",
    x1: 136.477,
    y1: 7.61585,
    x2: 136.463,
    y2: 7.62939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_7270_1548",
    x1: 133.075,
    y1: 9.42839,
    x2: 132.741,
    y2: 9.76305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_7270_1548",
    x1: 135.324,
    y1: 8.15735,
    x2: 135.292,
    y2: 8.18969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_7270_1548",
    x1: 135.291,
    y1: 8.20453,
    x2: 135.197,
    y2: 8.29836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_7270_1548",
    x1: 133.131,
    y1: 9.54258,
    x2: 133.06,
    y2: 9.61347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_7270_1548",
    x1: 133.11,
    y1: 9.57786,
    x2: 133.045,
    y2: 9.64249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_7270_1548",
    x1: 133.059,
    y1: 9.72519,
    x2: 132.853,
    y2: 9.93077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_7270_1548",
    x1: 133.146,
    y1: 9.71935,
    x2: 133.086,
    y2: 9.77879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_7270_1548",
    x1: 136.059,
    y1: 7.52494,
    x2: 135.742,
    y2: 7.84187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_7270_1548",
    x1: 136.051,
    y1: 7.54233,
    x2: 135.949,
    y2: 7.6445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_7270_1548",
    x1: 135.579,
    y1: 8.17311,
    x2: 135.547,
    y2: 8.2054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_7270_1548",
    x1: 136.639,
    y1: 7.18069,
    x2: 136.584,
    y2: 7.23594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_7270_1548",
    x1: 135.612,
    y1: 8.1913,
    x2: 135.54,
    y2: 8.26327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_7270_1548",
    x1: 136.092,
    y1: 7.77937,
    x2: 136.042,
    y2: 7.8294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_7270_1548",
    x1: 137.084,
    y1: 6.93308,
    x2: 137.025,
    y2: 6.99251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_7270_1548",
    x1: 136.604,
    y1: 7.54379,
    x2: 136.55,
    y2: 7.59801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_7270_1548",
    x1: 138.966,
    y1: 5.86375,
    x2: 138.913,
    y2: 5.91588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_7270_1548",
    x1: 140.836,
    y1: 5.384,
    x2: 140.753,
    y2: 5.46741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_7270_1548",
    x1: 149.193,
    y1: 3.54709,
    x2: 149.132,
    y2: 3.60759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_7270_1548",
    x1: 149.211,
    y1: 3.23501,
    x2: 149.178,
    y2: 3.26837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_7270_1548",
    x1: 149.204,
    y1: 3.26737,
    x2: 149.155,
    y2: 3.31637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_7270_1548",
    x1: 149.23,
    y1: 3.17668,
    x2: 149.191,
    y2: 3.21525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_7270_1548",
    x1: 148.924,
    y1: 3.5754,
    x2: 148.881,
    y2: 3.61814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_7270_1548",
    x1: 148.869,
    y1: 3.61403,
    x2: 148.732,
    y2: 3.75166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_7270_1548",
    x1: 148.013,
    y1: 3.86703,
    x2: 147.983,
    y2: 3.89727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_7270_1548",
    x1: 147.874,
    y1: 3.8549,
    x2: 147.828,
    y2: 3.90076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_7270_1548",
    x1: 147.199,
    y1: 3.8723,
    x2: 147.176,
    y2: 3.89524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_7270_1548",
    x1: 144.85,
    y1: 3.93405,
    x2: 143.811,
    y2: 4.97252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_7270_1548",
    x1: 143.769,
    y1: 3.22617,
    x2: 143.713,
    y2: 3.28247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_7270_1548",
    x1: 143.342,
    y1: 3.34874,
    x2: 143.309,
    y2: 3.38107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_7270_1548",
    x1: 143.35,
    y1: 4.51693,
    x2: 143.246,
    y2: 4.62011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_7270_1548",
    x1: 143.272,
    y1: 4.5379,
    x2: 143.219,
    y2: 4.59103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_7270_1548",
    x1: 143.049,
    y1: 4.54479,
    x2: 142.965,
    y2: 4.62821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_7270_1548",
    x1: 142.842,
    y1: 3.47099,
    x2: 142.777,
    y2: 3.53668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_7270_1548",
    x1: 142.812,
    y1: 3.54828,
    x2: 142.775,
    y2: 3.58476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_7270_1548",
    x1: 142.526,
    y1: 4.75073,
    x2: 142.461,
    y2: 4.8153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_7270_1548",
    x1: 141.006,
    y1: 4.15849,
    x2: 140.735,
    y2: 4.42957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_7270_1548",
    x1: 140.942,
    y1: 4.33321,
    x2: 140.738,
    y2: 4.53757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_7270_1548",
    x1: 140.645,
    y1: 4.49102,
    x2: 140.602,
    y2: 4.53373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_7270_1548",
    x1: 140.592,
    y1: 4.30043,
    x2: 140.524,
    y2: 4.36825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_7270_1548",
    x1: 140.241,
    y1: 4.43821,
    x2: 140.18,
    y2: 4.49971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_7270_1548",
    x1: 140.217,
    y1: 4.50613,
    x2: 140.17,
    y2: 4.55301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_7270_1548",
    x1: 140.023,
    y1: 4.57186,
    x2: 139.983,
    y2: 4.61251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_7270_1548",
    x1: 139.913,
    y1: 4.6167,
    x2: 139.855,
    y2: 4.67509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_7270_1548",
    x1: 139.859,
    y1: 4.59992,
    x2: 139.782,
    y2: 4.67708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_7270_1548",
    x1: 139.795,
    y1: 4.6479,
    x2: 139.734,
    y2: 4.70836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_7270_1548",
    x1: 139.695,
    y1: 4.67593,
    x2: 139.593,
    y2: 4.77806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_7270_1548",
    x1: 139.322,
    y1: 4.98013,
    x2: 139.27,
    y2: 5.03223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_7270_1548",
    x1: 139.098,
    y1: 4.92784,
    x2: 139.038,
    y2: 4.98831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_7270_1548",
    x1: 139.135,
    y1: 5.5021,
    x2: 139.084,
    y2: 5.55321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_7270_1548",
    x1: 138.808,
    y1: 5.20847,
    x2: 138.727,
    y2: 5.28979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_7270_1548",
    x1: 138.692,
    y1: 4.93684,
    x2: 138.644,
    y2: 4.98478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_7270_1548",
    x1: 138.769,
    y1: 5.27253,
    x2: 138.722,
    y2: 5.31941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_7270_1548",
    x1: 138.704,
    y1: 5.27507,
    x2: 138.668,
    y2: 5.31153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_7270_1548",
    x1: 138.706,
    y1: 5.32489,
    x2: 138.668,
    y2: 5.36347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_7270_1548",
    x1: 138.573,
    y1: 5.15778,
    x2: 138.517,
    y2: 5.21406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_7270_1548",
    x1: 138.621,
    y1: 5.28796,
    x2: 138.577,
    y2: 5.33176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_7270_1548",
    x1: 138.427,
    y1: 5.04731,
    x2: 138.357,
    y2: 5.11714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_7270_1548",
    x1: 138.549,
    y1: 5.32989,
    x2: 138.51,
    y2: 5.36848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_7270_1548",
    x1: 138.518,
    y1: 5.24939,
    x2: 138.485,
    y2: 5.28275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_7270_1548",
    x1: 138.491,
    y1: 5.20497,
    x2: 138.444,
    y2: 5.2519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_7270_1548",
    x1: 138.496,
    y1: 5.26525,
    x2: 138.384,
    y2: 5.3768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_7270_1548",
    x1: 138.285,
    y1: 5.1165,
    x2: 138.159,
    y2: 5.24262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_7270_1548",
    x1: 138.257,
    y1: 5.56204,
    x2: 138.173,
    y2: 5.6465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_7270_1548",
    x1: 138.22,
    y1: 5.63609,
    x2: 138.132,
    y2: 5.72365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_7270_1548",
    x1: 138.113,
    y1: 5.6317,
    x2: 138.035,
    y2: 5.70989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_7270_1548",
    x1: 137.923,
    y1: 5.40426,
    x2: 137.801,
    y2: 5.52613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_7270_1548",
    x1: 138.296,
    y1: 6.16217,
    x2: 138.14,
    y2: 6.31749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_7270_1548",
    x1: 138.02,
    y1: 5.62199,
    x2: 137.965,
    y2: 5.67721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_7270_1548",
    x1: 137.753,
    y1: 5.49383,
    x2: 137.706,
    y2: 5.54074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_7270_1548",
    x1: 138.012,
    y1: 6.07042,
    x2: 137.946,
    y2: 6.13716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_7270_1548",
    x1: 137.772,
    y1: 5.63948,
    x2: 137.686,
    y2: 5.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_7270_1548",
    x1: 137.683,
    y1: 5.71094,
    x2: 137.591,
    y2: 5.80267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_7270_1548",
    x1: 138.056,
    y1: 6.42664,
    x2: 137.989,
    y2: 6.49339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_7270_1548",
    x1: 137.675,
    y1: 5.78419,
    x2: 137.628,
    y2: 5.83107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_7270_1548",
    x1: 137.618,
    y1: 5.71699,
    x2: 137.596,
    y2: 5.73888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_7270_1548",
    x1: 137.459,
    y1: 5.70555,
    x2: 137.331,
    y2: 5.83379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_7270_1548",
    x1: 137.315,
    y1: 5.70406,
    x2: 137.229,
    y2: 5.79059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_7270_1548",
    x1: 137.326,
    y1: 5.74474,
    x2: 137.286,
    y2: 5.78435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_7270_1548",
    x1: 137.47,
    y1: 6.03718,
    x2: 137.361,
    y2: 6.14563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_7270_1548",
    x1: 137.512,
    y1: 6.30797,
    x2: 137.388,
    y2: 6.43204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_7270_1548",
    x1: 137.304,
    y1: 6.00963,
    x2: 137.218,
    y2: 6.09511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_7270_1548",
    x1: 137.273,
    y1: 6.14907,
    x2: 137.233,
    y2: 6.18973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_7270_1548",
    x1: 137.376,
    y1: 6.36652,
    x2: 137.328,
    y2: 6.4145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_7270_1548",
    x1: 137.292,
    y1: 6.31675,
    x2: 137.222,
    y2: 6.38659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_7270_1548",
    x1: 137.493,
    y1: 6.32004,
    x2: 137.785,
    y2: 6.32004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_7270_1548",
    x1: 136.972,
    y1: 6.06051,
    x2: 136.902,
    y2: 6.13038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_7270_1548",
    x1: 136.865,
    y1: 5.91981,
    x2: 136.715,
    y2: 6.06888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_7270_1548",
    x1: 137.131,
    y1: 6.45721,
    x2: 137.093,
    y2: 6.49579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_7270_1548",
    x1: 137.146,
    y1: 6.54879,
    x2: 137.095,
    y2: 6.59989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_7270_1548",
    x1: 137.075,
    y1: 6.43573,
    x2: 137.027,
    y2: 6.48369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_7270_1548",
    x1: 137.025,
    y1: 6.36801,
    x2: 136.934,
    y2: 6.4598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_7270_1548",
    x1: 137.058,
    y1: 6.49662,
    x2: 137.034,
    y2: 6.52059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_7270_1548",
    x1: 136.944,
    y1: 6.35459,
    x2: 136.89,
    y2: 6.40876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_7270_1548",
    x1: 137.168,
    y1: 6.76788,
    x2: 137.063,
    y2: 6.87321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_7270_1548",
    x1: 136.768,
    y1: 6.17637,
    x2: 136.652,
    y2: 6.29314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_7270_1548",
    x1: 136.757,
    y1: 6.28158,
    x2: 136.719,
    y2: 6.32013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_7270_1548",
    x1: 136.764,
    y1: 6.32986,
    x2: 136.715,
    y2: 6.37883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_7270_1548",
    x1: 136.659,
    y1: 6.32337,
    x2: 136.604,
    y2: 6.37864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_7270_1548",
    x1: 137.06,
    y1: 6.96528,
    x2: 137.009,
    y2: 7.01639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_7270_1548",
    x1: 136.724,
    y1: 6.51667,
    x2: 136.667,
    y2: 6.57297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_7270_1548",
    x1: 136.852,
    y1: 6.91669,
    x2: 136.74,
    y2: 7.02826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_7270_1548",
    x1: 136.346,
    y1: 6.20302,
    x2: 136.303,
    y2: 6.24681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_7270_1548",
    x1: 136.686,
    y1: 7.03789,
    x2: 136.626,
    y2: 7.09837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_7270_1548",
    x1: 136.277,
    y1: 6.57368,
    x2: 136.216,
    y2: 6.63517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_7270_1548",
    x1: 136.033,
    y1: 6.41326,
    x2: 135.89,
    y2: 6.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_7270_1548",
    x1: 136.292,
    y1: 6.78635,
    x2: 136.204,
    y2: 6.87391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_7270_1548",
    x1: 136.106,
    y1: 6.53104,
    x2: 136.085,
    y2: 6.55293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_7270_1548",
    x1: 136.102,
    y1: 6.89445,
    x2: 136.048,
    y2: 6.94865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_7270_1548",
    x1: 135.972,
    y1: 6.81132,
    x2: 135.942,
    y2: 6.84156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_7270_1548",
    x1: 135.917,
    y1: 6.79131,
    x2: 135.882,
    y2: 6.82572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_7270_1548",
    x1: 136.26,
    y1: 7.27995,
    x2: 136.208,
    y2: 7.33207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_7270_1548",
    x1: 135.957,
    y1: 6.8671,
    x2: 135.909,
    y2: 6.91503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_7270_1548",
    x1: 135.971,
    y1: 6.90868,
    x2: 135.894,
    y2: 6.98577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_7270_1548",
    x1: 135.772,
    y1: 6.71826,
    x2: 135.653,
    y2: 6.83711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_7270_1548",
    x1: 136.025,
    y1: 7.11186,
    x2: 135.934,
    y2: 7.20258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_7270_1548",
    x1: 135.848,
    y1: 6.91441,
    x2: 135.748,
    y2: 7.01447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_7270_1548",
    x1: 136.115,
    y1: 7.36058,
    x2: 136.055,
    y2: 7.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_7270_1548",
    x1: 135.655,
    y1: 6.86504,
    x2: 135.608,
    y2: 6.91194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_7270_1548",
    x1: 135.79,
    y1: 7.06443,
    x2: 135.764,
    y2: 7.0905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_7270_1548",
    x1: 135.493,
    y1: 6.69146,
    x2: 135.419,
    y2: 6.76551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_7270_1548",
    x1: 135.709,
    y1: 6.9951,
    x2: 135.585,
    y2: 7.11917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_7270_1548",
    x1: 135.576,
    y1: 6.83917,
    x2: 135.498,
    y2: 6.91736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_7270_1548",
    x1: 135.752,
    y1: 7.08704,
    x2: 135.662,
    y2: 7.17671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_7270_1548",
    x1: 135.776,
    y1: 7.2501,
    x2: 135.715,
    y2: 7.31057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_7270_1548",
    x1: 135.538,
    y1: 6.95685,
    x2: 135.476,
    y2: 7.01837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_7270_1548",
    x1: 135.514,
    y1: 7.00677,
    x2: 135.454,
    y2: 7.06725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_7270_1548",
    x1: 135.609,
    y1: 7.17459,
    x2: 135.562,
    y2: 7.22149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_7270_1548",
    x1: 135.903,
    y1: 7.57158,
    x2: 135.782,
    y2: 7.69252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_7270_1548",
    x1: 135.806,
    y1: 7.46319,
    x2: 135.761,
    y2: 7.50802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_7270_1548",
    x1: 135.744,
    y1: 7.56399,
    x2: 135.638,
    y2: 7.67031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_7270_1548",
    x1: 135.523,
    y1: 7.28346,
    x2: 135.495,
    y2: 7.31158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_7270_1548",
    x1: 135.493,
    y1: 7.40815,
    x2: 135.401,
    y2: 7.49989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_7270_1548",
    x1: 135.128,
    y1: 6.97331,
    x2: 135.063,
    y2: 7.03904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_7270_1548",
    x1: 135.733,
    y1: 7.7556,
    x2: 135.687,
    y2: 7.80148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_7270_1548",
    x1: 135.333,
    y1: 7.26057,
    x2: 135.251,
    y2: 7.34188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_7270_1548",
    x1: 135.403,
    y1: 7.4178,
    x2: 135.342,
    y2: 7.47929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_7270_1548",
    x1: 135,
    y1: 6.96054,
    x2: 134.961,
    y2: 7.00022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_7270_1548",
    x1: 135.024,
    y1: 7.18788,
    x2: 134.962,
    y2: 7.25045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_7270_1548",
    x1: 135.161,
    y1: 7.37242,
    x2: 135.083,
    y2: 7.45064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_7270_1548",
    x1: 134.915,
    y1: 7.06988,
    x2: 134.887,
    y2: 7.09804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_7270_1548",
    x1: 135.369,
    y1: 7.69405,
    x2: 135.293,
    y2: 7.77016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_7270_1548",
    x1: 135.323,
    y1: 7.77341,
    x2: 135.278,
    y2: 7.81825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_7270_1548",
    x1: 135.37,
    y1: 7.89884,
    x2: 135.287,
    y2: 7.98122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_7270_1548",
    x1: 135.25,
    y1: 7.75614,
    x2: 135.158,
    y2: 7.84789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_7270_1548",
    x1: 134.738,
    y1: 7.18631,
    x2: 134.685,
    y2: 7.23948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_7270_1548",
    x1: 135.36,
    y1: 7.95302,
    x2: 135.3,
    y2: 8.01349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_7270_1548",
    x1: 134.977,
    y1: 7.53221,
    x2: 134.93,
    y2: 7.57911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_7270_1548",
    x1: 134.778,
    y1: 7.35378,
    x2: 134.589,
    y2: 7.54249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_7270_1548",
    x1: 135.139,
    y1: 7.84265,
    x2: 135.1,
    y2: 7.88124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_7270_1548",
    x1: 134.835,
    y1: 7.49297,
    x2: 134.546,
    y2: 7.78178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_7270_1548",
    x1: 135.071,
    y1: 7.86998,
    x2: 135.018,
    y2: 7.92315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_7270_1548",
    x1: 134.402,
    y1: 7.40598,
    x2: 134.278,
    y2: 7.53002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_7270_1548",
    x1: 134.894,
    y1: 7.97913,
    x2: 134.863,
    y2: 8.01037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_7270_1548",
    x1: 134.315,
    y1: 7.39002,
    x2: 134.267,
    y2: 7.43796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_7270_1548",
    x1: 134.447,
    y1: 7.5583,
    x2: 134.359,
    y2: 7.64586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_7270_1548",
    x1: 134.829,
    y1: 8.02268,
    x2: 134.73,
    y2: 8.12179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_7270_1548",
    x1: 134.325,
    y1: 7.57259,
    x2: 134.294,
    y2: 7.60386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_7270_1548",
    x1: 134.425,
    y1: 7.75389,
    x2: 134.337,
    y2: 7.8415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_7270_1548",
    x1: 134.191,
    y1: 7.54353,
    x2: 134.104,
    y2: 7.63114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_7270_1548",
    x1: 134.33,
    y1: 7.75133,
    x2: 134.304,
    y2: 7.77739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_7270_1548",
    x1: 134.097,
    y1: 7.50485,
    x2: 134.033,
    y2: 7.56845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_7270_1548",
    x1: 134.272,
    y1: 7.81469,
    x2: 134.239,
    y2: 7.84805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_7270_1548",
    x1: 134.692,
    y1: 8.34174,
    x2: 134.548,
    y2: 8.48563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_7270_1548",
    x1: 133.971,
    y1: 7.58747,
    x2: 133.9,
    y2: 7.65839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_7270_1548",
    x1: 134.546,
    y1: 8.31179,
    x2: 134.486,
    y2: 8.37223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_7270_1548",
    x1: 134.482,
    y1: 8.30632,
    x2: 134.438,
    y2: 8.35116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_7270_1548",
    x1: 134.34,
    y1: 8.21649,
    x2: 134.202,
    y2: 8.35518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_7270_1548",
    x1: 134.431,
    y1: 8.42501,
    x2: 134.378,
    y2: 8.47819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_7270_1548",
    x1: 134.01,
    y1: 8.03855,
    x2: 133.967,
    y2: 8.0813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_7270_1548",
    x1: 133.876,
    y1: 7.98182,
    x2: 133.829,
    y2: 8.02874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_7270_1548",
    x1: 133.912,
    y1: 8.03232,
    x2: 133.891,
    y2: 8.05316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_7270_1548",
    x1: 134.374,
    y1: 8.53482,
    x2: 134.282,
    y2: 8.62655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_7270_1548",
    x1: 133.711,
    y1: 8.13004,
    x2: 133.687,
    y2: 8.15403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_7270_1548",
    x1: 133.735,
    y1: 8.34416,
    x2: 133.688,
    y2: 8.39109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_7270_1548",
    x1: 133.886,
    y1: 8.7466,
    x2: 133.84,
    y2: 8.79246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_7270_1548",
    x1: 133.371,
    y1: 8.32292,
    x2: 133.324,
    y2: 8.36985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_7270_1548",
    x1: 133.807,
    y1: 8.8056,
    x2: 133.747,
    y2: 8.8661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_7270_1548",
    x1: 133.773,
    y1: 8.86305,
    x2: 133.644,
    y2: 8.99226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_7270_1548",
    x1: 133.861,
    y1: 8.98077,
    x2: 133.817,
    y2: 9.02554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_7270_1548",
    x1: 133.577,
    y1: 9.09009,
    x2: 133.425,
    y2: 9.24127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_7270_1548",
    x1: 132.963,
    y1: 8.51204,
    x2: 132.939,
    y2: 8.53603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_7270_1548",
    x1: 132.831,
    y1: 8.43087,
    x2: 132.79,
    y2: 8.47155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_7270_1548",
    x1: 133.498,
    y1: 9.10295,
    x2: 133.446,
    y2: 9.15508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_7270_1548",
    x1: 132.914,
    y1: 8.60879,
    x2: 132.891,
    y2: 8.63173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_7270_1548",
    x1: 132.664,
    y1: 8.60921,
    x2: 132.631,
    y2: 8.64152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_7270_1548",
    x1: 132.537,
    y1: 8.58132,
    x2: 132.465,
    y2: 8.65326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_7270_1548",
    x1: 144.166,
    y1: 4.40374,
    x2: 144.103,
    y2: 4.46733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_7270_1548",
    x1: 143.501,
    y1: 4.55133,
    x2: 143.426,
    y2: 4.62642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_7270_1548",
    x1: 143.258,
    y1: 3.37026,
    x2: 143.201,
    y2: 3.42761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_7270_1548",
    x1: 143.12,
    y1: 3.35585,
    x2: 142.97,
    y2: 3.50595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_7270_1548",
    x1: 142.864,
    y1: 4.63097,
    x2: 142.786,
    y2: 4.70918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_7270_1548",
    x1: 142.725,
    y1: 4.60332,
    x2: 142.547,
    y2: 4.78161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_7270_1548",
    x1: 141.077,
    y1: 4.26249,
    x2: 141.019,
    y2: 4.31976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_7270_1548",
    x1: 141.027,
    y1: 4.25287,
    x2: 140.924,
    y2: 4.3561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_7270_1548",
    x1: 140.842,
    y1: 4.32057,
    x2: 140.7,
    y2: 4.46228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_7270_1548",
    x1: 140.696,
    y1: 4.09948,
    x2: 140.485,
    y2: 4.3111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_7270_1548",
    x1: 140.743,
    y1: 4.74465,
    x2: 140.697,
    y2: 4.79053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_7270_1548",
    x1: 140.509,
    y1: 4.5271,
    x2: 140.362,
    y2: 4.67411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_7270_1548",
    x1: 140.451,
    y1: 4.36064,
    x2: 140.37,
    y2: 4.44198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_7270_1548",
    x1: 140.228,
    y1: 4.65581,
    x2: 140.187,
    y2: 4.69646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_7270_1548",
    x1: 140.099,
    y1: 4.53097,
    x2: 140.029,
    y2: 4.60084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_7270_1548",
    x1: 140.113,
    y1: 4.65804,
    x2: 139.965,
    y2: 4.8061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_7270_1548",
    x1: 140.045,
    y1: 4.58264,
    x2: 139.968,
    y2: 4.65875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_7270_1548",
    x1: 139.216,
    y1: 4.8678,
    x2: 139.144,
    y2: 4.93973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_7270_1548",
    x1: 139.087,
    y1: 5.12024,
    x2: 139.02,
    y2: 5.18801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_7270_1548",
    x1: 138.9,
    y1: 5.10062,
    x2: 138.767,
    y2: 5.23408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_7270_1548",
    x1: 138.811,
    y1: 5.00663,
    x2: 138.625,
    y2: 5.19327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_7270_1548",
    x1: 138.644,
    y1: 5.34404,
    x2: 138.599,
    y2: 5.38992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_7270_1548",
    x1: 138.606,
    y1: 5.26485,
    x2: 138.569,
    y2: 5.30131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_7270_1548",
    x1: 138.391,
    y1: 5.19339,
    x2: 138.22,
    y2: 5.36434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_7270_1548",
    x1: 138.337,
    y1: 5.32501,
    x2: 138.291,
    y2: 5.37086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_7270_1548",
    x1: 138.226,
    y1: 5.20521,
    x2: 137.72,
    y2: 5.7111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_7270_1548",
    x1: 138.256,
    y1: 5.32901,
    x2: 138.025,
    y2: 5.56049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_7270_1548",
    x1: 137.843,
    y1: 5.65925,
    x2: 137.413,
    y2: 6.08884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_7270_1548",
    x1: 137.645,
    y1: 5.52606,
    x2: 137.527,
    y2: 5.64389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_7270_1548",
    x1: 137.593,
    y1: 5.60299,
    x2: 137.486,
    y2: 5.71043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_7270_1548",
    x1: 137.516,
    y1: 5.61183,
    x2: 137.367,
    y2: 5.76089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_7270_1548",
    x1: 137.28,
    y1: 5.78636,
    x2: 137.146,
    y2: 5.92088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_7270_1548",
    x1: 137.054,
    y1: 5.8847,
    x2: 136.962,
    y2: 5.97647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_7270_1548",
    x1: 137.036,
    y1: 5.96647,
    x2: 136.998,
    y2: 6.00506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_7270_1548",
    x1: 136.637,
    y1: 6.09029,
    x2: 136.358,
    y2: 6.36867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_7270_1548",
    x1: 136.61,
    y1: 6.19588,
    x2: 135.807,
    y2: 6.99869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_7270_1548",
    x1: 136.735,
    y1: 6.39374,
    x2: 136.403,
    y2: 6.72631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_7270_1548",
    x1: 136.563,
    y1: 6.23485,
    x2: 136.242,
    y2: 6.55569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_7270_1548",
    x1: 136.61,
    y1: 6.30789,
    x2: 136.568,
    y2: 6.34957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_7270_1548",
    x1: 136.274,
    y1: 6.29116,
    x2: 136.156,
    y2: 6.40898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_7270_1548",
    x1: 135.662,
    y1: 6.63101,
    x2: 135.494,
    y2: 6.79886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_7270_1548",
    x1: 135.588,
    y1: 6.90602,
    x2: 135.52,
    y2: 6.97378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_7270_1548",
    x1: 135.459,
    y1: 6.92552,
    x2: 135.187,
    y2: 7.19762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_7270_1548",
    x1: 135.45,
    y1: 6.76712,
    x2: 135.298,
    y2: 6.91933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_7270_1548",
    x1: 135.333,
    y1: 7.11328,
    x2: 135.965,
    y2: 7.11328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_7270_1548",
    x1: 135.39,
    y1: 7.33542,
    x2: 135.314,
    y2: 7.41154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_7270_1548",
    x1: 135.058,
    y1: 6.94017,
    x2: 135.009,
    y2: 6.98922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_7270_1548",
    x1: 135.187,
    y1: 7.18144,
    x2: 134.962,
    y2: 7.40665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_7270_1548",
    x1: 135.088,
    y1: 7.13051,
    x2: 134.83,
    y2: 7.38911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_7270_1548",
    x1: 134.89,
    y1: 7.11164,
    x2: 134.841,
    y2: 7.16064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_7270_1548",
    x1: 134.997,
    y1: 7.47126,
    x2: 134.958,
    y2: 7.50982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_7270_1548",
    x1: 134.917,
    y1: 7.3763,
    x2: 134.823,
    y2: 7.47016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_7270_1548",
    x1: 135.119,
    y1: 8.0561,
    x2: 135.076,
    y2: 8.09886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_7270_1548",
    x1: 134.341,
    y1: 7.64174,
    x2: 134.247,
    y2: 7.73662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_7270_1548",
    x1: 134.731,
    y1: 8.30747,
    x2: 134.688,
    y2: 8.3502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_7270_1548",
    x1: 134.639,
    y1: 8.33335,
    x2: 134.511,
    y2: 8.4616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_7270_1548",
    x1: 133.543,
    y1: 9.01255,
    x2: 133.398,
    y2: 9.15746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_7270_1548",
    x1: 133.395,
    y1: 9.06307,
    x2: 133.35,
    y2: 9.1079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_7270_1548",
    x1: 149.18,
    y1: 3.39193,
    x2: 148.929,
    y2: 3.64319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_7270_1548",
    x1: 143.815,
    y1: 4.38064,
    x2: 143.666,
    y2: 4.52974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_7270_1548",
    x1: 143.309,
    y1: 4.458,
    x2: 143.18,
    y2: 4.58729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_7270_1548",
    x1: 138.705,
    y1: 5.18154,
    x2: 138.634,
    y2: 5.25241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_7270_1548",
    x1: 137.941,
    y1: 5.43025,
    x2: 137.569,
    y2: 5.80141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_7270_1548",
    x1: 134.772,
    y1: 7.42395,
    x2: 134.396,
    y2: 7.80031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_7270_1548",
    x1: 151.421,
    y1: 2.87503,
    x2: 151.368,
    y2: 2.9282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_7270_1548",
    x1: 151.742,
    y1: 1.96842,
    x2: 151.718,
    y2: 1.99239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_7270_1548",
    x1: 151.473,
    y1: 2.54453,
    x2: 151.447,
    y2: 2.57059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_7270_1548",
    x1: 151.574,
    y1: 2.26061,
    x2: 151.514,
    y2: 2.32108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_7270_1548",
    x1: 151.466,
    y1: 2.5796,
    x2: 151.422,
    y2: 2.62341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_7270_1548",
    x1: 151.508,
    y1: 2.49286,
    x2: 151.472,
    y2: 2.52831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_7270_1548",
    x1: 151.2,
    y1: 3.00075,
    x2: 151.176,
    y2: 3.02474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_7270_1548",
    x1: 151.209,
    y1: 2.88396,
    x2: 151.174,
    y2: 2.91938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_7270_1548",
    x1: 151.163,
    y1: 2.91182,
    x2: 151.032,
    y2: 3.04323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_7270_1548",
    x1: 151.376,
    y1: 1.8556,
    x2: 151.342,
    y2: 1.89002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_7270_1548",
    x1: 150.477,
    y1: 3.12007,
    x2: 150.45,
    y2: 3.14718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_7270_1548",
    x1: 150.373,
    y1: 3.09738,
    x2: 150.332,
    y2: 3.13803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_7270_1548",
    x1: 143.837,
    y1: 3.17558,
    x2: 143.778,
    y2: 3.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_7270_1548",
    x1: 143.104,
    y1: 2.72672,
    x2: 143.012,
    y2: 2.81948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_7270_1548",
    x1: 142.766,
    y1: 2.93217,
    x2: 142.686,
    y2: 3.01246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_7270_1548",
    x1: 142.635,
    y1: 2.9757,
    x2: 142.603,
    y2: 3.00801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_7270_1548",
    x1: 142.356,
    y1: 3.0427,
    x2: 142.319,
    y2: 3.08024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_7270_1548",
    x1: 142.261,
    y1: 3.11124,
    x2: 142.232,
    y2: 3.14043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_7270_1548",
    x1: 142.115,
    y1: 3.77697,
    x2: 142.078,
    y2: 3.81348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_7270_1548",
    x1: 142.27,
    y1: 3.68412,
    x2: 142.515,
    y2: 3.68412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_7270_1548",
    x1: 141.873,
    y1: 3.15815,
    x2: 141.765,
    y2: 3.26558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_7270_1548",
    x1: 141.921,
    y1: 3.79034,
    x2: 141.893,
    y2: 3.81848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_7270_1548",
    x1: 141.449,
    y1: 3.3049,
    x2: 141.416,
    y2: 3.33826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_7270_1548",
    x1: 141.154,
    y1: 3.43675,
    x2: 141.051,
    y2: 3.53997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_7270_1548",
    x1: 140.882,
    y1: 3.66309,
    x2: 140.796,
    y2: 3.74965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_7270_1548",
    x1: 140.703,
    y1: 3.55624,
    x2: 140.646,
    y2: 3.61356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_7270_1548",
    x1: 140.723,
    y1: 3.74242,
    x2: 140.669,
    y2: 3.79663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_7270_1548",
    x1: 140.659,
    y1: 3.84213,
    x2: 140.615,
    y2: 3.88594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_7270_1548",
    x1: 140.745,
    y1: 3.80914,
    x2: 140.577,
    y2: 3.97701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_7270_1548",
    x1: 140.703,
    y1: 4.42902,
    x2: 140.671,
    y2: 4.46136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_7270_1548",
    x1: 140.602,
    y1: 4.45403,
    x2: 140.546,
    y2: 4.51032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_7270_1548",
    x1: 140.364,
    y1: 3.74221,
    x2: 140.315,
    y2: 3.79121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_7270_1548",
    x1: 140.431,
    y1: 4.27631,
    x2: 140.387,
    y2: 4.32007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_7270_1548",
    x1: 140.282,
    y1: 3.70726,
    x2: 140.253,
    y2: 3.73647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_7270_1548",
    x1: 140.223,
    y1: 3.92638,
    x2: 140.177,
    y2: 3.97223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_7270_1548",
    x1: 140.273,
    y1: 4.61,
    x2: 140.241,
    y2: 4.64231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_7270_1548",
    x1: 140.232,
    y1: 4.57955,
    x2: 140.166,
    y2: 4.64524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_7270_1548",
    x1: 140.031,
    y1: 3.86292,
    x2: 140.002,
    y2: 3.89208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_7270_1548",
    x1: 139.982,
    y1: 4.01476,
    x2: 139.844,
    y2: 4.15238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_7270_1548",
    x1: 140.133,
    y1: 4.6256,
    x2: 140.103,
    y2: 4.65584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_7270_1548",
    x1: 139.723,
    y1: 3.97885,
    x2: 139.627,
    y2: 4.07478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_7270_1548",
    x1: 139.675,
    y1: 3.93173,
    x2: 139.636,
    y2: 3.97136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_7270_1548",
    x1: 139.715,
    y1: 4.13467,
    x2: 139.643,
    y2: 4.20661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_7270_1548",
    x1: 139.818,
    y1: 4.67649,
    x2: 139.732,
    y2: 4.76303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_7270_1548",
    x1: 139.628,
    y1: 4.1165,
    x2: 139.604,
    y2: 4.14047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_7270_1548",
    x1: 139.529,
    y1: 4.05468,
    x2: 139.466,
    y2: 4.11827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_7270_1548",
    x1: 139.589,
    y1: 4.31117,
    x2: 139.566,
    y2: 4.33411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_7270_1548",
    x1: 139.361,
    y1: 4.04061,
    x2: 139.31,
    y2: 4.0917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_7270_1548",
    x1: 139.535,
    y1: 4.8924,
    x2: 139.501,
    y2: 4.92575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_7270_1548",
    x1: 139.45,
    y1: 4.76596,
    x2: 139.344,
    y2: 4.87128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_7270_1548",
    x1: 139.19,
    y1: 4.40872,
    x2: 139.156,
    y2: 4.44313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_7270_1548",
    x1: 139.034,
    y1: 4.50764,
    x2: 139.009,
    y2: 4.53265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_7270_1548",
    x1: 139.005,
    y1: 5.17205,
    x2: 138.971,
    y2: 5.20645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_7270_1548",
    x1: 138.936,
    y1: 5.20358,
    x2: 138.888,
    y2: 5.25156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_7270_1548",
    x1: 138.307,
    y1: 4.56102,
    x2: 138.276,
    y2: 4.59125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_7270_1548",
    x1: 138.327,
    y1: 4.77323,
    x2: 138.313,
    y2: 4.78678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_7270_1548",
    x1: 138.055,
    y1: 4.65478,
    x2: 137.997,
    y2: 4.71318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_7270_1548",
    x1: 133.349,
    y1: 5.39157,
    x2: 151.95,
    y2: 5.39157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_7270_1548",
    x1: 151.182,
    y1: 2.86432,
    x2: 151.14,
    y2: 2.90604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_7270_1548",
    x1: 142.536,
    y1: 2.97494,
    x2: 142.454,
    y2: 3.0573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_7270_1548",
    x1: 142.482,
    y1: 3.04755,
    x2: 142.406,
    y2: 3.12361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_7270_1548",
    x1: 142.436,
    y1: 3.0454,
    x2: 142.329,
    y2: 3.15175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_7270_1548",
    x1: 142.027,
    y1: 3.1806,
    x2: 141.964,
    y2: 3.24418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_7270_1548",
    x1: 141.638,
    y1: 3.25938,
    x2: 141.435,
    y2: 3.46268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_7270_1548",
    x1: 141.362,
    y1: 3.38286,
    x2: 141.279,
    y2: 3.46627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_7270_1548",
    x1: 140.826,
    y1: 3.5383,
    x2: 140.696,
    y2: 3.66757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_7270_1548",
    x1: 140.703,
    y1: 3.78488,
    x2: 140.649,
    y2: 3.83806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_7270_1548",
    x1: 140.585,
    y1: 3.78539,
    x2: 140.38,
    y2: 3.99097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_7270_1548",
    x1: 140.644,
    y1: 3.61323,
    x2: 140.523,
    y2: 3.73418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_7270_1548",
    x1: 140.275,
    y1: 3.90508,
    x2: 140.082,
    y2: 4.09812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_7270_1548",
    x1: 140.165,
    y1: 3.81621,
    x2: 140.124,
    y2: 3.8569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_7270_1548",
    x1: 139.618,
    y1: 4.18343,
    x2: 139.541,
    y2: 4.2606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_7270_1548",
    x1: 138.678,
    y1: 5.33113,
    x2: 138.572,
    y2: 5.43749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_7270_1548",
    x1: 138.575,
    y1: 5.3389,
    x2: 138.538,
    y2: 5.37641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_7270_1548",
    x1: 151.449,
    y1: 2.70937,
    x2: 151.205,
    y2: 2.95332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_7270_1548",
    x1: 149.096,
    y1: 1.68303,
    x2: 149.077,
    y2: 1.70179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_7270_1548",
    x1: 149.245,
    y1: 0.322101,
    x2: 148.57,
    y2: 0.996648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_7270_1548",
    x1: 149.078,
    y1: 1.70874,
    x2: 149.009,
    y2: 1.77755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_7270_1548",
    x1: 150.359,
    y1: 0.306551,
    x2: 150.273,
    y2: 0.392057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_7270_1548",
    x1: 150.871,
    y1: 0.253024,
    x2: 150.845,
    y2: 0.279088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4136"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo-full.887f50279eaf436d71b2b1c96b91ba8d.svg";
export { ForwardRef as ReactComponent };